/* FSP designer v0.6: guided steps, help and plain-English checks; vector print files, shop fonts, templates, clipart, shapes, QR,
   smart checks, saved designs. Sandbox theme only. */
(function () {
  'use strict';
  var root = document.getElementById('fsp-designer');
  if (!root || !window.fabric || !window.PDFLib || !window.opentype) { return; }
  var PL = window.PDFLib;

  var VERSION = 'FSP designer v0.8';
  var PRODUCT = JSON.parse(document.getElementById('fsp-product-json').textContent);
  var BLEED = 0.125;        // inches each edge
  var SAFE = 0.25;          // inches inside the cut line
  var PREVIEW_DPI = 40;     // customer-facing preview jpgs
  var FALLBACK_DPI = 300;   // anything that can't be vector (photos, effects)
  var CUSTOM = ['fspType', 'fspFlip', 'fspData', 'fspFile', 'fspCurve', 'fspName'];   // our own object properties, kept in saved designs
  var ASSET = window.FSPD_ASSET_BASE || '';
  var CDN = 'https://cdnjs.cloudflare.com/ajax/libs/';
  // Dan 9 Oct: every file gets an invisible cut path on the trim (Separation /None: never prints). No CutContour color.
  // Fonts (Dan, 10 Oct): 18 open-licensed fonts from the shop PC + 22 of the most popular Google Fonts, all SIL OFL / Apache.
  // Screen: fsp-font-<slug>-<w>.woff (served as WOFF2 by Shopify). Print outlines: the same file as base64 text, .b64.js.
  var FONT_GROUPS = [
    ['Sans serif', ['Open Sans', 'Roboto', 'Montserrat', 'Inter', 'Poppins', 'Lato', 'Arimo', 'Raleway', 'Nunito', 'Manrope', 'Rubik', 'Quicksand', 'Plus Jakarta Sans', 'Work Sans', 'Figtree', 'Fira Sans', 'Glacial Indifference']],
    ['Bold & condensed', ['Oswald', 'Roboto Condensed', 'Bebas Neue', 'Anton', 'Archivo Black', 'Barlow Condensed', 'Fira Sans Condensed', 'Antonio', 'Hammersmith One', 'Black Ops One']],
    ['Serif', ['Playfair Display', 'Merriweather', 'Roboto Slab', 'Lora', 'Libre Baskerville', 'EB Garamond', 'Zilla Slab', 'Alfa Slab One']],
    ['Script & handwriting', ['Dancing Script', 'Caveat', 'Pacifico', 'Pinyon Script', 'Italianno']]
  ];
  var FONT_LABELS = { 'Arimo': 'Arimo (looks like Arial)' };
  var ONE_WEIGHT = { 'Bebas Neue': 1, 'Archivo Black': 1, 'Hammersmith One': 1, 'Pinyon Script': 1, 'Italianno': 1, 'Anton': 1, 'Black Ops One': 1, 'Alfa Slab One': 1, 'Pacifico': 1 };
  var DEFAULT_FONT = 'Montserrat';
  var FONTS = {};
  FONT_GROUPS.forEach(function (g) { g[1].forEach(function (f) { FONTS[f] = { weights: ONE_WEIGHT[f] ? [400] : [400, 700] }; }); });
  // Colors we print well (digital print on vinyl / Max Metal / coroplast). Custom colors are still allowed.
  var PALETTE = [
    ['Black', '#000000'], ['White', '#ffffff'], ['Charcoal', '#333f48'], ['Gray', '#97999b'],
    ['Navy', '#0c2340'], ['Blue', '#0057b8'], ['Sky blue', '#41b6e6'], ['Teal', '#00827f'],
    ['Dark green', '#154734'], ['Green', '#43b02a'], ['Yellow', '#ffd100'], ['Gold', '#b9975b'],
    ['Orange', '#ff6a13'], ['Red', '#c8102e'], ['Burgundy', '#6f263d'], ['Purple', '#5f259f'],
    ['Brown', '#5c4033'], ['Pink', '#e31c79']
  ];
  var OT = {}, LOADING = {}, OUTLINES = {}, SCRIPTS = {};
  var ORIGINALS = {};       // fspFile id -> File the customer uploaded (attached to the order as-is)
  // New customer accounts: /customer_authentication/login?return_to=<path> brings the customer back to that page.
  function loginBase(u) { u = String(u || ''); return /customer_authentication/.test(u) ? '/customer_authentication/login' : (u || '/account/login'); }
  // Saved designs ("My saved designs"): our service, reached through the Shopify app proxy at /apps/fsp.
  var SAVE = { on: window.FSPD_SAVE !== false, proxy: '/apps/fsp', login: loginBase(window.FSPD_LOGIN_URL), sess: null, saved: null, links: {}, srcMap: {}, pending: null, busy: false, dirty: false };
  var $ = function (id) { return document.getElementById(id); };
  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) { e.className = cls; } if (html != null) { e.innerHTML = html; } return e; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  var TAGS = (PRODUCT.tags || []).map(function (t) { return String(t).toLowerCase(); });
  var TWO_SIDED = TAGS.indexOf('single-sided') < 0;
  // Product profiles: what kind of thing is being designed. Chosen from the product's handle and tags
  // (or window.FSPD_KIND for tests). Each profile sets the margins, sides, colors, designs and order details.
  var HANDLE = String(PRODUCT.handle || '');
  var KIND = window.FSPD_KIND || (TAGS.indexOf('banner') >= 0 ? 'banner'
    : (/^a-frame/.test(HANDLE) || TAGS.indexOf('a-frame') >= 0) ? 'aframe'
    : HANDLE === 'request-a-custom-quote' ? 'cnc'
    : HANDLE === 'sublimated-aluminum-plate' ? 'plate'
    : HANDLE === 'cast-address-plaque' ? 'plaque'
    : (TAGS.indexOf('engraved') >= 0 || /engraved|nameplate/.test(HANDLE)) ? 'engrave'
    : 'sign');
  // Two-ply engraving stock (1/16"): engraving cuts through the face color to show the core color (Dan's six schemes).
  var TWO_PLY = [
    { label: 'Black letters on white', ink: '#000000', face: '#ffffff' },
    { label: 'White letters on black', ink: '#ffffff', face: '#111111' },
    { label: 'White letters on red', ink: '#ffffff', face: '#c8102e' },
    { label: 'Black letters on brushed gold', ink: '#000000', face: '#c9a74a' },
    { label: 'Black letters on brushed silver', ink: '#000000', face: '#bfc3c7' },
    { label: 'White letters on green', ink: '#ffffff', face: '#154734' }
  ];
  var SCHEMES = HANDLE === 'engraved-brass-nameplate' ? [{ label: 'Black fill on satin brass', ink: '#000000', face: '#c9a74a' }]
    : HANDLE === 'screen-printed-aluminum-nameplate' ? [{ label: 'Black ink on satin aluminum', ink: '#000000', face: '#bfc3c7' }]
    : KIND === 'plaque' ? [{ label: 'Raised silver letters on black', ink: '#c9ccd0', face: '#1f1f1f', match: /aluminum/i }, { label: 'Raised bronze letters on dark brown', ink: '#b08d57', face: '#3b2a1a', match: /bronze/i }]
    : TWO_PLY;
  // CNC router materials (from the plastics we sell). Preview color only; the cut file is the shapes' outlines.
  var MATERIALS = [
    ['Clear acrylic 1/16"', '#cfe6f2', 'clear-acrylic-1-16'], ['Clear acrylic 1/8"', '#cfe6f2', 'clear-acrylic-1-8'], ['Clear acrylic 3/16"', '#cfe6f2', 'clear-acrylic-3-16'],
    ['Clear acrylic 1/4"', '#cfe6f2', 'clear-acrylic-1-4'], ['Clear acrylic 1/2"', '#cfe6f2', 'clear-acrylic-1-2'], ['White acrylic 1/8"', '#ffffff', 'white-acrylic-1-8'],
    ['Black acrylic 3/8"', '#1a1a1a', 'black-acrylic-3-8'], ['Black acrylic 1/2"', '#1a1a1a', 'black-acrylic-1-2'], ['Mirror acrylic', '#c0c4c8', 'mirror-acrylic-sheet'],
    ['Marine board (StarBoard) white 1/4"', '#f4f4f2', 'marine-board-hdpe'], ['Marine board (StarBoard) white 1/2"', '#f4f4f2', ''], ['Marine board (StarBoard) white 3/4"', '#f4f4f2', ''],
    ['Marine board (StarBoard) black 1/4"', '#1a1a1a', ''], ['Marine board (StarBoard) black 1/2"', '#1a1a1a', ''], ['Marine board (StarBoard) black 3/4"', '#1a1a1a', ''],
    ['Other / not sure (tell us in the notes)', '#9aa4b2', '']
  ];
  var PROFILES = {
    sign: { noun: 'sign', safe: SAFE, bleed: BLEED, oneSided: false, minDpi: 100, hideCats: [], firstCats: [] },
    banner: { noun: 'banner', safe: 1.5, bleed: BLEED, oneSided: true, minDpi: 50, hideCats: ['Riders'], firstCats: ['Business', 'Events'] },
    aframe: { noun: 'panel', safe: 0.25, bleed: BLEED, oneSided: false, minDpi: 100, hideCats: ['Riders', 'Nameplates', 'Plaques', 'CNC letters & shapes'], firstCats: ['Business', 'Real estate', 'Events'],
      variantOk: function (v) { return /panel/i.test(v.title); }, dims: 'Each panel (one on each side of the frame): ' },
    engrave: { noun: 'plate', safe: 0.08, bleed: 0, oneSided: true, mono: true, minDpi: 150, onlyCats: ['Nameplates'], minTextIn: 0.125, noPhotos: true },
    plate: { noun: 'plate', safe: 0.08, bleed: 0.0625, oneSided: true, minDpi: 150, onlyCats: ['Nameplates'], minTextIn: 0.1 },
    plaque: { noun: 'plaque', safe: 0.5, bleed: 0, oneSided: true, mono: true, minDpi: 150, onlyCats: ['Plaques'], minTextIn: 0.5, noPhotos: true, noQr: true },
    cnc: { noun: 'design', safe: 0, bleed: 0, oneSided: true, mono: true, custom: true, minDpi: 150, onlyCats: ['CNC letters & shapes'], minTextIn: 1, noPhotos: true, noQr: true, quote: true,
      dims: 'Work area (your cut pieces fit inside this): ' }
  };
  var PROFILE = PROFILES[KIND] || PROFILES.sign;
  PROFILE.hideCats = PROFILE.hideCats || []; PROFILE.firstCats = PROFILE.firstCats || [];
  if (KIND !== 'cnc') { PROFILE.hideCats.push('CNC letters & shapes'); }
  if (['engrave', 'plate', 'plaque', 'cnc'].indexOf(KIND) < 0) { PROFILE.hideCats.push('Nameplates', 'Plaques'); }
  var IS_BANNER = KIND === 'banner';
  if (PROFILE.oneSided) { TWO_SIDED = false; }
  SAFE = PROFILE.safe; BLEED = PROFILE.bleed;
  // One-color products (engraving, cast plaques, CNC cut pieces): every item takes the letter color, the background is the material.
  var MONO = { on: !!PROFILE.mono, scheme: SCHEMES[0], material: MATERIALS[3] };
  function monoInk() { return KIND === 'cnc' ? (MONO.material[1] === '#ffffff' || MONO.material[1] === '#f4f4f2' ? '#e9ecef' : MONO.material[1]) : MONO.scheme.ink; }
  function monoFace() { return KIND === 'cnc' ? '#5b6573' : MONO.scheme.face; }
  var CUSTOM_SIZE = { w: 36, h: 12 };   // CNC work area, inches (router bed is 4' x 8')
  var NOUN_CAP = PROFILE.noun.charAt(0).toUpperCase() + PROFILE.noun.slice(1);
  var PDF_MAX_IN = 199;     // Acrobat and many RIPs refuse PDF pages over 200 in; bigger jobs are built at half scale

  var state = {
    variant: null,
    trimW: 0, trimH: 0,     // finished size, inches
    W: 0, H: 0,             // with bleed, inches
    ppi: 1, wpx: 0, hpx: 0,
    current: 0,
    sides: [null, null],    // {json, ppi, wpx, hpx}
    hist: [{ stack: [], idx: -1 }, { stack: [], idx: -1 }],
    loading: 0
  };

  // Fabric 5.3 restores a text's curve path only for plain Text; do the same for IText (saved designs, undo, duplicate).
  if (!fabric.IText.__fspCurveFix) {
    var itFrom = fabric.IText.fromObject;
    fabric.IText.fromObject = function (object, callback) {
      if (!object.path || object.path instanceof fabric.Path) { return itFrom.call(fabric.IText, object, callback); }
      var copy = fabric.util.object.clone(object), pathObj = object.path; delete copy.path;
      return itFrom.call(fabric.IText, copy, function (t) {
        fabric.Path.fromObject(pathObj, function (p) { t.set('path', p); t.initDimensions(); t.setCoords(); callback && callback(t); });
      });
    };
    fabric.IText.__fspCurveFix = true;
  }

  // Big, easy-to-grab handles (older customers, touch screens). Screen only: none of this is saved or printed.
  fabric.Object.prototype.set({ cornerSize: 16, touchCornerSize: 34, transparentCorners: false, cornerStyle: 'circle', cornerColor: '#ffffff', cornerStrokeColor: '#1d4f86', borderColor: '#1d4f86', borderScaleFactor: 2, padding: 4 });
  var canvas = new fabric.Canvas('fspd-canvas', { backgroundColor: '#ffffff', preserveObjectStacking: true });

  function loadScript(url) {
    if (SCRIPTS[url]) { return SCRIPTS[url]; }
    SCRIPTS[url] = new Promise(function (res, rej) {
      var s = document.createElement('script'); s.src = url; s.async = true;
      s.onload = function () { res(); }; s.onerror = function () { delete SCRIPTS[url]; rej(new Error('could not load ' + url.split('/').pop())); };
      document.head.appendChild(s);
    });
    return SCRIPTS[url];
  }

  /* ---------- fonts: one file feeds both the screen and the print outlines ---------- */
  function fontSlug(fam) { return fam.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, ''); }
  function fontUrl(fam, w) { return ASSET + 'fsp-font-' + fontSlug(fam) + '-' + w + '.woff'; }
  function ensureFont(fam) {
    if (!FONTS[fam]) { fam = DEFAULT_FONT; }
    if (LOADING[fam]) { return LOADING[fam]; }
    LOADING[fam] = Promise.all(FONTS[fam].weights.map(function (w) {
      var ff = new FontFace(fam, 'url("' + fontUrl(fam, w) + '")', { weight: String(w), style: 'normal' });
      return ff.load().then(function (f) { document.fonts.add(f); });
    })).catch(function () { delete LOADING[fam]; throw new Error('font ' + fam + ' did not load'); });
    return LOADING[fam];
  }
  function ensureOutlines(fam) {
    if (!FONTS[fam]) { fam = DEFAULT_FONT; }
    if (OUTLINES[fam]) { return OUTLINES[fam]; }
    OUTLINES[fam] = Promise.all(FONTS[fam].weights.map(function (w) {
      return fetch(ASSET + 'fsp-font-' + fontSlug(fam) + '-' + w + '.b64.js').then(function (r) {
        if (!r.ok) { throw new Error('outlines ' + fam + ' ' + w + ' HTTP ' + r.status); }
        return r.text();
      }).then(function (t) {
        var bin = atob(t.replace(/[^A-Za-z0-9+\/=]/g, '')), u = new Uint8Array(bin.length);
        for (var k = 0; k < bin.length; k++) { u[k] = bin.charCodeAt(k); }
        OT[fam + '|' + w] = opentype.parse(u.buffer);
      });
    })).catch(function (e) { delete OUTLINES[fam]; throw e; });
    return OUTLINES[fam];
  }
  // every one of our font families used by a list of objects (fabric objects or saved JSON)
  function fontsIn(objs, set) {
    set = set || {};
    (objs || []).forEach(function walk(o) { if (o.fontFamily && FONTS[o.fontFamily]) { set[o.fontFamily] = 1; } (o.objects || o._objects || []).forEach(walk); });
    return set;
  }
  function ensureFonts(set) { return Promise.all(Object.keys(set).map(function (f) { return Promise.all([ensureFont(f), ensureOutlines(f)]); })); }
  function ensureScreenFonts(set) { return Promise.all(Object.keys(set).map(ensureFont)); }
  function weightOf(o) {
    var fam = FONTS[o.fontFamily] ? o.fontFamily : DEFAULT_FONT;
    var w = (o.fontWeight === 'bold' || Number(o.fontWeight) >= 600) ? 700 : 400;
    return FONTS[fam].weights.indexOf(w) >= 0 ? w : 400;
  }
  function otFont(o) { return FONTS[o.fontFamily] ? OT[o.fontFamily + '|' + weightOf(o)] : null; }

  /* ---------- product options and sizes ---------- */
  var SIZE_RE = /(\d+(?:\.\d+)?)\s*"?\s*W\s*x\s*(\d+(?:\.\d+)?)\s*"?\s*H/i;
  function parseSize(title) {
    var m = SIZE_RE.exec(title || '');
    return m ? { w: parseFloat(m[1]), h: parseFloat(m[2]) } : null;
  }
  function money(cents) { return '$' + (cents / 100).toFixed(2); }
  // Size of what's being designed: from the variant ("24"W x 18"H"), else from the product title (A-frame, tags), else the CNC work area.
  function sizeOf(v) {
    if (PROFILE.custom && PRODUCT === MAIN_PRODUCT) { return { w: CUSTOM_SIZE.w, h: CUSTOM_SIZE.h }; }
    return parseSize(v && v.title) || (PRODUCT === MAIN_PRODUCT ? parseSize(PRODUCT.title) : null);
  }
  // "24"W x 18"H / None" -> "24"W x 18"H" (names, My saved designs)
  function variantLabel(v) { return String(v && v.title || '').split(' / ').filter(function (x) { return !/^(none|no|default title|default)$/i.test(x.trim()); }).join(' / ') || String(v && v.title || ''); }
  var MAIN_PRODUCT = PRODUCT;
  var VARIANTS = PRODUCT.variants.filter(function (v) { return sizeOf(v) && (!PROFILE.variantOk || PROFILE.variantOk(v)); });
  var OPTION_NAMES = (PRODUCT.options || []).map(function (o) { return typeof o === 'string' ? o : o.name; });
  function optVal(v, i) { return v['option' + (i + 1)] != null ? v['option' + (i + 1)] : (v.options ? v.options[i] : null); }
  var SIZE_OPT = -1;
  OPTION_NAMES.forEach(function (n, i) { if (SIZE_OPT < 0 && VARIANTS.length && VARIANTS.every(function (v) { return parseSize(optVal(v, i)); })) { SIZE_OPT = i; } });
  var OPT_SELECTS = [];
  function buildOptionSelects() {
    var box = $('fspd-options'); box.innerHTML = '';
    if (PROFILE.custom) { buildCustomSize(box); OPT_SELECTS = null; return; }
    if (SIZE_OPT < 0 || OPTION_NAMES.length < 2) {
      // one size list straight from the variant titles
      var s = el('select'); s.id = 'fspd-size';
      var titled = !VARIANTS.some(function (v) { return parseSize(v.title); });   // e.g. "Standard Corners": the size comes from the product
      VARIANTS.forEach(function (v) {
        var o = el('option'); o.value = v.id; o.textContent = v.title + ' — ' + money(v.price) + (v.available ? '' : ' (sold out)');
        if (!v.available) { o.disabled = true; }
        s.appendChild(o);
      });
      var l = el('label', 'fspd-field'); l.appendChild(document.createTextNode((titled && OPTION_NAMES[0] && !/^title$/i.test(OPTION_NAMES[0]) ? OPTION_NAMES[0] : NOUN_CAP + ' size') + ' ')); l.appendChild(s); box.appendChild(l);
      s.addEventListener('change', function () { setSize(s.value); });
      OPT_SELECTS = null;
      return;
    }
    OPT_SELECTS = OPTION_NAMES.map(function (name, i) {
      var vals = [];
      VARIANTS.forEach(function (v) { var x = optVal(v, i); if (vals.indexOf(x) < 0) { vals.push(x); } });
      var s = el('select'); if (i === SIZE_OPT) { s.id = 'fspd-size'; }
      vals.forEach(function (x) { var o = el('option'); o.value = x; o.textContent = x; s.appendChild(o); });
      var shown = i === SIZE_OPT ? NOUN_CAP + ' size' : name + (vals.some(function (x) { return /^none$/i.test(x); }) ? ' (optional)' : '');
      var l = el('label', 'fspd-field'); l.appendChild(document.createTextNode(shown + ' ')); l.appendChild(s); box.appendChild(l);
      s.addEventListener('change', function () { pickFromOptions(i); });
      return s;
    });
  }
  function pickFromOptions(changed) {
    var want = OPT_SELECTS.map(function (s) { return s.value; });
    var match = function (v) { return want.every(function (x, i) { return optVal(v, i) === x; }); };
    var v = VARIANTS.filter(match)[0];
    if (!v) {   // that combination doesn't exist: keep the changed option, take the first variant that has it
      v = VARIANTS.filter(function (x) { return optVal(x, changed) === want[changed]; })[0];
    }
    setSize(v.id);
  }
  function syncOptionSelects(v) {
    if (PROFILE.custom) { return; }
    if (!OPT_SELECTS) { $('fspd-size').value = v.id; return; }
    OPT_SELECTS.forEach(function (s, i) {
      s.value = optVal(v, i);
      Array.prototype.forEach.call(s.options, function (o) {
        // grey out values that don't exist with the chosen size
        if (i === SIZE_OPT) { o.disabled = false; return; }
        o.disabled = !VARIANTS.some(function (x) { return optVal(x, i) === o.value && optVal(x, SIZE_OPT) === optVal(v, SIZE_OPT); });
      });
    });
  }

  var fsel = $('fspd-font');
  fsel.innerHTML = '';
  FONT_GROUPS.forEach(function (g) {
    var og = el('optgroup'); og.label = g[0];
    g[1].forEach(function (f) { var op = el('option'); op.value = f; op.textContent = FONT_LABELS[f] || f; og.appendChild(op); });
    fsel.appendChild(og);
  });
  fsel.value = DEFAULT_FONT;

  function stageMaxWidth() {
    var col = root.querySelector('.fspd-stage-col');
    return Math.max(260, Math.min(900, col.clientWidth - 4));
  }

  function setSize(variantId, noSave) {
    // the size and add-on menus belong to the sign: if the rider is on screen, go back to the sign first
    if (window.FSPD && FSPD.leaveRiderNow) { noSave = FSPD.leaveRiderNow() || noSave; }
    var v = VARIANTS.filter(function (x) { return String(x.id) === String(variantId); })[0] || VARIANTS[0];
    if (!noSave) { saveCurrent(); }
    state.variant = v;
    syncOptionSelects(v);
    layoutCanvas();
    var priceTxt = PROFILE.quote ? 'Free quote. We price your design and email you.' : money(v.price) + ' each' + (v.available ? '' : ' (sold out)');
    $('fspd-price').textContent = priceTxt;
    if ($('fspd-price-top')) { $('fspd-price-top').textContent = priceTxt; }
    if (MONO.on && KIND === 'plaque') { var sm = SCHEMES.filter(function (x) { return x.match && x.match.test(v.title); })[0]; if (sm && sm !== MONO.scheme) { MONO.scheme = sm; syncModeUI(); } }
    qtyTierSync(v);
    $('fspd-cart').disabled = !v.available;
    loadSideIntoEditor(state.current, function () { if (window.FSPD && FSPD.onSide) { FSPD.onSide(); } });
    renderTemplates();
    if (window.FSPD && FSPD.riderSync) { FSPD.riderSync(); }
  }
  // Size the editor for whatever is being designed now (the sign, or the rider that goes in its frame).
  function layoutCanvas() {
    var s = sizeOf(state.variant);
    state.trimW = s.w; state.trimH = s.h;
    state.W = s.w + 2 * BLEED; state.H = s.h + 2 * BLEED;
    var maxW = stageMaxWidth(), maxH = window.innerWidth < 700 ? 360 : Math.max(300, Math.min(480, window.innerHeight - 330));
    // whole-number pixels per 1/4 inch, so the canvas is exactly proportional to the sign (no rounding stretch)
    var rawPpi = Math.min(maxW / state.W, maxH / state.H);
    state.ppi = rawPpi >= 4 ? Math.floor(rawPpi / 4) * 4 : rawPpi;
    state.wpx = Math.round(state.W * state.ppi);
    state.hpx = Math.round(state.H * state.ppi);
    canvas.setWidth(state.wpx); canvas.setHeight(state.hpx);
    var stage = $('fspd-stage');
    stage.style.width = state.wpx + 'px'; stage.style.height = state.hpx + 'px';
    placeGuide($('fspd-trim'), BLEED);
    placeGuide($('fspd-safe'), BLEED + SAFE);
    $('fspd-dims').textContent = (window.FSPD && FSPD.surface && FSPD.surface() === 'rider' ? 'Your rider: ' : (PROFILE.dims || 'Your ' + PROFILE.noun + ': ')) + s.w + '" wide × ' + s.h + '" tall';
  }
  function placeGuide(g, inset) {
    var p = inset * state.ppi;
    g.style.left = p + 'px'; g.style.top = p + 'px';
    g.style.width = (state.wpx - 2 * p) + 'px'; g.style.height = (state.hpx - 2 * p) + 'px';
  }
  function aspectClass(w, h) { var r = w / h; return r >= 2.5 ? 'wide' : r >= 1.15 ? 'land' : r > 0.87 ? 'square' : 'tall'; }

  /* ---------- sides, history, autosave ---------- */
  function snapshot(c) { return { json: c.toJSON(CUSTOM), ppi: state.ppi, wpx: c.getWidth(), hpx: c.getHeight() }; }
  function saveCurrent() { if (!state.wpx || state.loading) { return; } state.sides[state.current] = snapshot(canvas); }
  // Load a stored side into any fabric canvas, re-fitting it to the current size.
  function loadSide(target, side, done) {
    var isEditor = target === canvas;
    if (isEditor) { state.loading++; }
    var finish = function () { if (isEditor) { state.loading--; } done && done(); };
    if (!side) { target.clear(); target.backgroundColor = MONO.on ? monoFace() : '#ffffff'; target.renderAll(); finish(); return; }
    ensureScreenFonts(fontsIn(side.json.objects)).catch(function () {}).then(function () {
      target.loadFromJSON(side.json, function () {
        var f = state.ppi / side.ppi;
        var fx = target.getWidth() / side.wpx, fy = target.getHeight() / side.hpx;
        target.getObjects().forEach(function (o) {
          if (isText(o)) { o.initDimensions(); }
          if (Math.abs(f - 1) > 1e-6 || Math.abs(fx - 1) > 1e-6 || Math.abs(fy - 1) > 1e-6) {
            var c = o.getCenterPoint();
            o.scaleX *= f; o.scaleY *= f;
            o.setPositionByOrigin(new fabric.Point(c.x * fx, c.y * fy), 'center', 'center');
          }
          o.setCoords();
        });
        target.renderAll();
        finish();
      });
    });
  }
  function loadSideIntoEditor(i, done) {
    loadSide(canvas, state.sides[i], function () {
      setSwatchValue('bg', toHex(canvas.backgroundColor || '#ffffff'));
      checkSafe(); syncProps();
      var h = state.hist[i];
      if (h.idx < 0) { h.stack = [JSON.stringify(snapshot(canvas))]; h.idx = 0; }
      updateUndo();
      done && done();
    });
  }
  function switchSide(i) {
    if (typeof SURF !== 'undefined' && SURF === 'rider') { toSurface('sign', i); return; }
    switchSideCore(i);
  }
  function switchSideCore(i) {
    if (i === state.current) { return; }
    saveCurrent();
    state.current = i;
    root.querySelectorAll('.fspd-tab[data-side]').forEach(function (b) { var on = Number(b.dataset.side) === i; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    loadSideIntoEditor(i, function () { if (window.FSPD && FSPD.onSide) { FSPD.onSide(); } });
  }
  var commitTimer;
  function commit() {
    if (state.loading) { return; }
    clearTimeout(commitTimer);
    commitTimer = setTimeout(function () {
      if (state.loading) { return; }
      saveCurrent();
      var h = state.hist[state.current], s = JSON.stringify(state.sides[state.current]);
      if (h.stack[h.idx] !== s) {
        h.stack = h.stack.slice(0, h.idx + 1); h.stack.push(s);
        if (h.stack.length > 60) { h.stack.shift(); }
        h.idx = h.stack.length - 1;
      }
      if (SAVE.saved) { SAVE.dirty = true; }
      updateUndo(); autosave(); checkSafe();
      if (window.FSPD && FSPD.renderWords) { FSPD.renderWords(false); }
    }, 200);
  }
  function undoRedo(step) {
    clearTimeout(commitTimer);
    var h = state.hist[state.current], j = h.idx + step;
    if (j < 0 || j >= h.stack.length) { return; }
    h.idx = j;
    state.sides[state.current] = JSON.parse(h.stack[j]);
    loadSide(canvas, state.sides[state.current], function () {
      setSwatchValue('bg', toHex(canvas.backgroundColor || '#ffffff'));
      checkSafe(); syncProps(); updateUndo(); autosave();
      if (window.FSPD && FSPD.renderWords) { FSPD.renderWords(true); }
    });
  }
  function updateUndo() {
    var h = state.hist[state.current];
    $('fspd-undo').disabled = h.idx <= 0; $('fspd-redo').disabled = h.idx >= h.stack.length - 1;
  }
  canvas.on('object:added', commit);
  canvas.on('object:removed', commit);
  canvas.on('object:modified', commit);
  canvas.on('text:changed', commit);

  var DRAFT_KEY = 'fspd:draft:' + PRODUCT.id;
  var saveTimer;
  function autosave() {
    clearTimeout(saveTimer);
    saveTimer = setTimeout(function () {
      try {
        var ss = signSides(), sv = signVariant(), rd = riderDraft();
        if (!sideHasContent(ss[0]) && !sideHasContent(ss[1]) && !(rd && sideHasContent(rd.sides[0]))) { localStorage.removeItem(DRAFT_KEY); return; }
        localStorage.setItem(DRAFT_KEY, JSON.stringify({ v: 4, ts: Date.now(), variant: sv && sv.id, sides: ss, saved: SAVE.saved, links: SAVE.links, dirty: SAVE.dirty, rider: rd, mode: modeState() }));
      } catch (e) { /* storage full or blocked: drafts are a convenience only */ }
    }, 600);
  }
  function readDraft() {
    try {
      var d = JSON.parse(localStorage.getItem(DRAFT_KEY) || 'null');
      if (d && d.v === 4 && Date.now() - d.ts < 30 * 864e5) { return d; }
    } catch (e) { }
    return null;
  }
  function startOver() {
    leaveRiderNow();
    if (CTX.rider) { CTX.rider.sides = [null, null]; CTX.rider.hist = newHist(); }
    RIDER.backCustom = false;
    state.sides = [null, null];
    state.hist = [{ stack: [], idx: -1 }, { stack: [], idx: -1 }];
    try { localStorage.removeItem(DRAFT_KEY); } catch (e) { }
    $('fspd-draft').hidden = true;
    setSaved(null, {}); SAVE.dirty = false;
    state.current = -1; switchSide(0);
    status('Started a new design.');
  }

  function copyFront(mirror) {
    saveCurrent();
    var front = state.sides[0];
    if (!sideHasContent(front)) { status('Design the front first, then copy it.', true); return; }
    var tmp = new fabric.StaticCanvas(null, { width: state.wpx, height: state.hpx });
    loadSide(tmp, front, function () {
      if (mirror) {
        tmp.getObjects().forEach(function (o) {
          var c = o.getCenterPoint();
          o.setPositionByOrigin(new fabric.Point(state.wpx - c.x, c.y), 'center', 'center');
          if (shouldFlip(o)) { o.flipX = !o.flipX; }   // arrows and shapes flip; text, logos, clipart and QR codes stay readable
          o.setCoords();
        });
      }
      state.sides[1] = JSON.parse(JSON.stringify(snapshot(tmp)));
      tmp.dispose();
      state.current = -1;            // force reload
      switchSide(1);
      setTimeout(commit, 50);
      status(mirror ? 'Back side created as a mirror of the front. Arrows and shapes are flipped; text, logos and QR codes stay readable.' : 'Front copied to the back.');
    });
  }
  function shouldFlip(o) {
    if (o.fspFlip != null) { return !!o.fspFlip; }
    return !isText(o) && o.type !== 'image' && o.type !== 'group';
  }

  /* ---------- color swatches ---------- */
  var SWATCH = {};
  function buildSwatches(key, box, onPick, allowNone) {
    box.innerHTML = '';
    if (allowNone) {
      var nb = el('button', 'fspd-sw fspd-sw-none'); nb.type = 'button'; nb.title = 'None'; nb.dataset.c = 'none';
      nb.addEventListener('click', function () { setSwatchValue(key, 'none'); onPick('none'); });
      box.appendChild(nb);
    }
    PALETTE.forEach(function (p) {
      var b = el('button', 'fspd-sw'); b.type = 'button'; b.title = p[0]; b.dataset.c = p[1]; b.style.background = p[1];
      b.addEventListener('click', function () { setSwatchValue(key, p[1]); onPick(p[1]); });
      box.appendChild(b);
    });
    var lab = el('label', 'fspd-sw fspd-sw-custom'); lab.title = 'Custom color';
    var inp = el('input'); inp.type = 'color'; inp.value = '#000000';
    inp.addEventListener('input', function () { setSwatchValue(key, inp.value); onPick(inp.value); });
    lab.appendChild(inp); box.appendChild(lab);
    SWATCH[key] = { box: box, input: inp };
  }
  function setSwatchValue(key, c) {
    var s = SWATCH[key]; if (!s) { return; }
    c = (c || '').toLowerCase();
    Array.prototype.forEach.call(s.box.querySelectorAll('.fspd-sw'), function (b) { b.classList.toggle('is-on', b.dataset.c === c); });
    if (c && c !== 'none' && c.charAt(0) === '#') { s.input.value = c.length === 4 ? toHex(c) : c; }
  }
  function currentColor(key) { var s = SWATCH[key], on = s && s.box.querySelector('.is-on'); return on ? on.dataset.c : (s ? s.input.value : '#000000'); }

  /* ---------- tools ---------- */
  function isText(o) { return o && (o.type === 'i-text' || o.type === 'text' || o.type === 'textbox'); }
  function addObj(o, keepPos) {
    canvas.add(o);
    if (!keepPos) { o.setPositionByOrigin(new fabric.Point(state.wpx / 2, state.hpx / 2), 'center', 'center'); }
    o.setCoords(); canvas.setActiveObject(o); canvas.requestRenderAll(); checkSafe(); syncProps(); commit();
  }
  function newText(txt, font, opts) {
    return ensureFont(font).then(function () {
      var t = new fabric.IText(txt, Object.assign({
        fontFamily: font, fontSize: 40, fill: '#000000', textAlign: 'center', lineHeight: 1.05,
        fontWeight: FONTS[font].weights.indexOf(700) >= 0 ? '700' : 'normal', strokeLineJoin: 'round', paintFirst: 'stroke'
      }, opts || {}));
      return t;
    });
  }
  function addText() {
    var txt = $('fspd-text').value.replace(/\s+$/, '') || 'Your text';
    var font = FONTS[$('fspd-font').value] ? $('fspd-font').value : DEFAULT_FONT;
    var lines = txt.split('\n').length;
    var size = Math.min(state.trimH * 0.35 / Math.max(1, lines * 0.9), 2.5) * state.ppi;
    status('Loading ' + font + '…');
    newText(txt, font, { fontSize: size, fill: currentColor('fill') === 'none' ? '#000000' : currentColor('fill') }).then(function (t) {
      var maxW = (state.trimW - 2 * SAFE) * state.ppi;
      if (t.getScaledWidth() > maxW) { t.set('fontSize', t.fontSize * maxW / t.getScaledWidth()); t.initDimensions(); }
      addObj(t);
      $('fspd-text').value = '';
      status('');
    }, function (e) { status('That font didn’t load (' + e.message + '). Please try again.', true); });
  }

  // Shapes: all built as absolute-coordinate paths or basic shapes, so they print as vector.
  var SHAPES = {
    'arrow': { label: '➜ Arrow', flip: true, d: 'M 0 25 L 70 25 L 70 0 L 120 45 L 70 90 L 70 65 L 0 65 Z' },
    'arrow-double': { label: '⇔ Double arrow', flip: true, d: 'M 0 45 L 40 0 L 40 25 L 120 25 L 120 0 L 160 45 L 120 90 L 120 65 L 40 65 L 40 90 Z' },
    'arrow-bend': { label: '↱ Turn arrow', flip: true, d: 'M 0 120 L 0 50 Q 0 20 30 20 L 80 20 L 80 0 L 120 35 L 80 70 L 80 50 L 36 50 Q 30 50 30 56 L 30 120 Z' },
    'chevron': { label: '› Chevron', flip: true, d: 'M 0 0 L 40 0 L 85 50 L 40 100 L 0 100 L 45 50 Z' },
    'circle': { label: '● Circle' },
    'rect': { label: '■ Box' },
    'round-rect': { label: '▢ Rounded box' },
    'border': { label: '▭ Border' },
    'line': { label: '― Line' },
    'triangle': { label: '▲ Triangle', d: 'M 50 0 L 100 87 L 0 87 Z' },
    'star': { label: '★ Star' },
    'burst': { label: '✸ Burst' },
    'banner': { label: '🎗 Banner', d: 'M 0 10 L 30 10 L 30 0 L 170 0 L 170 10 L 200 10 L 188 30 L 200 50 L 170 50 L 170 60 L 30 60 L 30 50 L 0 50 L 12 30 Z' }
  };
  function starPoints(n, rOut, rIn) {
    var pts = [];
    for (var i = 0; i < n * 2; i++) {
      var r = i % 2 ? rIn : rOut, a = Math.PI * i / n - Math.PI / 2;
      pts.push({ x: Math.round((r * Math.cos(a) + rOut) * 100) / 100, y: Math.round((r * Math.sin(a) + rOut) * 100) / 100 });
    }
    return pts;
  }
  function addShape(kind) {
    var c = currentColor('fill'); if (c === 'none') { c = '#000000'; }
    var sh = SHAPES[kind], o, ppi = state.ppi, tw = state.trimW, th = state.trimH;
    var size = Math.min(tw, th) * 0.4 * ppi;
    if (kind === 'circle') { o = new fabric.Circle({ radius: size / 2, fill: c }); }
    else if (kind === 'rect') { o = new fabric.Rect({ width: tw * 0.3 * ppi, height: th * 0.3 * ppi, fill: c }); }
    else if (kind === 'round-rect') { o = new fabric.Rect({ width: tw * 0.3 * ppi, height: th * 0.3 * ppi, rx: size * 0.12, ry: size * 0.12, fill: c }); }
    else if (kind === 'border') {
      var sw = Math.max(0.15, Math.min(tw, th) * 0.02) * ppi;
      o = new fabric.Rect({ width: (tw - 2 * SAFE) * ppi - sw, height: (th - 2 * SAFE) * ppi - sw, fill: 'transparent', stroke: c, strokeWidth: sw, rx: sw, ry: sw, fspType: 'border' });
    }
    else if (kind === 'line') { o = new fabric.Line([0, 0, tw * 0.5 * ppi, 0], { stroke: c, strokeWidth: Math.max(0.08, th * 0.02) * ppi, strokeLineCap: 'round', fspType: 'line' }); }
    else if (kind === 'star') { o = new fabric.Polygon(starPoints(5, 50, 20), { fill: c }); }
    else if (kind === 'burst') { o = new fabric.Polygon(starPoints(16, 50, 40), { fill: c }); }
    else { o = new fabric.Path(sh.d, { fill: c }); }
    if (sh.flip) { o.fspFlip = true; o.fspType = 'arrow'; }
    if (kind !== 'rect' && kind !== 'round-rect' && kind !== 'border' && kind !== 'line') {
      if (o.width / o.height > tw / th) { o.scaleToWidth(Math.min(tw * 0.35, th * 0.8 * o.width / o.height) * ppi); }
      else { o.scaleToHeight(Math.min(th * 0.45, tw * 0.5 * o.height / o.width) * ppi); }
    }
    o.fspName = sh.label.replace(/^\S+\s/, '');
    addObj(o);
  }

  // Clipart (Phosphor Icons, MIT) loads only when the panel is opened.
  var CLIP = null;
  function loadClipart() {
    if (CLIP) { return Promise.resolve(CLIP); }
    return loadScript(ASSET + 'fsp-clipart.js').then(function () {
      CLIP = { vb: window.FSPD_CLIPART.vb, byId: {}, cats: window.FSPD_CLIPART.cats };
      CLIP.cats.forEach(function (c) { c.items.forEach(function (it) { CLIP.byId[it[0]] = it; }); });
      return CLIP;
    });
  }
  function clipPath(id, color) {
    var it = CLIP.byId[id]; if (!it) { return null; }
    var p = new fabric.Path(it[2], { fill: color || '#000000', fspType: 'clipart', fspData: id, fspName: it[1], fspFlip: !!it[3] });
    return p;
  }
  function renderClipart(filter) {
    var grid = $('fspd-clip-grid'), sel = $('fspd-clip-cat');
    loadClipart().then(function (C) {
      if (!sel.options.length) {
        C.cats.forEach(function (c, i) { var o = el('option'); o.value = i; o.textContent = c.name + ' (' + c.items.length + ')'; sel.appendChild(o); });
      }
      var q = (filter || '').trim().toLowerCase();
      var items = q ? [].concat.apply([], C.cats.map(function (c) { return c.items; })).filter(function (it, i, a) { return it[1].toLowerCase().indexOf(q) >= 0 && a.indexOf(it) === i; })
        : C.cats[Number(sel.value) || 0].items;
      grid.innerHTML = '';
      items.forEach(function (it) {
        var b = el('button', 'fspd-clip'); b.type = 'button'; b.title = it[1];
        b.innerHTML = '<svg viewBox="0 0 ' + C.vb + ' ' + C.vb + '" aria-hidden="true"><path d="' + it[2] + '"/></svg><span>' + esc(it[1]) + '</span>';
        b.addEventListener('click', function () {
          var c = currentColor('fill'); var p = clipPath(it[0], c === 'none' ? '#000000' : c);
          p.scaleToHeight(Math.min(state.trimH * 0.5, state.trimW * 0.4) * state.ppi);
          addObj(p);
        });
        grid.appendChild(b);
      });
      if (!items.length) { grid.innerHTML = '<p class="fspd-hint">No icons match.</p>'; }
    }, function (e) { grid.innerHTML = '<p class="fspd-hint">Clipart didn’t load. Please refresh.</p>'; });
  }

  // QR codes: built as one vector path (exact squares), on a white quiet zone so they scan on any background.
  function qrGroup(text, color) {
    return loadScript(CDN + 'qrcode-generator/1.4.4/qrcode.min.js').then(function () {
      var qr = window.qrcode(0, 'M'); qr.addData(text); qr.make();
      var n = qr.getModuleCount(), q = 2, d = '';
      for (var r = 0; r < n; r++) {
        for (var c = 0; c < n; c++) {
          if (!qr.isDark(r, c)) { continue; }
          var c2 = c; while (c2 + 1 < n && qr.isDark(r, c2 + 1)) { c2++; }
          d += 'M ' + (c + q) + ' ' + (r + q) + ' L ' + (c2 + 1 + q) + ' ' + (r + q) + ' L ' + (c2 + 1 + q) + ' ' + (r + 1 + q) + ' L ' + (c + q) + ' ' + (r + 1 + q) + ' Z ';
          c = c2;
        }
      }
      var bg = new fabric.Rect({ left: 0, top: 0, width: n + 2 * q, height: n + 2 * q, fill: '#ffffff' });
      var dots = new fabric.Path(d, { fill: color || '#000000' });
      dots.set({ left: q, top: q });
      var g = new fabric.Group([bg, dots], { fspType: 'qr', fspData: text, fspFlip: false, fspName: 'QR code' });
      return g;
    });
  }
  function addQr() {
    var text = $('fspd-qr').value.trim();
    if (!text) { status('Type a web address, phone number or text for the QR code first.', true); return; }
    if (/^[\w.-]+\.[a-z]{2,}(\/\S*)?$/i.test(text)) { text = 'https://' + text; }
    var act = canvas.getActiveObject();
    status('Making QR code…');
    qrGroup(text).then(function (g) {
      var side = Math.max(1.25, Math.min(state.trimH * 0.6, state.trimW * 0.4, 6)) * state.ppi;
      if (act && act.fspType === 'qr') {   // replace the selected QR code in place
        var c = act.getCenterPoint(), w = act.getScaledWidth();
        canvas.remove(act); g.scaleToWidth(w); canvas.add(g); g.setPositionByOrigin(c, 'center', 'center'); addObj(g, true);
      } else { g.scaleToWidth(side); addObj(g); }
      status('QR code added. Keep it at least 1" square and test it with your phone on the preview.');
    }, function (e) { status('The QR code maker didn’t load (' + e.message + ').', true); });
  }

  /* ---------- uploads ---------- */
  function fitUpload(o) {
    var maxW = state.trimW * 0.6 * state.ppi, maxH = state.trimH * 0.7 * state.ppi;
    o.scale(Math.min(maxW / o.width, maxH / o.height));
    addObj(o);
  }
  var fileSeq = 0;
  function keepOriginal(file) { var id = 'f' + Date.now().toString(36) + (fileSeq++); ORIGINALS[id] = file; return id; }
  function upload(file) {
    if (!file) { return; }
    if (file.size > 20 * 1024 * 1024) { status('That file is over 20 MB. Please email it to us instead, or upload a smaller version.', true); return; }
    var name = file.name || 'logo', ext = (name.split('.').pop() || '').toLowerCase();
    var rd = new FileReader();
    if (/svg/i.test(file.type) || ext === 'svg') {
      // SVG logos stay vector all the way to the print file
      rd.onload = function () {
        fabric.loadSVGFromString(rd.result, function (objs, opts) {
          if (!objs || !objs.length) { status('That SVG has no shapes we can read. Try a PDF or PNG instead.', true); return; }
          var g = fabric.util.groupSVGElements(objs, opts);
          g.fspType = 'logo'; g.fspName = name; g.fspFlip = false; g.fspFile = keepOriginal(file);
          fitUpload(g);
          status('Vector logo added. It will print sharp at any size.');
        });
      };
      rd.readAsText(file);
      return;
    }
    if (ext === 'pdf' || ext === 'ai' || file.type === 'application/pdf') {
      status('Reading ' + name + '…');
      var id = keepOriginal(file);
      loadScript(CDN + 'pdf.js/3.11.174/pdf.min.js').then(function () {
        window.pdfjsLib.GlobalWorkerOptions.workerSrc = CDN + 'pdf.js/3.11.174/pdf.worker.min.js';
        return file.arrayBuffer();
      }).then(function (buf) { return window.pdfjsLib.getDocument({ data: buf }).promise; })
        .then(function (pdf) { return pdf.getPage(1); })
        .then(function (page) {
          var v1 = page.getViewport({ scale: 1 }), sc = 2400 / Math.max(v1.width, v1.height);
          var vp = page.getViewport({ scale: sc }), cv = document.createElement('canvas');
          cv.width = Math.ceil(vp.width); cv.height = Math.ceil(vp.height);
          return page.render({ canvasContext: cv.getContext('2d'), viewport: vp, background: 'rgba(0,0,0,0)' }).promise.then(function () { return cv; });
        })
        .then(function (cv) {
          fabric.Image.fromURL(cv.toDataURL('image/png'), function (img) {
            img.set({ fspType: 'logo', fspName: name, fspFile: id, fspFlip: false });
            fitUpload(img);
            status('Logo added from ' + name + '. Your original file is attached to the order, so we print from it.');
          });
        })
        .catch(function () { addPlaceholder(name, id); });
      return;
    }
    if (ext === 'eps' || ext === 'ps') { addPlaceholder(name, keepOriginal(file)); return; }
    rd.onload = function () {
      fabric.Image.fromURL(rd.result, function (img) {
        if (!img || !img.width) { status('That image couldn’t be read. Please use PNG, JPG, SVG, PDF, AI or EPS.', true); return; }
        img.set({ fspType: 'image', fspName: name, fspFlip: false });
        fitUpload(img);
        var dpi = img.width / (img.getScaledWidth() / state.ppi);
        if (dpi < PROFILE.minDpi) { status('Heads up: this image is low resolution for this size (about ' + Math.round(dpi) + ' dpi). It may print blurry. Try “Convert to vector” or send us a better file.', true); }
      });
    };
    rd.readAsDataURL(file);
  }
  function addPlaceholder(name, id) {
    var w = state.trimW * 0.35 * state.ppi, h = state.trimH * 0.3 * state.ppi;
    var box = new fabric.Rect({ width: w, height: h, fill: '#eef2f6', stroke: '#6b7280', strokeWidth: 2, strokeDashArray: [8, 6], originX: 'center', originY: 'center' });
    newText('Your logo\n' + name, DEFAULT_FONT, { fontSize: Math.min(h * 0.2, w * 0.09), fill: '#374151', fontWeight: 'normal', originX: 'center', originY: 'center' }).then(function (t) {
      var g = new fabric.Group([box, t], { fspType: 'placeholder', fspFile: id, fspName: name, fspFlip: false });
      addObj(g);
      status('We can’t show ' + name + ' in the browser, so there’s a placeholder. Size and place it where you want the logo. Your file is attached to the order and we’ll set it in before your proof.');
    });
  }

  // Logo helpers (no server): remove a white background, or trace a picture into vector shapes.
  function imageCanvas(img, maxSide) {
    var e = img.getElement(), w = e.naturalWidth || e.width, h = e.naturalHeight || e.height, k = Math.min(1, (maxSide || 1e9) / Math.max(w, h));
    var cv = document.createElement('canvas'); cv.width = Math.round(w * k); cv.height = Math.round(h * k);
    cv.getContext('2d').drawImage(e, 0, 0, cv.width, cv.height); return cv;
  }
  function removeWhite(img) {
    var cv = imageCanvas(img), ctx = cv.getContext('2d'), w = cv.width, h = cv.height;
    var id = ctx.getImageData(0, 0, w, h), d = id.data, seen = new Uint8Array(w * h), stack = [];
    var white = function (i) { return d[i * 4 + 3] > 0 && d[i * 4] > 235 && d[i * 4 + 1] > 235 && d[i * 4 + 2] > 235; };
    for (var x = 0; x < w; x++) { stack.push(x, (h - 1) * w + x); }
    for (var y = 0; y < h; y++) { stack.push(y * w, y * w + w - 1); }
    while (stack.length) {   // flood fill from the edges, so white inside the logo stays
      var p = stack.pop(); if (seen[p] || !white(p)) { continue; }
      seen[p] = 1; d[p * 4 + 3] = 0;
      var px = p % w;
      if (px > 0) { stack.push(p - 1); } if (px < w - 1) { stack.push(p + 1); }
      if (p >= w) { stack.push(p - w); } if (p < w * (h - 1)) { stack.push(p + w); }
    }
    ctx.putImageData(id, 0, 0);
    img.setElement(cv); img.set('dirty', true); canvas.requestRenderAll(); commit();
    status('White background removed.');
  }
  function traceImage(img) {
    status('Converting to vector… this can take a few seconds.');
    loadScript(ASSET + 'fsp-imagetracer.js').then(function () {
      var cv = imageCanvas(img, 900), ctx = cv.getContext('2d');
      var svg = window.ImageTracer.imagedataToSVG(ctx.getImageData(0, 0, cv.width, cv.height),
        { numberofcolors: 6, colorquantcycles: 3, ltres: 1, qtres: 1, pathomit: 12, rightangleenhance: true, strokewidth: 0, linefilter: true, viewbox: true, roundcoords: 2 });
      fabric.loadSVGFromString(svg, function (objs, opts) {
        objs = (objs || []).filter(function (o) { return !(typeof o.fill === 'string' && /rgba?\(\s*\d+\s*,\s*\d+\s*,\s*\d+\s*,\s*0(\.0+)?\s*\)/.test(o.fill)) && o.opacity !== 0; });
        if (!objs.length) { status('That picture couldn’t be traced. We’ll use it as is.', true); return; }
        var g = fabric.util.groupSVGElements(objs, opts);
        var c = img.getCenterPoint(); g.scaleToWidth(img.getScaledWidth());
        g.set({ fspType: 'logo', fspName: (img.fspName || 'logo') + ' (traced)', fspFlip: false, fspFile: img.fspFile });
        canvas.remove(img); canvas.add(g); g.setPositionByOrigin(c, 'center', 'center'); addObj(g, true);
        status('Converted to vector. Check the edges look right. Fine detail can simplify; we’ll check it at proof.');
      });
    }, function (e) { status('The vector tool didn’t load (' + e.message + ').', true); });
  }

  function applyToActive(fn) {
    var o = canvas.getActiveObject(); if (!o) { status('Click an item on the sign first.', true); return; }
    fn(o); o.setCoords(); canvas.requestRenderAll(); checkSafe(); commit();
  }
  function toHex(c) {
    if (typeof c !== 'string' || c === 'transparent' || c === 'none' || !c) { return '#ffffff'; }
    if (c.charAt(0) === '#') { return c.length === 4 ? '#' + c[1] + c[1] + c[2] + c[2] + c[3] + c[3] : c.toLowerCase(); }
    return '#' + new fabric.Color(c).toHex().toLowerCase();
  }
  function usesStrokeColor(o) { return o.type === 'line' || o.fspType === 'border' || ((!o.fill || o.fill === 'transparent') && o.stroke); }
  function setObjColor(o, c) {
    if (c === 'none') { return; }
    if (o.type === 'group') {
      if (o.fspType === 'qr') { o.getObjects()[1].set('fill', c); }
      else if (o.fspType !== 'placeholder') {
        o.getObjects().forEach(function (k) { if (typeof k.fill === 'string' && k.fill && toHex(k.fill) !== '#ffffff') { k.set('fill', c); } });
      }
      o.dirty = true; return;
    }
    if (o.type === 'image') { return; }
    if (usesStrokeColor(o)) { o.set('stroke', c); } else { o.set('fill', c); }
  }
  function objColor(o) {
    if (!o) { return null; }
    if (o.fspType === 'qr') { return toHex(o.getObjects()[1].fill); }
    if (o.type === 'group' && o.fspType === 'logo') { var k = o.getObjects().filter(function (x) { return typeof x.fill === 'string' && x.fill && toHex(x.fill) !== '#ffffff'; })[0]; return k ? toHex(k.fill) : null; }
    if (o.type === 'group' || o.type === 'image') { return null; }
    return toHex(usesStrokeColor(o) ? o.stroke : o.fill);
  }

  /* ---------- text effects: curve, outline, spacing ---------- */
  function setCurve(o, v) {
    v = Math.max(-100, Math.min(100, Number(v) || 0));
    var c = o.getCenterPoint();
    o.set('path', null); o.fspCurve = v; o.initDimensions();
    if (v) {
      var W = o.calcTextWidth(), th = Math.min(Math.abs(v) / 100 * Math.PI * 1.6, Math.PI * 1.6), R = W / th;
      var a = th / 2, sx = -R * Math.sin(a), ex = R * Math.sin(a), cy = R * Math.cos(a);
      var big = th > Math.PI ? 1 : 0, d;
      if (v > 0) { d = 'M ' + n(sx) + ' ' + n(-cy) + ' A ' + n(R) + ' ' + n(R) + ' 0 ' + big + ' 1 ' + n(ex) + ' ' + n(-cy); }
      else { d = 'M ' + n(sx) + ' ' + n(cy) + ' A ' + n(R) + ' ' + n(R) + ' 0 ' + big + ' 0 ' + n(ex) + ' ' + n(cy); }
      var p = new fabric.Path(d, { visible: false, fill: '', stroke: '' });
      o.set('path', p); o.initDimensions();
    }
    o.setPositionByOrigin(c, 'center', 'center'); o.setCoords();
  }

  /* ---------- selection toolbar ---------- */
  function syncProps() {
    var o = canvas.getActiveObject(), box = $('fspd-props');
    box.classList.toggle('is-empty', !o);
    if (!o) { $('fspd-props-name').textContent = 'Click anything on the sign to change it'; return; }
    var t = isText(o);
    root.querySelectorAll('[data-for]').forEach(function (e) {
      var f = e.dataset.for;
      e.hidden = !((f === 'text' && t) || (f === 'image' && o.type === 'image') || (f === 'qr' && o.fspType === 'qr') || (f === 'color' && objColor(o) !== null) || f === 'any' || (f === 'groupcolor' && o.type === 'group' && o.fspType === 'logo'));
    });
    $('fspd-props-name').textContent = t ? 'Text' : (o.fspName || ({ image: 'Picture', group: 'Logo', path: 'Shape', rect: 'Box', circle: 'Circle', polygon: 'Shape', line: 'Line' }[o.type] || 'Item'));
    var col = objColor(o); if (col) { setSwatchValue('fill', col); }
    if (t) {
      $('fspd-font').value = FONTS[o.fontFamily] ? o.fontFamily : DEFAULT_FONT;
      root.querySelectorAll('.fspd-align').forEach(function (b) { b.classList.toggle('is-on', b.dataset.align === (o.textAlign || 'left')); });
      $('fspd-spacing').value = o.charSpacing || 0;
      $('fspd-leading').value = o.lineHeight || 1.16;
      $('fspd-curve').value = o.fspCurve || 0;
      $('fspd-outline-w').value = o.stroke && o.strokeWidth ? Math.round(o.strokeWidth / o.fontSize * 100) : 0;
      setSwatchValue('outline', o.stroke && o.strokeWidth ? toHex(o.stroke) : 'none');
    }
    if (o.fspType === 'qr') { $('fspd-qr').value = o.fspData || ''; }
  }
  canvas.on('selection:created', syncProps);
  canvas.on('selection:updated', syncProps);
  canvas.on('selection:cleared', syncProps);

  function alignTo(where) {
    applyToActive(function (o) {
      var m = (BLEED + SAFE) * state.ppi, b = o.getBoundingRect(true, true), dx = 0, dy = 0;
      if (where === 'left') { dx = m - b.left; }
      if (where === 'right') { dx = state.wpx - m - (b.left + b.width); }
      if (where === 'hcenter') { dx = state.wpx / 2 - (b.left + b.width / 2); }
      if (where === 'top') { dy = m - b.top; }
      if (where === 'bottom') { dy = state.hpx - m - (b.top + b.height); }
      if (where === 'vcenter') { dy = state.hpx / 2 - (b.top + b.height / 2); }
      o.set({ left: o.left + dx, top: o.top + dy });
    });
  }
  function duplicate() {
    var o = canvas.getActiveObject(); if (!o) { status('Click an item on the sign first.', true); return; }
    o.clone(function (c) {
      CUSTOM.forEach(function (k) { if (o[k] != null) { c[k] = o[k]; } });
      if (o.fspFile) { c.fspFile = o.fspFile; }
      c.set({ left: o.left + 12, top: o.top + 12 });
      canvas.add(c); c.setCoords(); canvas.setActiveObject(c); canvas.requestRenderAll(); checkSafe(); commit();
    }, CUSTOM);
  }

  // snap to the center lines while dragging
  var guides = { v: false, h: false };
  canvas.on('object:moving', function (e) {
    var o = e.target, c = o.getCenterPoint(), tol = 6;
    guides.v = Math.abs(c.x - state.wpx / 2) < tol; guides.h = Math.abs(c.y - state.hpx / 2) < tol;
    if (guides.v || guides.h) {
      o.setPositionByOrigin(new fabric.Point(guides.v ? state.wpx / 2 : c.x, guides.h ? state.hpx / 2 : c.y), 'center', 'center');
    }
    checkSafe();
  });
  canvas.on('mouse:up', function () { if (guides.v || guides.h) { guides.v = guides.h = false; canvas.requestRenderAll(); } });
  canvas.on('after:render', function () {
    if (!guides.v && !guides.h) { return; }
    var ctx = canvas.getContext(); ctx.save(); ctx.strokeStyle = '#e11d74'; ctx.lineWidth = 1; ctx.setLineDash([4, 3]);
    if (guides.v) { ctx.beginPath(); ctx.moveTo(state.wpx / 2 + 0.5, 0); ctx.lineTo(state.wpx / 2 + 0.5, state.hpx); ctx.stroke(); }
    if (guides.h) { ctx.beginPath(); ctx.moveTo(0, state.hpx / 2 + 0.5); ctx.lineTo(state.wpx, state.hpx / 2 + 0.5); ctx.stroke(); }
    ctx.restore();
  });

  /* ---------- safe-zone check ---------- */
  function outsideSafe(objs, wpx, hpx, ppi) {
    var m = (BLEED + SAFE) * ppi, bad = 0;
    objs.forEach(function (o) {
      if ((o.type === 'rect' && (o.getScaledWidth() >= wpx * 0.9 || o.getScaledHeight() >= hpx * 0.9)) || o.fspType === 'border') { return; } // backgrounds, edge-to-edge color bands and borders are fine
      var b = o.getBoundingRect(true, true);
      if (b.left < m - 1 || b.top < m - 1 || b.left + b.width > wpx - m + 1 || b.top + b.height > hpx - m + 1) { bad++; }
    });
    return bad;
  }
  function checkSafe() {
    var nb = outsideSafe(canvas.getObjects(), state.wpx, state.hpx, state.ppi);
    var w = $('fspd-warn');
    if (nb) { w.hidden = false; w.textContent = (nb > 1 ? nb + ' things on this side are' : 'Something on this side is') + ' outside the green dotted line and could get cut off. Drag ' + (nb > 1 ? 'them' : 'it') + ' in a little, or click ' + (nb > 1 ? 'each one' : 'it') + ' and use “− Smaller”.'; }
    else { w.hidden = true; }
  }
  canvas.on('object:scaling', checkSafe);

  /* ---------- smart checks before ordering (plain rules, no AI needed) ---------- */
  function lum(hex) {
    var c = new fabric.Color(hex).getSource(); if (!c) { return 1; }
    var f = function (v) { v /= 255; return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4); };
    return 0.2126 * f(c[0]) + 0.7152 * f(c[1]) + 0.0722 * f(c[2]);
  }
  function contrast(a, b) { var x = lum(a), y = lum(b); return (Math.max(x, y) + 0.05) / (Math.min(x, y) + 0.05); }
  function behind(objs, idx, pt, bg) {
    for (var i = idx - 1; i >= 0; i--) {
      var o = objs[i];
      if ((o.type === 'rect' || o.type === 'circle' || o.type === 'polygon' || o.type === 'path') && typeof o.fill === 'string' && o.fill && o.fill !== 'transparent' && o.containsPoint(pt, null, true)) { return o.fill; }
    }
    return bg;
  }
  // opt.prefix: 'Rider' labels the notes for the rider; opt.autoBack: the back is made automatically, so check the front only
  function runChecks(opt) {
    opt = opt || {};
    saveCurrent();
    var out = [], sides = opt.autoBack ? [0] : (TWO_SIDED ? [0, 1] : [0]);
    var minH = PROFILE.minTextIn || (Math.max(state.trimW, state.trimH) >= 18 ? 0.75 : 0.4);
    // one side after the other, so the notes always come out in the same order (front, then back)
    return sides.reduce(function (pp, si) { return pp.then(function () {
      if (!sideHasContent(state.sides[si])) { return null; }
      return withSideCanvas(si, function (tmp) {
        var objs = tmp.getObjects(), bg = tmp.backgroundColor || '#ffffff', label = opt.prefix ? opt.prefix + (si ? ' back: ' : ': ') : sides.length > 1 ? (si ? 'Back: ' : 'Front: ') : '';
        if (outsideSafe(objs, state.wpx, state.hpx, state.ppi)) { out.push(label + 'Something sits past the green safe zone and may be trimmed off.'); }
        objs.forEach(function (o, idx) {
          if (isText(o)) {
            var txt = o.text || '', short = txt.replace(/\s+/g, ' ').slice(0, 30);
            if (/your name|000-000-0000|your street|yourwebsite|your text|your company|your business/i.test(txt)) { out.push(label + 'Sample text is still on the sign: “' + short + '”. Replace it with your own.'); }
            var capIn = o.fontSize * (o.scaleY || 1) * 0.7 / state.ppi;
            if (capIn < minH) {
              var tall = capIn < 0.3 ? (Math.round(capIn * 100) / 100) : (Math.round(capIn * 10) / 10);
              if (KIND === 'cnc') { out.push(label + '“' + short + '” letters are about ' + tall + '" tall. Letters smaller than about 1" are hard to cut cleanly. Make them bigger, or call us.'); }
              else if (KIND === 'engrave' || KIND === 'plate') { out.push(label + '“' + short + '” letters are about ' + tall + '" tall. Letters smaller than about 1/8" may not come out clean. Make them bigger if you can.'); }
              else if (KIND === 'plaque') { out.push(label + '“' + short + '” letters are about ' + tall + '" tall, which is small for a cast plaque. Make them bigger if you can.'); }
              else { out.push(label + '“' + short + '” letters are about ' + tall + '" tall, which is small for this sign. About 1" of letter height reads from 10 feet away.'); }
            }
            var col = typeof o.fill === 'string' ? o.fill : '#000000', under = behind(objs, idx, o.getCenterPoint(), bg);
            var ratio = contrast(col, under);
            if (o.stroke && o.strokeWidth) { ratio = Math.max(ratio, contrast(o.stroke, under)); }
            if (ratio < 2.5 && !MONO.on) { out.push(label + '“' + short + '” is hard to see against the color behind it. Try a darker or lighter color.'); }
            (txt.match(/\(?\d[\d\s().-]{5,}\d/g) || []).forEach(function (m) {
              var dg = m.replace(/\D/g, '');
              if (dg.length >= 7 && dg.length <= 12 && dg.length !== 10 && !(dg.length === 11 && dg[0] === '1') && dg.length !== 7) { out.push(label + 'The number “' + m + '” looks incomplete for a phone number (' + dg.length + ' digits).'); }
            });
            if (/\b(\w+)\s+\1\b/i.test(txt)) { out.push(label + '“' + short + '” has a repeated word.'); }
          }
          if (o.type === 'image' && PROFILE.noPhotos) { out.push(label + 'A photo or picture file can’t be ' + (KIND === 'cnc' ? 'cut' : KIND === 'plaque' ? 'cast' : 'engraved') + ' as it is. Click it and use “Make it sharper (convert to vector)”, or send us a logo file (SVG, PDF, AI or EPS).'); }
          else if (o.type === 'image' && o.fspType !== 'logo') {
            var dpi = (o.getElement().naturalWidth || o.width) / (o.getScaledWidth() / state.ppi);
            if (dpi < PROFILE.minDpi) { out.push(label + 'A picture is low resolution at this size (about ' + Math.round(dpi) + ' dpi) and may print blurry.'); }
          }
          if (o.fspType === 'qr' && o.getScaledWidth() / state.ppi < 1) { out.push(label + 'The QR code is smaller than 1" and may not scan. Make it bigger.'); }
        });
      });
    }); }, Promise.resolve()).then(function () {
      if (!opt.prefix && TWO_SIDED && sideHasContent(state.sides[0]) && !sideHasContent(state.sides[1])) { out.push('The back of your sign is empty, so it will print blank.'); }
      return out.filter(function (x, i) { return out.indexOf(x) === i; });
    });
  }
  function showChecks(list) {
    var box = $('fspd-checks');
    if (!list.length) { box.hidden = true; box.innerHTML = ''; return; }
    box.hidden = false;
    box.innerHTML = '<strong>Before you order, please look at:</strong><ul>' + list.map(function (x) { return '<li>' + esc(x) + '</li>'; }).join('') + '</ul>';
  }

  /* ---------- templates ---------- */
  // Boxes are fractions of the safe area [x, y, w, h]. Every template uses sample text the customer replaces.
  var NAME = 'Your Name', PHONE = '000-000-0000';
  function T(t, font, color, box, extra) { return Object.assign({ t: 'text', text: t, font: font, color: color, box: box }, extra || {}); }
  function C(id, color, box) { return { t: 'clip', id: id, color: color, box: box }; }
  function R(color, box, rx) { return { t: 'rect', color: color, box: box, rx: rx || 0 }; }
  function A(color, box, dir) { return { t: 'arrow', color: color, box: box, dir: dir || 'right' }; }
  var RED = '#c8102e', NAVY = '#0c2340', BLUE = '#0057b8', BLACK = '#000000', WHITE = '#ffffff', GREEN = '#154734', YEL = '#ffd100', ORANGE = '#ff6a13', TEAL = '#00827f';
  function rider(word, color, bg, font, arrow) {
    var items = [];
    if (bg && bg !== WHITE) { items.push(R(bg, [-0.2, -0.3, 1.4, 1.6])); }
    items.push(T(word, font || 'Anton', bg && bg !== WHITE ? WHITE : color, arrow ? [0, 0.05, 0.74, 0.9] : [0, 0.05, 1, 0.9], { align: arrow ? 'left' : 'center' }));
    if (arrow) { items.push(A(bg && bg !== WHITE ? WHITE : color, [0.8, 0.12, 0.2, 0.76])); }
    return { bg: WHITE, items: items };
  }
  function bigWord(word, color, sub, icon, font) {
    return {
      land: { bg: WHITE, items: [R(color, [-0.1, -0.1, 1.2, 0.5]), T(word, font || 'Anton', WHITE, [0.04, 0.02, 0.92, 0.34]), icon ? C(icon, color, [0.02, 0.5, 0.2, 0.42]) : null, T(sub || NAME, 'Montserrat', BLACK, icon ? [0.25, 0.5, 0.75, 0.2] : [0, 0.5, 1, 0.2]), T(PHONE, 'Montserrat', color, icon ? [0.25, 0.74, 0.75, 0.2] : [0, 0.74, 1, 0.2])] },
      square: { bg: WHITE, items: [R(color, [-0.1, -0.1, 1.2, 0.46]), T(word, font || 'Anton', WHITE, [0.04, 0.02, 0.92, 0.3]), icon ? C(icon, color, [0.38, 0.42, 0.24, 0.22]) : null, T(sub || NAME, 'Montserrat', BLACK, [0, 0.66, 1, 0.14]), T(PHONE, 'Montserrat', color, [0, 0.84, 1, 0.14])] },
      tall: { bg: WHITE, items: [R(color, [-0.1, -0.1, 1.2, 0.4]), T(word.split(' ').join('\n'), font || 'Anton', WHITE, [0.04, 0.02, 0.92, 0.26]), icon ? C(icon, color, [0.3, 0.38, 0.4, 0.24]) : null, T(sub || NAME, 'Montserrat', BLACK, [0, 0.66, 1, 0.12]), T(PHONE, 'Montserrat', color, [0, 0.82, 1, 0.12])] }
    };
  }
  var TEMPLATES = [
    { id: 'for-sale', name: 'For Sale', cat: 'Real estate', l: bigWord('FOR SALE', RED, NAME, 'house') },
    { id: 'for-rent', name: 'For Rent', cat: 'Real estate', l: bigWord('FOR RENT', BLUE, NAME, 'key') },
    { id: 'sold', name: 'Sold', cat: 'Real estate', l: bigWord('SOLD', RED, NAME, 'seal-check') },
    { id: 'coming-soon', name: 'Coming Soon', cat: 'Real estate', l: bigWord('COMING SOON', NAVY, NAME, 'house-line') },
    { id: 'under-contract', name: 'Under Contract', cat: 'Real estate', l: bigWord('UNDER CONTRACT', GREEN, NAME, 'handshake') },
    { id: 'fsbo', name: 'For Sale By Owner', cat: 'Real estate', l: bigWord('FOR SALE BY OWNER', RED, 'Call or text', 'house') },
    {
      id: 'open-house', name: 'Open House', cat: 'Real estate', l: {
        land: { bg: WHITE, items: [R(BLUE, [-0.1, -0.1, 1.2, 0.56]), T('OPEN\nHOUSE', 'Anton', WHITE, [0.03, 0.0, 0.66, 0.44], { align: 'left' }), A(WHITE, [0.72, 0.08, 0.26, 0.28]), T('Sat & Sun 1 - 4 PM', 'Montserrat', BLACK, [0, 0.56, 1, 0.18]), T(NAME + '  ·  ' + PHONE, 'Montserrat', BLUE, [0, 0.78, 1, 0.16])] },
        tall: { bg: WHITE, items: [R(BLUE, [-0.1, -0.1, 1.2, 0.5]), T('OPEN\nHOUSE', 'Anton', WHITE, [0.04, 0.0, 0.92, 0.3]), A(WHITE, [0.3, 0.3, 0.4, 0.1]), T('Sat & Sun\n1 - 4 PM', 'Montserrat', BLACK, [0, 0.5, 1, 0.22]), T(NAME, 'Montserrat', BLACK, [0, 0.76, 1, 0.1]), T(PHONE, 'Montserrat', BLUE, [0, 0.88, 1, 0.1])] }
      }
    },
    { id: 'r-open', name: 'Rider: Open House →', cat: 'Riders', l: { wide: rider('OPEN HOUSE', RED, WHITE, 'Anton', true) } },
    { id: 'r-sold', name: 'Rider: Sold', cat: 'Riders', l: { wide: rider('SOLD', WHITE, RED) } },
    { id: 'r-pending', name: 'Rider: Pending', cat: 'Riders', l: { wide: rider('PENDING', NAVY) } },
    { id: 'r-contract', name: 'Rider: Under Contract', cat: 'Riders', l: { wide: rider('UNDER CONTRACT', WHITE, GREEN) } },
    { id: 'r-coming', name: 'Rider: Coming Soon', cat: 'Riders', l: { wide: rider('COMING SOON', BLUE) } },
    { id: 'r-price', name: 'Rider: New Price', cat: 'Riders', l: { wide: rider('NEW PRICE', WHITE, RED) } },
    { id: 'r-pool', name: 'Rider: Pool', cat: 'Riders', l: { wide: { bg: WHITE, items: [C('swimming-pool', TEAL, [0, 0.05, 0.22, 0.9]), T('POOL', 'Anton', TEAL, [0.26, 0.05, 0.74, 0.9])] } } },
    { id: 'r-water', name: 'Rider: Waterfront', cat: 'Riders', l: { wide: { bg: WHITE, items: [C('waves', BLUE, [0, 0.05, 0.2, 0.9]), T('WATERFRONT', 'Anton', BLUE, [0.24, 0.05, 0.76, 0.9])] } } },
    { id: 'r-appt', name: 'Rider: By Appointment', cat: 'Riders', l: { wide: rider('BY APPOINTMENT ONLY', NAVY, WHITE, 'Oswald') } },
    { id: 'r-rent', name: 'Rider: For Rent', cat: 'Riders', l: { wide: rider('FOR RENT', WHITE, BLUE) } },
    { id: 'r-name', name: 'Rider: Name & Phone', cat: 'Riders', l: { wide: { bg: WHITE, items: [T(NAME, 'Montserrat', BLACK, [0, 0.02, 1, 0.5]), T(PHONE, 'Montserrat', RED, [0, 0.55, 1, 0.43])] } } },
    { id: 'no-trespassing', name: 'Private Property', cat: 'Property & safety', l: { land: { bg: WHITE, items: [R(RED, [-0.1, -0.1, 1.2, 0.42]), T('PRIVATE PROPERTY', 'Anton', WHITE, [0.03, 0.04, 0.94, 0.26]), C('prohibit', RED, [0.03, 0.46, 0.22, 0.5]), T('NO\nTRESPASSING', 'Anton', BLACK, [0.28, 0.46, 0.72, 0.5])] }, tall: { bg: WHITE, items: [R(RED, [-0.1, -0.1, 1.2, 0.34]), T('PRIVATE\nPROPERTY', 'Anton', WHITE, [0.04, 0.02, 0.92, 0.22]), C('prohibit', RED, [0.3, 0.34, 0.4, 0.28]), T('NO\nTRESPASSING', 'Anton', BLACK, [0, 0.66, 1, 0.3])] } } },
    { id: 'beware-dog', name: 'Beware of Dog', cat: 'Property & safety', l: { land: { bg: YEL, items: [R(BLACK, [-0.02, -0.02, 1.04, 1.04], 0.04), R(YEL, [0.02, 0.03, 0.96, 0.94], 0.03), C('dog', BLACK, [0.05, 0.12, 0.3, 0.76]), T('BEWARE\nOF DOG', 'Anton', BLACK, [0.38, 0.1, 0.6, 0.8])] }, tall: { bg: YEL, items: [R(BLACK, [-0.02, -0.02, 1.04, 1.04], 0.04), R(YEL, [0.03, 0.02, 0.94, 0.96], 0.03), C('dog', BLACK, [0.25, 0.08, 0.5, 0.36]), T('BEWARE\nOF DOG', 'Anton', BLACK, [0.06, 0.5, 0.88, 0.42])] } } },
    { id: 'camera', name: 'Video Surveillance', cat: 'Property & safety', l: { land: { bg: WHITE, items: [R(NAVY, [-0.1, -0.1, 1.2, 1.2]), C('video-camera', YEL, [0.03, 0.15, 0.28, 0.7]), T('THIS PROPERTY IS\nUNDER 24 HOUR\nVIDEO SURVEILLANCE', 'Oswald', WHITE, [0.34, 0.08, 0.64, 0.84], { align: 'left' })] }, tall: { bg: WHITE, items: [R(NAVY, [-0.1, -0.1, 1.2, 1.2]), C('video-camera', YEL, [0.25, 0.06, 0.5, 0.3]), T('THIS PROPERTY IS\nUNDER 24 HOUR\nVIDEO\nSURVEILLANCE', 'Oswald', WHITE, [0.04, 0.42, 0.92, 0.54])] } } },
    { id: 'parking', name: 'Reserved Parking', cat: 'Parking', l: { land: { bg: WHITE, items: [R(BLUE, [-0.1, -0.1, 1.2, 0.5]), T('RESERVED', 'Anton', WHITE, [0.03, 0.03, 0.94, 0.34]), C('car', BLUE, [0.02, 0.52, 0.24, 0.44]), T('PARKING', 'Anton', BLUE, [0.28, 0.5, 0.72, 0.24]), T('Violators will be towed', 'Montserrat', BLACK, [0.28, 0.78, 0.72, 0.18])] }, tall: { bg: WHITE, items: [R(BLUE, [-0.1, -0.1, 1.2, 0.36]), T('RESERVED\nPARKING', 'Anton', WHITE, [0.04, 0.02, 0.92, 0.24]), C('car', BLUE, [0.25, 0.36, 0.5, 0.28]), T('Your Company\nCustomers Only', 'Montserrat', BLACK, [0, 0.68, 1, 0.16]), T('Violators will be towed', 'Montserrat', RED, [0, 0.88, 1, 0.1])] } } },
    { id: 'no-parking', name: 'No Parking', cat: 'Parking', l: { land: { bg: WHITE, items: [C('prohibit', RED, [0.02, 0.06, 0.32, 0.88]), T('NO\nPARKING', 'Anton', RED, [0.36, 0.04, 0.62, 0.62]), T('Tow-away zone', 'Montserrat', BLACK, [0.36, 0.72, 0.62, 0.22])] }, tall: { bg: WHITE, items: [C('prohibit', RED, [0.2, 0.04, 0.6, 0.34]), T('NO\nPARKING', 'Anton', RED, [0, 0.42, 1, 0.38]), T('Tow-away zone', 'Montserrat', BLACK, [0, 0.84, 1, 0.12])] } } },
    { id: 'address', name: 'Address', cat: 'Address', l: { land: { bg: NAVY, items: [T('1234', 'Oswald', WHITE, [0, 0, 1, 0.66]), T('Your Street', 'Montserrat', WHITE, [0, 0.7, 1, 0.28])] }, wide: { bg: NAVY, items: [T('1234 Your Street', 'Oswald', WHITE, [0, 0.05, 1, 0.9])] }, tall: { bg: NAVY, items: [T('1234', 'Oswald', WHITE, [0, 0.1, 1, 0.5]), T('Your\nStreet', 'Montserrat', WHITE, [0, 0.64, 1, 0.3])] } } },
    { id: 'yard-sale', name: 'Yard Sale', cat: 'Events', l: { land: { bg: YEL, items: [T('YARD SALE', 'Anton', BLACK, [0, 0, 0.72, 0.5], { align: 'left' }), A(RED, [0.75, 0.08, 0.25, 0.34]), T('Saturday 8 AM - 2 PM', 'Montserrat', BLACK, [0, 0.56, 1, 0.2]), T('1234 Your Street', 'Montserrat', RED, [0, 0.8, 1, 0.18])] }, wide: { bg: YEL, items: [T('YARD SALE', 'Anton', BLACK, [0, 0.05, 0.76, 0.9], { align: 'left' }), A(RED, [0.8, 0.12, 0.2, 0.76])] }, tall: { bg: YEL, items: [T('YARD\nSALE', 'Anton', BLACK, [0, 0, 1, 0.44]), A(RED, [0.25, 0.48, 0.5, 0.16]), T('Saturday\n8 AM - 2 PM', 'Montserrat', BLACK, [0, 0.68, 1, 0.3])] } } },
    { id: 'birthday', name: 'Happy Birthday', cat: 'Events', l: { land: { bg: WHITE, items: [C('balloon', RED, [0.02, 0.05, 0.16, 0.6]), C('balloon', BLUE, [0.82, 0.05, 0.16, 0.6]), T('Happy\nBirthday', 'Pacifico', '#5f259f', [0.2, 0, 0.6, 0.66]), T(NAME, 'Montserrat', BLACK, [0, 0.72, 1, 0.26])] }, tall: { bg: WHITE, items: [C('balloon', RED, [0.1, 0.02, 0.25, 0.26]), C('balloon', BLUE, [0.65, 0.02, 0.25, 0.26]), T('Happy\nBirthday', 'Pacifico', '#5f259f', [0, 0.32, 1, 0.4]), T(NAME, 'Montserrat', BLACK, [0, 0.78, 1, 0.18])] } } },
    { id: 'grad', name: 'Congrats Grad', cat: 'Events', l: { land: { bg: NAVY, items: [C('graduation-cap', '#b9975b', [0.02, 0.1, 0.26, 0.8]), T('Congrats\nGrad!', 'Pacifico', WHITE, [0.3, 0, 0.7, 0.66]), T(NAME + ' · Class of 2027', 'Montserrat', '#b9975b', [0.3, 0.72, 0.7, 0.24])] }, tall: { bg: NAVY, items: [C('graduation-cap', '#b9975b', [0.25, 0.02, 0.5, 0.28]), T('Congrats\nGrad!', 'Pacifico', WHITE, [0, 0.34, 1, 0.36]), T(NAME + '\nClass of 2027', 'Montserrat', '#b9975b', [0, 0.74, 1, 0.24])] } } },
    { id: 'welcome', name: 'Welcome Home', cat: 'Events', l: { land: { bg: WHITE, items: [C('heart', RED, [0.42, 0.0, 0.16, 0.28]), T('Welcome Home', 'Pacifico', NAVY, [0, 0.3, 1, 0.46]), T('We missed you, ' + NAME, 'Montserrat', BLACK, [0, 0.8, 1, 0.18])] }, wide: { bg: WHITE, items: [T('Welcome Home', 'Pacifico', NAVY, [0, 0.0, 1, 1])] }, tall: { bg: WHITE, items: [C('heart', RED, [0.3, 0.02, 0.4, 0.22]), T('Welcome\nHome', 'Pacifico', NAVY, [0, 0.28, 1, 0.46]), T(NAME, 'Montserrat', BLACK, [0, 0.8, 1, 0.16])] } } },
    { id: 'grand-opening', name: 'Grand Opening', cat: 'Business', l: {
      land: { bg: WHITE, items: [R(RED, [-0.1, -0.1, 1.2, 0.6]), T('GRAND OPENING', 'Anton', WHITE, [0.03, 0.04, 0.94, 0.46]), T('Your Business Name', 'Montserrat', BLACK, [0, 0.62, 1, 0.18]), T('Saturday 10 AM  ·  1234 Your Street', 'Montserrat', RED, [0, 0.83, 1, 0.15])] },
      wide: { bg: RED, items: [T('GRAND OPENING', 'Anton', WHITE, [0, 0.04, 0.6, 0.92], { align: 'left' }), T('Your Business Name', 'Montserrat', YEL, [0.63, 0.06, 0.37, 0.44]), T('Saturday 10 AM', 'Montserrat', WHITE, [0.63, 0.56, 0.37, 0.36])] },
      tall: { bg: WHITE, items: [R(RED, [-0.1, -0.1, 1.2, 0.5]), T('GRAND\nOPENING', 'Anton', WHITE, [0.04, 0.03, 0.92, 0.4]), T('Your Business\nName', 'Montserrat', BLACK, [0, 0.56, 1, 0.2]), T('Saturday 10 AM', 'Montserrat', RED, [0, 0.82, 1, 0.12])] } } },
    { id: 'sale', name: 'Sale', cat: 'Business', l: {
      land: { bg: YEL, items: [T('SALE', 'Anton', RED, [0, 0, 1, 0.62]), T('This Weekend Only', 'Montserrat', BLACK, [0, 0.64, 1, 0.16]), T('Your Business Name', 'Montserrat', BLACK, [0, 0.84, 1, 0.14])] },
      wide: { bg: YEL, items: [T('SALE', 'Anton', RED, [0, 0.02, 0.4, 0.96]), T('This Weekend Only', 'Montserrat', BLACK, [0.43, 0.08, 0.57, 0.44]), T('Your Business Name', 'Montserrat', BLACK, [0.43, 0.56, 0.57, 0.36])] },
      tall: { bg: YEL, items: [T('SALE', 'Anton', RED, [0, 0.04, 1, 0.5]), T('This Weekend\nOnly', 'Montserrat', BLACK, [0, 0.58, 1, 0.24]), T('Your Business Name', 'Montserrat', BLACK, [0, 0.86, 1, 0.1])] } } },
    { id: 'event', name: 'Event', cat: 'Events', l: {
      land: { bg: NAVY, items: [T('Your Event Name', 'Oswald', WHITE, [0, 0.02, 1, 0.46]), T('Saturday, June 6  ·  10 AM - 4 PM', 'Montserrat', YEL, [0, 0.54, 1, 0.18]), T('1234 Your Street', 'Montserrat', WHITE, [0, 0.78, 1, 0.18])] },
      wide: { bg: NAVY, items: [T('Your Event Name', 'Oswald', WHITE, [0, 0.04, 0.58, 0.92], { align: 'left' }), T('Saturday, June 6', 'Montserrat', YEL, [0.61, 0.06, 0.39, 0.42]), T('10 AM - 4 PM', 'Montserrat', WHITE, [0.61, 0.54, 0.39, 0.38])] },
      tall: { bg: NAVY, items: [T('Your\nEvent\nName', 'Oswald', WHITE, [0, 0.03, 1, 0.5]), T('Saturday, June 6\n10 AM - 4 PM', 'Montserrat', YEL, [0, 0.58, 1, 0.22]), T('1234 Your Street', 'Montserrat', WHITE, [0, 0.86, 1, 0.1])] } } },
    { id: 'open-house-banner', name: 'Open House', cat: 'Real estate', only: 'banner', l: {
      wide: { bg: BLUE, items: [T('OPEN HOUSE', 'Anton', WHITE, [0, 0.04, 0.5, 0.92], { align: 'left' }), A(WHITE, [0.52, 0.2, 0.1, 0.6]), T('Sat & Sun 1 - 4 PM', 'Montserrat', WHITE, [0.65, 0.06, 0.35, 0.42]), T(NAME + '  ·  ' + PHONE, 'Montserrat', YEL, [0.65, 0.56, 0.35, 0.36])] } } },
    { id: 'now-open', name: 'Now Open', cat: 'Business', l: { land: { bg: RED, items: [T('NOW OPEN', 'Anton', WHITE, [0, 0.02, 1, 0.56]), T('Your Business Name', 'Montserrat', YEL, [0, 0.62, 1, 0.2]), T('www.yourwebsite.com', 'Montserrat', WHITE, [0, 0.84, 1, 0.14])] }, wide: rider('NOW OPEN', WHITE, RED), tall: { bg: RED, items: [T('NOW\nOPEN', 'Anton', WHITE, [0, 0.04, 1, 0.56]), T('Your Business\nName', 'Montserrat', YEL, [0, 0.64, 1, 0.2]), T('www.yourwebsite.com', 'Montserrat', WHITE, [0, 0.88, 1, 0.1])] } } },
    { id: 'hiring', name: 'Now Hiring', cat: 'Business', l: { land: { bg: WHITE, items: [R(ORANGE, [-0.1, -0.1, 1.2, 0.56]), T('NOW HIRING', 'Anton', WHITE, [0.03, 0.04, 0.94, 0.38]), T('Apply today', 'Montserrat', BLACK, [0, 0.56, 1, 0.2]), T(PHONE + '  ·  www.yourwebsite.com', 'Montserrat', ORANGE, [0, 0.8, 1, 0.16])] }, wide: rider('NOW HIRING', WHITE, ORANGE), tall: { bg: WHITE, items: [R(ORANGE, [-0.1, -0.1, 1.2, 0.46]), T('NOW\nHIRING', 'Anton', WHITE, [0.04, 0.02, 0.92, 0.32]), T('Apply today', 'Montserrat', BLACK, [0, 0.52, 1, 0.14]), T(PHONE, 'Montserrat', ORANGE, [0, 0.7, 1, 0.12]), T('www.yourwebsite.com', 'Montserrat', BLACK, [0, 0.86, 1, 0.1])] } } },
    { id: 'business', name: 'Business Info', cat: 'Business', l: { land: { bg: WHITE, items: [R(NAVY, [-0.1, -0.1, 1.2, 0.5]), T('Your Business Name', 'Oswald', WHITE, [0.03, 0.04, 0.94, 0.32]), C('phone', NAVY, [0.02, 0.56, 0.1, 0.18]), T(PHONE, 'Montserrat', BLACK, [0.14, 0.54, 0.86, 0.2], { align: 'left' }), C('globe', NAVY, [0.02, 0.8, 0.1, 0.18]), T('www.yourwebsite.com', 'Montserrat', BLACK, [0.14, 0.78, 0.86, 0.2], { align: 'left' })] }, wide: { bg: NAVY, items: [T('Your Business  ·  ' + PHONE, 'Oswald', WHITE, [0, 0.05, 1, 0.9])] }, tall: { bg: WHITE, items: [R(NAVY, [-0.1, -0.1, 1.2, 0.4]), T('Your\nBusiness\nName', 'Oswald', WHITE, [0.04, 0.02, 0.92, 0.28]), C('storefront', NAVY, [0.3, 0.42, 0.4, 0.22]), T(PHONE, 'Montserrat', BLACK, [0, 0.7, 1, 0.12]), T('www.yourwebsite.com', 'Montserrat', NAVY, [0, 0.86, 1, 0.1])] } } }
  ];
  // Nameplates (engraved tags, brass, screen printed, sublimated), cast plaques, CNC letters & shapes
  (function () {
    var G = '#5f6b7a';
    var np = function (id, name, l) { TEMPLATES.push({ id: id, name: name, cat: 'Nameplates', l: l }); };
    np('np-name-title', 'Name & Title', {
      wide: { bg: WHITE, items: [T(NAME, 'Montserrat', BLACK, [0, 0.02, 1, 0.56]), T('Your Title', 'Montserrat', BLACK, [0, 0.64, 1, 0.34], { weight: 400 })] },
      land: { bg: WHITE, items: [T(NAME, 'Montserrat', BLACK, [0, 0.04, 1, 0.52]), T('Your Title', 'Montserrat', BLACK, [0, 0.62, 1, 0.34], { weight: 400 })] },
      square: { bg: WHITE, items: [T(NAME, 'Montserrat', BLACK, [0, 0.18, 1, 0.34]), T('Your Title', 'Montserrat', BLACK, [0, 0.58, 1, 0.24], { weight: 400 })] } });
    np('np-one-line', 'One Line', { wide: { bg: WHITE, items: [T(NAME, 'Montserrat', BLACK, [0, 0.12, 1, 0.76])] }, land: { bg: WHITE, items: [T(NAME, 'Montserrat', BLACK, [0, 0.25, 1, 0.5])] }, square: { bg: WHITE, items: [T(NAME, 'Montserrat', BLACK, [0, 0.35, 1, 0.3])] } });
    np('np-company', 'Company, Name & Title', {
      wide: { bg: WHITE, items: [T('Your Company', 'Oswald', BLACK, [0, 0, 1, 0.4]), T(NAME, 'Montserrat', BLACK, [0, 0.44, 1, 0.3]), T('Your Title', 'Montserrat', BLACK, [0, 0.76, 1, 0.24], { weight: 400 })] },
      land: { bg: WHITE, items: [T('Your Company', 'Oswald', BLACK, [0, 0, 1, 0.36]), T(NAME, 'Montserrat', BLACK, [0, 0.42, 1, 0.3]), T('Your Title', 'Montserrat', BLACK, [0, 0.76, 1, 0.24], { weight: 400 })] } });
    np('np-office', 'Office / Room', {
      wide: { bg: WHITE, items: [T('OFFICE', 'Oswald', BLACK, [0, 0.04, 1, 0.5]), T(NAME, 'Montserrat', BLACK, [0, 0.6, 1, 0.36])] },
      land: { bg: WHITE, items: [T('OFFICE', 'Oswald', BLACK, [0, 0.04, 1, 0.48]), T(NAME, 'Montserrat', BLACK, [0, 0.6, 1, 0.34])] } });
    np('np-label', 'Equipment Label', { wide: { bg: WHITE, items: [T('PANEL A', 'Oswald', BLACK, [0, 0.08, 1, 0.84])] }, land: { bg: WHITE, items: [T('MAIN\nSHUTOFF', 'Oswald', BLACK, [0, 0.05, 1, 0.9])] } });
    np('np-door', 'Restroom / Door', { wide: { bg: WHITE, items: [T('RESTROOM', 'Oswald', BLACK, [0, 0.12, 1, 0.76])] }, land: { bg: WHITE, items: [T('PRIVATE', 'Oswald', BLACK, [0, 0.05, 1, 0.5]), T('Employees Only', 'Montserrat', BLACK, [0, 0.62, 1, 0.34], { weight: 400 })] } });
    TEMPLATES.push({ id: 'np-band', name: 'Name with Color Band', cat: 'Nameplates', kind: 'plate', l: {
      wide: { bg: WHITE, items: [R(NAVY, [-0.2, -0.2, 0.3, 1.4]), T(NAME, 'Montserrat', BLACK, [0.16, 0.04, 0.84, 0.54]), T('Your Title', 'Montserrat', G, [0.16, 0.64, 0.84, 0.32], { weight: 400 })] },
      land: { bg: WHITE, items: [R(NAVY, [-0.2, -0.3, 1.4, 0.58]), T('Your Company', 'Oswald', WHITE, [0, 0.01, 1, 0.22]), T(NAME, 'Montserrat', BLACK, [0, 0.34, 1, 0.36]), T('Your Title', 'Montserrat', G, [0, 0.74, 1, 0.24], { weight: 400 })] } } });
    var pl = function (id, name, l) { TEMPLATES.push({ id: id, name: name, cat: 'Plaques', l: l }); };
    pl('pl-number-street', 'Number & Street', { land: { bg: WHITE, items: [T('1234', 'Oswald', BLACK, [0, 0, 1, 0.64]), T('Your Street', 'Montserrat', BLACK, [0, 0.7, 1, 0.3])] } });
    pl('pl-number', 'Number Only', { land: { bg: WHITE, items: [T('1234', 'Oswald', BLACK, [0, 0, 1, 1])] } });
    pl('pl-family', 'Family Name & Number', { land: { bg: WHITE, items: [T('The Your Name Family', 'Playfair Display', BLACK, [0, 0, 1, 0.3]), T('1234', 'Oswald', BLACK, [0, 0.36, 1, 0.64])] } });
    pl('pl-est', 'Name & Established', { land: { bg: WHITE, items: [T('Your Name', 'Playfair Display', BLACK, [0, 0, 1, 0.56]), T('EST. 2026', 'Montserrat', BLACK, [0, 0.66, 1, 0.3])] } });
    var cnc = function (id, name, l) { TEMPLATES.push({ id: id, name: name, cat: 'CNC letters & shapes', l: l }); };
    var one = function (t, font) { var it = [T(t, font, BLACK, [0.02, 0.05, 0.96, 0.9])]; return { wide: { bg: WHITE, items: it }, land: { bg: WHITE, items: it }, square: { bg: WHITE, items: it }, tall: { bg: WHITE, items: [T(t, font, BLACK, [0.02, 0.3, 0.96, 0.4])] } }; };
    cnc('cnc-block', 'Block Letters', one('YOUR NAME', 'Oswald'));
    cnc('cnc-bold', 'Bold Letters', one('YOUR BUSINESS', 'Anton'));
    cnc('cnc-numbers', 'House Numbers', one('1234', 'Oswald'));
    cnc('cnc-serif', 'Classic Letters', one('Your Name', 'Playfair Display'));
    cnc('cnc-script', 'Script Word', one('Welcome', 'Pacifico'));
    cnc('cnc-two-lines', 'Two Lines', { wide: { bg: WHITE, items: [T('YOUR BUSINESS', 'Oswald', BLACK, [0, 0, 1, 0.6]), T('Your Tagline', 'Montserrat', BLACK, [0, 0.66, 1, 0.34])] }, land: { bg: WHITE, items: [T('YOUR\nBUSINESS', 'Oswald', BLACK, [0, 0, 1, 0.66]), T('Your Tagline', 'Montserrat', BLACK, [0, 0.72, 1, 0.28])] }, square: { bg: WHITE, items: [T('YOUR\nNAME', 'Oswald', BLACK, [0, 0.05, 1, 0.9])] } });
    cnc('cnc-star', 'Star Shape', { wide: { bg: WHITE, items: [C('star', BLACK, [0.35, 0.05, 0.3, 0.9])] }, land: { bg: WHITE, items: [C('star', BLACK, [0.25, 0.05, 0.5, 0.9])] }, square: { bg: WHITE, items: [C('star', BLACK, [0.05, 0.05, 0.9, 0.9])] }, tall: { bg: WHITE, items: [C('star', BLACK, [0.05, 0.3, 0.9, 0.4])] } });
    cnc('cnc-heart', 'Heart Shape', { wide: { bg: WHITE, items: [C('heart', BLACK, [0.35, 0.05, 0.3, 0.9])] }, land: { bg: WHITE, items: [C('heart', BLACK, [0.25, 0.05, 0.5, 0.9])] }, square: { bg: WHITE, items: [C('heart', BLACK, [0.05, 0.05, 0.9, 0.9])] }, tall: { bg: WHITE, items: [C('heart', BLACK, [0.05, 0.3, 0.9, 0.4])] } });
    cnc('cnc-anchor', 'Anchor (Marine)', { wide: { bg: WHITE, items: [C('anchor', BLACK, [0.35, 0.05, 0.3, 0.9])] }, land: { bg: WHITE, items: [C('anchor', BLACK, [0.25, 0.05, 0.5, 0.9])] }, square: { bg: WHITE, items: [C('anchor', BLACK, [0.05, 0.05, 0.9, 0.9])] }, tall: { bg: WHITE, items: [C('anchor', BLACK, [0.05, 0.3, 0.9, 0.4])] } });
  })();
  // wide (long banner) versions of two event templates
  (function () {
    var byId = function (id) { return TEMPLATES.filter(function (t) { return t.id === id; })[0]; };
    byId('birthday').l.wide = { bg: WHITE, items: [C('balloon', RED, [0, 0.05, 0.08, 0.9]), T('Happy Birthday', 'Pacifico', '#5f259f', [0.1, 0, 0.56, 1]), T(NAME, 'Montserrat', BLACK, [0.68, 0.1, 0.22, 0.8]), C('balloon', BLUE, [0.92, 0.05, 0.08, 0.9])] };
    byId('grad').l.wide = { bg: NAVY, items: [C('graduation-cap', '#b9975b', [0, 0.05, 0.12, 0.9]), T('Congrats Grad!', 'Pacifico', WHITE, [0.14, 0, 0.5, 1]), T(NAME + '\nClass of 2027', 'Montserrat', '#b9975b', [0.66, 0.1, 0.34, 0.8])] };
  })();
  function layoutFor(tpl, cls) { var l = tpl.l; return l[cls] || (cls === 'square' ? (l.land || l.tall) : null) || (cls === 'land' && l.square) || null; }

  // Builds fabric objects for a layout (templates and AI designs share this). Returns a promise of {bg, objects}.
  function buildLayout(lay, ppi, trimW, trimH) {
    var sx = (BLEED + SAFE) * ppi, sy = sx, sw = (trimW - 2 * SAFE) * ppi, sh = (trimH - 2 * SAFE) * ppi;
    var items = (lay.items || []).filter(Boolean), fonts = {};
    items.forEach(function (it) { if (it.t === 'text') { fonts[FONTS[it.font] ? it.font : DEFAULT_FONT] = 1; } });
    var needClip = items.some(function (it) { return it.t === 'clip'; });
    return Promise.all([ensureScreenFonts(fonts), needClip ? loadClipart() : null]).then(function () {
      var objs = [];
      items.forEach(function (it) {
        var b = it.box || [0, 0, 1, 1], bx = sx + b[0] * sw, by = sy + b[1] * sh, bw = b[2] * sw, bh = b[3] * sh, o = null;
        var color = /^#[0-9a-f]{6}$/i.test(it.color || '') ? it.color : '#000000';
        if (it.t === 'rect') {
          var rr = (it.rx || 0) * Math.min(sw, sh);
          o = new fabric.Rect({ left: bx, top: by, width: bw, height: bh, fill: color, rx: rr, ry: rr });
        } else if (it.t === 'text') {
          var font = FONTS[it.font] ? it.font : DEFAULT_FONT, txt = String(it.text || '').slice(0, 200);
          var lines = txt.split('\n').length;
          o = new fabric.IText(txt, { fontFamily: font, fontWeight: FONTS[font].weights.indexOf(700) >= 0 && it.weight !== 400 ? '700' : 'normal', fill: color, textAlign: it.align || 'center', lineHeight: 1.0, fontSize: bh / lines * 0.95, strokeLineJoin: 'round', paintFirst: 'stroke' });
          o.initDimensions();
          if (o.width > bw) { o.set('fontSize', o.fontSize * bw / o.width); o.initDimensions(); }
          if (o.height > bh) { o.set('fontSize', o.fontSize * bh / o.height); o.initDimensions(); }
          // the drawn text is a touch wider/taller than its box; shrink so the visible text stays inside the box
          o.setCoords(); var br = o.getBoundingRect(true, true);
          var over = Math.max(br.width / bw, br.height / bh);
          if (over > 1) { o.set('fontSize', o.fontSize / over * 0.995); o.initDimensions(); o.setCoords(); br = o.getBoundingRect(true, true); }
          var ex = (br.width - o.width) / 2;
          var ax = it.align === 'left' ? bx + ex : it.align === 'right' ? bx + bw - o.width - ex : bx + (bw - o.width) / 2;
          o.set({ left: ax, top: by + (bh - o.height) / 2 });
        } else if (it.t === 'clip' && CLIP && CLIP.byId[it.id]) {
          o = clipPath(it.id, color);
        } else if (it.t === 'arrow') {
          o = new fabric.Path(SHAPES.arrow.d, { fill: color, fspFlip: true, fspType: 'arrow', fspName: 'Arrow', flipX: it.dir === 'left' });
        }
        if (!o) { return; }
        if (o.type === 'path') {
          var k = Math.min(bw / o.width, bh / o.height) * 0.98; o.scale(k);
          o.setPositionByOrigin(new fabric.Point(bx + bw / 2, by + bh / 2), 'center', 'center');
        }
        o.setCoords(); objs.push(o);
      });
      return { bg: /^#[0-9a-f]{6}$/i.test(lay.bg || '') ? lay.bg : '#ffffff', objects: objs };
    });
  }
  var tplArmed = null;
  function applyLayout(lay, label) {
    return buildLayout(lay, state.ppi, state.trimW, state.trimH).then(function (r) {
      state.loading++;
      canvas.clear(); canvas.backgroundColor = r.bg;
      r.objects.forEach(function (o) { canvas.add(o); });
      if (MONO.on) { applyMono(true); }
      canvas.renderAll(); state.loading--;
      setSwatchValue('bg', r.bg); checkSafe(); syncProps(); commit();
      status((label || 'Design') + ' is on your ' + PROFILE.noun + '. Next, put in your own words (Step 2).');
    });
  }
  function useTemplate(tpl, btn) {
    var lay = layoutFor(tpl, aspectClass(state.trimW, state.trimH)); if (!lay) { return; }
    if (canvas.getObjects().length && tplArmed !== tpl.id) {
      tplArmed = tpl.id; root.querySelectorAll('.fspd-tpl').forEach(function (b) { b.classList.remove('is-armed'); });
      btn.classList.add('is-armed');
      status('This replaces what’s on this side. Click the template again to use it, or Undo afterwards.');
      setTimeout(function () { if (tplArmed === tpl.id) { tplArmed = null; btn.classList.remove('is-armed'); } }, 5000);
      return;
    }
    tplArmed = null; btn.classList.remove('is-armed');
    applyLayout(lay, tpl.name).then(function () {
      root.querySelectorAll('.fspd-tpl').forEach(function (b) { b.classList.toggle('is-picked', b === btn); });
      if (FSPD.afterTemplate) { FSPD.afterTemplate(tpl); }
    });
  }
  var tplRender = 0;
  function renderTemplates() {
    var grid = $('fspd-tpl-grid'); if (!grid || !state.trimW) { return; }
    var cls = aspectClass(state.trimW, state.trimH), run = ++tplRender;
    var list = TEMPLATES.filter(function (t) { return layoutFor(t, cls) && PROFILE.hideCats.indexOf(t.cat) < 0 && (!PROFILE.onlyCats || PROFILE.onlyCats.indexOf(t.cat) >= 0) && (!t.only || t.only === PROFILE.noun || t.only === KIND) && (!t.kind || t.kind === KIND); });
    if (PROFILE.firstCats.length) {
      var rank = function (t) { var i = PROFILE.firstCats.indexOf(t.cat); return i < 0 ? 99 : i; };
      list = list.map(function (t, i) { return [t, i]; }).sort(function (a, b) { return rank(a[0]) - rank(b[0]) || a[1] - b[1]; }).map(function (x) { return x[0]; });
    }
    grid.innerHTML = '';
    if (!list.length) { grid.innerHTML = '<p class="fspd-hint">No templates for this size yet. Start from scratch with text and graphics.</p>'; return; }
    var pw = 168, k = pw / (state.W * 72), ppi = 72 * k, ph = Math.round(state.H * ppi);
    list.forEach(function (t) {
      var b = el('button', 'fspd-tpl'); b.type = 'button'; b.title = t.name;
      var cv = el('canvas'); cv.width = pw * 2; cv.height = ph * 2; cv.style.width = pw + 'px'; cv.style.height = ph + 'px';
      b.appendChild(cv); b.appendChild(el('span', null, esc(t.name)));
      b.addEventListener('click', function () { useTemplate(t, b); });
      grid.appendChild(b);
      buildLayout(layoutFor(t, cls), ppi * 2, state.trimW, state.trimH).then(function (r) {
        if (run !== tplRender) { return; }
        var sc = new fabric.StaticCanvas(cv, { width: pw * 2, height: ph * 2, backgroundColor: MONO.on ? monoFace() : r.bg, renderOnAddRemove: false });
        r.objects.forEach(function (o) { if (MONO.on) { setObjColor(o, monoInk()); } sc.add(o); }); sc.renderAll();
        cv.style.width = pw + 'px'; cv.style.height = ph + 'px';
      });
    });
  }

  /* ---------- AI assistant (needs the small relay server; hidden until it's set up) ---------- */
  var AI = { url: window.FSPD_AI_URL || '', designs: [], i: 0 };
  function aiAsk() {
    var prompt = $('fspd-ai-text').value.trim();
    if (prompt.length < 4) { status('Tell us what the sign is for, what it should say and any colors you like.', true); return; }
    var btn = $('fspd-ai-go'); btn.disabled = true; status('Designing… this takes a few seconds.');
    var palette = PALETTE.map(function (p) { return p[1]; });
    loadClipart().then(function (C2) {
      return fetch(AI.url, {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          prompt: prompt.slice(0, 600),
          sign: { product: PRODUCT.title, width_in: state.trimW, height_in: state.trimH, shape: aspectClass(state.trimW, state.trimH) },
          fonts: Object.keys(FONTS), colors: palette,
          clipart: Object.keys(C2.byId)
        })
      });
    }).then(function (r) { return r.json().then(function (j) { if (!r.ok) { throw new Error(j.error || ('HTTP ' + r.status)); } return j; }); })
      .then(function (j) {
        AI.designs = (j.designs || []).filter(function (d) { return d && Array.isArray(d.items); }).slice(0, 4); AI.i = 0;
        if (!AI.designs.length) { throw new Error('no designs came back'); }
        $('fspd-ai-next').hidden = AI.designs.length < 2;
        return applyLayout(AI.designs[0], 'Design idea 1 of ' + AI.designs.length);
      })
      .catch(function (e) { status('The design helper isn’t available right now (' + e.message + '). Try a template instead.', true); })
      .then(function () { btn.disabled = false; });
  }
  function aiNext() {
    if (!AI.designs.length) { return; }
    AI.i = (AI.i + 1) % AI.designs.length;
    applyLayout(AI.designs[AI.i], 'Design idea ' + (AI.i + 1) + ' of ' + AI.designs.length);
  }

  /* ---------- vector print file ---------- */
  // Fabric matrix [a b c d e f] (canvas px, y down) -> PDF cm (points, y up).
  // pdf-lib's drawSvgPath adds scale(1,-1), so the y-flip is folded in here.
  function pdfCm(m, g) {
    return [g.kx * m[0], -g.ky * m[1], -g.kx * m[2], g.ky * m[3], g.kx * m[4], g.H - g.ky * m[5]];
  }
  function pdfColor(c) {
    if (!c || typeof c !== 'string' || c === 'none' || c === 'transparent') { return null; }
    var s = new fabric.Color(c).getSource();
    if (!s) { return null; }
    return { rgb: PL.rgb(s[0] / 255, s[1] / 255, s[2] / 255), a: s[3] == null ? 1 : s[3] };
  }
  function n(v) { return Math.round(v * 1000) / 1000; }
  var KAPPA = 0.5522847498;
  function ellipsePath(rx, ry) {
    var kx = KAPPA * rx, ky = KAPPA * ry;
    return 'M ' + n(rx) + ' 0 C ' + n(rx) + ' ' + n(ky) + ' ' + n(kx) + ' ' + n(ry) + ' 0 ' + n(ry) +
      ' C ' + n(-kx) + ' ' + n(ry) + ' ' + n(-rx) + ' ' + n(ky) + ' ' + n(-rx) + ' 0' +
      ' C ' + n(-rx) + ' ' + n(-ky) + ' ' + n(-kx) + ' ' + n(-ry) + ' 0 ' + n(-ry) +
      ' C ' + n(kx) + ' ' + n(-ry) + ' ' + n(rx) + ' ' + n(-ky) + ' ' + n(rx) + ' 0 Z';
  }
  // opentype path -> SVG path data after an affine map (a b c d e f), for curved text
  function mappedPathData(path, m) {
    var out = [];
    var P = function (x, y) { return n(m[0] * x + m[2] * y + m[4]) + ' ' + n(m[1] * x + m[3] * y + m[5]); };
    path.commands.forEach(function (c) {
      if (c.type === 'M' || c.type === 'L') { out.push(c.type + ' ' + P(c.x, c.y)); }
      else if (c.type === 'C') { out.push('C ' + P(c.x1, c.y1) + ' ' + P(c.x2, c.y2) + ' ' + P(c.x, c.y)); }
      else if (c.type === 'Q') { out.push('Q ' + P(c.x1, c.y1) + ' ' + P(c.x, c.y)); }
      else if (c.type === 'Z') { out.push('Z'); }
    });
    return out.join(' ');
  }

  // Outline path for one object, in its own local units (origin at its center). null = not vector-able.
  function localPath(o) {
    var t = o.type, po = o.pathOffset || { x: 0, y: 0 };
    if (isText(o)) {
      var font = otFont(o); if (!font) { return null; }
      var d = '', acc = 0, top = -o.height / 2, left = -o.width / 2;
      for (var i = 0; i < o._textLines.length; i++) {
        var line = o._textLines[i].join('');
        for (var k = 0; k < line.length; k++) {
          if (!/\s/.test(line[k]) && font.charToGlyph(line[k]).index === 0) { return null; } // missing glyph
        }
        if (o.path) {   // text on a curve: place each letter where fabric draws it
          var bounds = o.__charBounds[i];
          for (var j = 0; j < o._textLines[i].length; j++) {
            var ch = o._textLines[i][j], cb = bounds[j];
            if (/\s/.test(ch) || !cb) { continue; }
            var ca = Math.cos(cb.angle), sa = Math.sin(cb.angle);
            d += mappedPathData(font.getPath(ch, -cb.width / 2, 0, o.fontSize, { kerning: false }), [ca, sa, -sa, ca, cb.renderLeft, cb.renderTop]) + ' ';
          }
          continue;
        }
        var hl = o.getHeightOfLine(i), maxH = hl / o.lineHeight;
        var base = top + acc + maxH * (1 - o._fontSizeFraction);
        var x = left + o._getLineLeftOffset(i), cbs = o.__charBounds[i];
        // each letter goes exactly where the browser measured it (its kerning and letter spacing), so print matches screen
        for (var q = 0; q < o._textLines[i].length; q++) {
          var g1 = o._textLines[i][q];
          if (/\s/.test(g1) || !cbs || !cbs[q]) { continue; }
          d += font.getPath(g1, x + cbs[q].left, base, o.fontSize, { kerning: false }).toPathData(3) + ' ';
        }
        acc += hl;
      }
      return d.trim() || '';
    }
    if (t === 'rect') {
      var w = o.width, h = o.height, x0 = -w / 2, y0 = -h / 2, rx = Math.min(o.rx || 0, w / 2), ry = Math.min(o.ry || rx, h / 2);
      if (!rx) { return 'M ' + n(x0) + ' ' + n(y0) + ' H ' + n(x0 + w) + ' V ' + n(y0 + h) + ' H ' + n(x0) + ' Z'; }
      var kx = KAPPA * rx, ky = KAPPA * ry, x1 = x0 + w, y1 = y0 + h;
      return 'M ' + n(x0 + rx) + ' ' + n(y0) + ' H ' + n(x1 - rx) +
        ' C ' + n(x1 - rx + kx) + ' ' + n(y0) + ' ' + n(x1) + ' ' + n(y0 + ry - ky) + ' ' + n(x1) + ' ' + n(y0 + ry) +
        ' V ' + n(y1 - ry) +
        ' C ' + n(x1) + ' ' + n(y1 - ry + ky) + ' ' + n(x1 - rx + kx) + ' ' + n(y1) + ' ' + n(x1 - rx) + ' ' + n(y1) +
        ' H ' + n(x0 + rx) +
        ' C ' + n(x0 + rx - kx) + ' ' + n(y1) + ' ' + n(x0) + ' ' + n(y1 - ry + ky) + ' ' + n(x0) + ' ' + n(y1 - ry) +
        ' V ' + n(y0 + ry) +
        ' C ' + n(x0) + ' ' + n(y0 + ry - ky) + ' ' + n(x0 + rx - kx) + ' ' + n(y0) + ' ' + n(x0 + rx) + ' ' + n(y0) + ' Z';
    }
    if (t === 'path') {
      var out = [];
      for (var s = 0; s < o.path.length; s++) {
        var seg = o.path[s], cmd = seg[0];
        if (cmd !== cmd.toUpperCase()) { return null; }   // relative commands: let the fallback handle it
        if (cmd === 'Z') { out.push('Z'); continue; }
        if (cmd === 'H') { out.push('H ' + n(seg[1] - po.x)); continue; }
        if (cmd === 'V') { out.push('V ' + n(seg[1] - po.y)); continue; }
        if (cmd === 'A') { out.push('A ' + seg.slice(1, 6).join(' ') + ' ' + n(seg[6] - po.x) + ' ' + n(seg[7] - po.y)); continue; }
        var p = [cmd];
        for (var jj = 1; jj < seg.length; jj += 2) { p.push(n(seg[jj] - po.x), n(seg[jj + 1] - po.y)); }
        out.push(p.join(' '));
      }
      return out.join(' ');
    }
    if (t === 'polygon' || t === 'polyline') {
      return o.points.map(function (pt, idx) { return (idx ? 'L ' : 'M ') + n(pt.x - po.x) + ' ' + n(pt.y - po.y); }).join(' ') + (t === 'polygon' ? ' Z' : '');
    }
    if (t === 'circle') {
      var span = Math.abs((o.endAngle == null ? 360 : o.endAngle) - (o.startAngle || 0));
      if (span < 359.9 && Math.abs(span - 2 * Math.PI) > 1e-6) { return null; }   // partial arc -> fallback
      return ellipsePath(o.radius, o.radius);
    }
    if (t === 'ellipse') { return ellipsePath(o.rx, o.ry); }
    if (t === 'line') {
      var lp = o.calcLinePoints();
      return 'M ' + n(lp.x1) + ' ' + n(lp.y1) + ' L ' + n(lp.x2) + ' ' + n(lp.y2);
    }
    return null;
  }

  function dataUrlBytes(url) {
    var bin = atob(url.split(',')[1]), arr = new Uint8Array(bin.length);
    for (var k = 0; k < bin.length; k++) { arr[k] = bin.charCodeAt(k); }
    return arr;
  }

  // Draws one object (recursing into groups). Returns a promise; counts what went in as raster.
  function drawObject(doc, page, o, g, report) {
    if (!o.visible) { return Promise.resolve(); }
    if (o.type === 'group' && !o.group && needsRaster(o)) { return rasterize(doc, page, o, g, report); }   // anything not vector-able inside: place the whole group as one image
    if (o.type === 'group') {
      if (o.fspType === 'placeholder') { report.placeholders++; }
      return o.getObjects().reduce(function (p, child) { return p.then(function () { return drawObject(doc, page, child, g, report); }); }, Promise.resolve());
    }
    var m = o.calcTransformMatrix();
    if (!m.every(isFinite) || !m[0] && !m[1] || !m[2] && !m[3]) { report.skipped = (report.skipped || 0) + 1; return Promise.resolve(); }   // squashed to nothing: nothing to print
    var opacity = o.opacity == null ? 1 : o.opacity;

    if (o.type === 'image' && !o.cropX && !o.cropY && !(o.filters && o.filters.length)) {
      var src = o.getSrc ? o.getSrc() : '', elx = o.getElement();
      var job;
      if (/^data:image\/jpe?g/i.test(src)) { job = doc.embedJpg(dataUrlBytes(src)); }
      else {
        var cv = document.createElement('canvas');
        cv.width = elx.naturalWidth || elx.width; cv.height = elx.naturalHeight || elx.height;
        cv.getContext('2d').drawImage(elx, 0, 0, cv.width, cv.height);
        job = doc.embedPng(dataUrlBytes(cv.toDataURL('image/png')));
      }
      return job.then(function (img) {
        page.pushOperators(PL.pushGraphicsState(), PL.concatTransformationMatrix.apply(null, pdfCm(m, g)));
        page.drawImage(img, { x: -o.width / 2, y: -o.height / 2, width: o.width, height: o.height, opacity: opacity });
        page.pushOperators(PL.popGraphicsState());
        report.images++;
      });
    }

    var d = typeof o.fill === 'string' || !o.fill ? localPath(o) : null;   // gradients/patterns -> fallback
    var fill = pdfColor(o.fill), stroke = (o.stroke && o.strokeWidth > 0) ? pdfColor(o.stroke) : null;
    if (d === '') { return Promise.resolve(); }
    if (d !== null && (fill || stroke)) {
      var isLine = o.type === 'line' || o.type === 'polyline';
      page.pushOperators(PL.pushGraphicsState(), PL.concatTransformationMatrix.apply(null, pdfCm(m, g)), PL.setLineJoin(o.strokeLineJoin === 'round' ? 1 : o.strokeLineJoin === 'bevel' ? 2 : 0));
      var cap = o.strokeLineCap === 'round' ? PL.LineCapStyle.Round : o.strokeLineCap === 'square' ? PL.LineCapStyle.Projecting : undefined;
      var drawFill = function () { if (fill && !isLine) { page.drawSvgPath(d, { x: 0, y: 0, color: fill.rgb, opacity: fill.a * opacity }); } };
      var dash = o.strokeDashArray && o.strokeDashArray.length ? o.strokeDashArray : undefined;
      var drawStroke = function () { if (stroke) { page.drawSvgPath(d, { x: 0, y: 0, borderColor: stroke.rgb, borderWidth: o.strokeWidth, borderOpacity: stroke.a * opacity, borderLineCap: cap, borderDashArray: dash }); } };
      if (o.paintFirst === 'stroke') { drawStroke(); drawFill(); } else { drawFill(); drawStroke(); }
      page.pushOperators(PL.popGraphicsState());
      report[isText(o) ? 'text' : 'shapes']++;
      return Promise.resolve();
    }
    if (d !== null) { return Promise.resolve(); }   // nothing visible to draw

    return rasterize(doc, page, o, g, report);
  }
  function needsRaster(o) {
    if (o.type === 'group') { return o.getObjects().some(needsRaster); }
    if (o.type === 'image') { return !!(o.cropX || o.cropY || (o.filters && o.filters.length)); }
    if (o.fill && typeof o.fill !== 'string') { return true; }
    return localPath(o) === null;
  }
  // Fallback: place one top-level item as a high-res image, exactly where it sits.
  function rasterize(doc, page, o, g, report) {
    var b = o.getBoundingRect(true, true);
    // big banners: keep the image under ~12,000 px on its long side so browsers can make it
    var objIn = Math.max(b.width, b.height) / state.ppi, dpi = Math.min(FALLBACK_DPI, Math.floor(12000 / Math.max(objIn, 1)));
    report.fallbackDpi = Math.min(report.fallbackDpi || FALLBACK_DPI, dpi);
    var url = o.toDataURL({ format: 'png', multiplier: dpi / state.ppi, enableRetinaScaling: false });
    return doc.embedPng(dataUrlBytes(url)).then(function (img) {
      page.drawImage(img, { x: g.kx * b.left, y: g.H - g.ky * (b.top + b.height), width: g.kx * b.width, height: g.ky * b.height });
      report.fallback++;
    });
  }

  // Invisible cut path exactly on the trim. Colorant /None never makes a mark on any printer or RIP,
  // but the path is in the file for anyone who wants to use it as a cut line.
  function addCutLine(doc, page, Wpt, Hpt, Bpt) {
    var ctx = doc.context;
    var tint = ctx.register(ctx.obj({ FunctionType: 2, Domain: [0, 1], C0: [0, 0, 0, 0], C1: [0, 0, 0, 0], N: 1 }));
    var cs = ctx.register(ctx.obj([PL.PDFName.of('Separation'), PL.PDFName.of('None'), PL.PDFName.of('DeviceCMYK'), tint]));
    var res = page.node.Resources();
    var csd = res.lookup(PL.PDFName.of('ColorSpace'));
    if (csd) { csd.set(PL.PDFName.of('CSCutLine'), cs); } else { res.set(PL.PDFName.of('ColorSpace'), ctx.obj({ CSCutLine: cs })); }
    var b = Bpt == null ? BLEED * 72 : Bpt;
    page.pushOperators(
      PL.pushGraphicsState(),
      PL.PDFOperator.of('CS', [PL.PDFName.of('CSCutLine')]),
      PL.PDFOperator.of('SCN', [PL.PDFNumber.of(1)]),
      PL.setLineWidth(0.25),
      PL.rectangle(b, b, Wpt - 2 * b, Hpt - 2 * b),
      PL.stroke(),
      PL.popGraphicsState()
    );
  }

  function withSideCanvas(i, fn) {
    return new Promise(function (resolve, reject) {
      var tmp = new fabric.StaticCanvas(null, { width: state.wpx, height: state.hpx });
      loadSide(tmp, state.sides[i], function () {
        Promise.resolve().then(function () { return fn(tmp); }).then(function (r) { tmp.dispose(); resolve(r); }, function (e) { tmp.dispose(); reject(e); });
      });
    });
  }

  function newDesignId() {
    var a = new Uint8Array(6); (window.crypto || window.msCrypto).getRandomValues(a);
    return 'dsn_' + Date.now().toString(36) + Array.prototype.map.call(a, function (x) { return ('0' + x.toString(16)).slice(-2); }).join('');
  }

  function designRecord(designId, sideIdx, qty) {
    var v = state.variant, used = {};
    sideIdx.forEach(function (i) { fontsIn(state.sides[i].json.objects, used); });
    return {
      design_id: designId,
      revision: 1,
      created_at: new Date().toISOString(),
      designer_version: VERSION,
      product: {
        product_id: PRODUCT.id, handle: PRODUCT.handle || null, variant_id: v.id, sku: v.sku || null, size_label: v.title,
        trim_in: { w: state.trimW, h: state.trimH }, bleed_in: BLEED, safe_in: SAFE, units: 'in'
      },
      options: modeState(),
      pricing: { price_version: null, price_type: PROFILE.quote ? 'quote' : 'firm', unit_price: (v.price / 100).toFixed(2), quantity: qty, currency: 'USD' },
      fonts: Object.keys(used).map(function (f) { return { family: f, files: FONTS[f].weights.map(function (w) { return 'fsp-font-' + fontSlug(f) + '-' + w + '.woff'; }), license: /Roboto (Condensed|Slab)/.test(f) ? 'Apache 2.0' : 'SIL OFL 1.1' }; }),
      customer_confirmed_rights: !!($('fspd-rights') && $('fspd-rights').checked),
      sides: sideIdx.map(function (i) {
        var s = state.sides[i];
        return { name: i === 0 ? 'Front' : 'Back', canvas: { wpx: s.wpx, hpx: s.hpx, ppi: s.ppi }, fabric_json: s.json };
      })
    };
  }
  function cdata(s) { return '<![CDATA[' + s.replace(/\]\]>/g, ']]]]><![CDATA[>') + ']]>'; }

  // SVG export: live text stays live; curved text goes in as outlines (it has no reliable SVG equivalent).
  function sideSvg(tmp) {
    tmp.getObjects().forEach(function (o) {
      if (isText(o) && o.path) {
        var d = localPath(o);
        if (d) {
          var mtx = o.calcTransformMatrix().map(n).join(' ');
          o.toSVG = function () { return '<path d="' + d + '" transform="matrix(' + mtx + ')" fill="' + esc(o.fill || '#000') + '"' + (o.stroke && o.strokeWidth ? ' stroke="' + esc(o.stroke) + '" stroke-width="' + n(o.strokeWidth) + '" stroke-linejoin="round" paint-order="stroke"' : '') + '/>\n'; };
        }
      }
    });
    return tmp.toSVG({ width: state.W + 'in', height: state.H + 'in', viewBox: { x: 0, y: 0, width: state.wpx, height: state.hpx } });
  }

  // Builds every file for the order. Exposed for testing.
  function buildFiles() {
    saveCurrent();
    var sideIdx = [0];
    if (TWO_SIDED && sideHasContent(state.sides[1])) { sideIdx.push(1); }
    var qty = Math.max(1, parseInt($('fspd-qty').value, 10) || 1);
    var designId = newDesignId();
    var scale = Math.max(state.W, state.H) > PDF_MAX_IN ? 0.5 : 1;
    var Wpt = state.W * 72 * scale, Hpt = state.H * 72 * scale, Bpt = BLEED * 72 * scale;
    var g = { kx: Wpt / state.wpx, ky: Hpt / state.hpx, H: Hpt };
    var report = { text: 0, shapes: 0, images: 0, fallback: 0, placeholders: 0, scale: scale };
    var sizeSlug = slug(state.variant.title);
    var record = designRecord(designId, sideIdx, qty);
    var svgs = [], previews = [];
    var used = {};
    sideIdx.forEach(function (i) { fontsIn(state.sides[i].json.objects, used); });

    return ensureFonts(used).then(function () { return PL.PDFDocument.create(); }).then(function (doc) {
      doc.setTitle(PRODUCT.title + ' ' + state.variant.title + ' print file');
      doc.setSubject('Design ' + designId);
      doc.setCreator(VERSION + ' (Floridian Signs)');
      doc.setProducer(VERSION);
      return sideIdx.reduce(function (p, i) {
        return p.then(function () {
          return withSideCanvas(i, function (tmp) {
            var page = doc.addPage([Wpt, Hpt]);
            page.setMediaBox(0, 0, Wpt, Hpt);
            page.setBleedBox(0, 0, Wpt, Hpt);
            page.setTrimBox(Bpt, Bpt, Wpt - 2 * Bpt, Hpt - 2 * Bpt);
            var bg = pdfColor(tmp.backgroundColor);
            if (bg && !MONO.on && !(bg.rgb.red === 1 && bg.rgb.green === 1 && bg.rgb.blue === 1)) {
              page.drawRectangle({ x: 0, y: 0, width: Wpt, height: Hpt, color: bg.rgb });
            }
            previews[i] = tmp.toDataURL({ format: 'jpeg', quality: 0.9, multiplier: Math.min(PREVIEW_DPI, 3000 / state.W) / state.ppi });
            // one-color products: the production files show every engrave / cast / cut shape in black on white
            if (MONO.on) { tmp.backgroundColor = ''; tmp.getObjects().forEach(function (o) { setObjColor(o, '#000000'); if (isText(o) && o.stroke && o.strokeWidth) { o.set('stroke', '#000000'); } }); }
            return tmp.getObjects().reduce(function (q, o) { return q.then(function () { return drawObject(doc, page, o, g, report); }); }, Promise.resolve())
              .then(function () {
                if (KIND !== 'cnc') { addCutLine(doc, page, Wpt, Hpt, Bpt); }
                // editable SVG: live text, an invisible cut path on the trim, and (front only) the design data for reorders
                var bx = BLEED * state.wpx / state.W, by = BLEED * state.hpx / state.H;
                svgs[i] = sideSvg(tmp).replace(/<\/svg>\s*$/, (KIND === 'cnc' ? '' : '<rect id="cut-line" x="' + n(bx) + '" y="' + n(by) + '" width="' + n(state.wpx - 2 * bx) + '" height="' + n(state.hpx - 2 * by) + '" fill="none" stroke="none"/>\n') +
                  (i === 0 ? '<metadata id="fsp-design">' + cdata(JSON.stringify(record)) + '</metadata>\n' : '') + '</svg>\n');
              });
          });
        });
      }, Promise.resolve()).then(function () {
        doc.attach(new TextEncoder().encode(JSON.stringify(record, null, 1)), 'design-' + designId + '.json',
          { mimeType: 'application/json', description: 'Editable design data (reopen in the FSP designer)' });
        return doc.save();
      });
    }).then(function (bytes) {
      return originalsUsed(sideIdx).then(function (orig) { return { bytes: bytes, orig: orig }; });
    }).then(function (done) {
      var bytes = done.bytes;
      var files = {
        designId: designId, record: record, report: report, sides: sideIdx.length, pdfScale: scale,
        pdf: new File([bytes], 'print-outlined-' + (scale < 1 ? 'HALF-SCALE-print-at-200pct-' : '') + sizeSlug + (sideIdx.length > 1 ? '-2-sided' : '-front') + '-' + designId + '.pdf', { type: 'application/pdf' }),
        svg: sideIdx.map(function (i) {
          return new File([svgs[i]], (i ? 'back' : 'front') + '-editable-' + sizeSlug + '-' + designId + '.svg', { type: 'image/svg+xml' });
        }),
        previews: sideIdx.map(function (i) { return new File([dataUrlBytes(previews[i])], (i ? 'back' : 'front') + '-preview-' + sizeSlug + '.jpg', { type: 'image/jpeg' }); }),
        originals: done.orig
      };
      return files;
    });
  }
  // Original logo files: from this visit (ORIGINALS) or, for a saved design opened again, from Shopify Files.
  function fileIdsIn(sideIdx) {
    var ids = [];
    sideIdx.forEach(function (i) { ((state.sides[i] && state.sides[i].json.objects) || []).forEach(function walk(o) { if (o.fspFile && ids.indexOf(o.fspFile) < 0) { ids.push(o.fspFile); } (o.objects || []).forEach(walk); }); });
    return ids;
  }
  function originalsUsed(sideIdx) {
    return Promise.all(fileIdsIn(sideIdx).map(function (id) {
      if (ORIGINALS[id]) { return ORIGINALS[id]; }
      var l = SAVE.links[id];
      if (!l || !l.url) { return null; }
      return fetch(l.url).then(function (r) { if (!r.ok) { throw new Error('HTTP ' + r.status); } return r.blob(); })
        .then(function (b) { ORIGINALS[id] = new File([b], l.name || 'logo', { type: l.type || b.type }); return ORIGINALS[id]; })
        .catch(function () { return null; });
    })).then(function (list) { return list.filter(Boolean); });
  }

  /* ---------- cart ---------- */
  var statusTimer;
  function status(msg, warn) {
    var s = $('fspd-status'); s.textContent = msg; s.classList.toggle('is-warn', !!warn);
    clearTimeout(statusTimer);
    s.classList.toggle('is-show', !!msg);
    if (msg && !/…$/.test(msg)) { statusTimer = setTimeout(function () { s.classList.remove('is-show'); }, warn ? 9000 : 6000); }
  }
  function sideHasContent(side) { return !!(side && side.json && side.json.objects && side.json.objects.length > 0); }
  function slug(s) { return String(s).replace(/"/g, 'in').replace(/[^a-z0-9]+/gi, '-').replace(/^-|-$/g, '').toLowerCase(); }
  function printNote(r, nOrig) {
    var parts = ['PDF: vector, text outlined', 'SVG: live text for edits', 'invisible cut path on trim'];
    if (r.images) { parts.push(r.images + ' uploaded image' + (r.images > 1 ? 's' : '') + ' placed at original resolution'); }
    if (r.scale && r.scale < 1) { parts.unshift('HALF SCALE: the PDF is 50% of full size, print at 200%'); }
    if (KIND === 'cnc') { parts.unshift('CNC CUT FILE: every shape is a cut piece (outlines, no background)'); }
    else if (MONO.on) { parts.unshift('ONE COLOR: ' + (KIND === 'plaque' ? 'raised letters and shapes' : 'engrave paths') + ' only, no background drawn; colors ' + MONO.scheme.label); }
    if (r.fallback) { parts.push(r.fallback + ' item' + (r.fallback > 1 ? 's' : '') + ' placed as ' + (r.fallbackDpi || FALLBACK_DPI) + ' dpi image'); }
    if (r.placeholders) { parts.push('LOGO PLACEHOLDER: set the customer’s attached logo file before proof'); }
    if (nOrig) { parts.push(nOrig + ' original logo file' + (nOrig > 1 ? 's' : '') + ' attached'); }
    return parts.join(', ');
  }

  var checksShown = '';
  function addToCart() {
    ensureSign();
    saveCurrent();
    if (!sideHasContent(state.sides[0])) { status('Add something to the front of the sign first.', true); return; }
    var missing = ['fspd-ok', 'fspd-rights'].filter(function (id) { return !$(id).checked; });
    ['fspd-ok', 'fspd-rights'].forEach(function (id) { $(id).closest('.fspd-check').classList.toggle('is-missing', missing.indexOf(id) >= 0); });
    if (missing.length) { $(missing[0]).closest('.fspd-check').scrollIntoView({ block: 'center', behavior: 'smooth' }); }
    if (!$('fspd-ok').checked) { status(TWO_SIDED ? 'Please tick the box to confirm you checked both sides.' : 'Please tick the box to confirm you checked your design.', true); return; }
    if (!$('fspd-rights').checked) { status('Please tick the box to confirm you have the rights to use everything in your design.', true); return; }
    var btn = $('fspd-cart'); btn.disabled = true;
    allChecks().then(function (list) {
      var sig = list.join('|');
      showChecks(list);
      if (list.length && checksShown !== sig) {
        checksShown = sig; btn.disabled = false; btn.textContent = 'Looks good, add to cart';
        status('Please look over the notes above. Fix anything you need to, or click the button again to order as is.', true);
        return null;
      }
      btn.textContent = 'Add to cart';
      return send(btn);
    }).catch(function (e) { btn.disabled = false; status('Sorry, something went wrong: ' + e.message, true); });
  }
  // One cart line: the sign, or the rider that goes in its frame. Same properties and order as before for the sign.
  function cartForm(files, o, withOriginals) {
    var fd = new FormData();
    fd.append('id', o.variantId);
    fd.append('quantity', o.qty);
    fd.append('properties[Size]', o.size);
    if (o.back) { fd.append('properties[Back side]', o.back); }
    Object.keys(o.visible || {}).forEach(function (k) { fd.append('properties[' + k + ']', o.visible[k]); });
    fd.append('properties[Front preview]', files.previews[0]);
    if (files.previews[1]) { fd.append('properties[Back preview]', files.previews[1]); }
    fd.append('properties[_Print file PDF (outlined)]', files.pdf);
    fd.append('properties[_Editable front (SVG)]', files.svg[0]);
    if (files.svg[1]) { fd.append('properties[_Editable back (SVG)]', files.svg[1]); }
    if (withOriginals) { files.originals.forEach(function (f, k) { fd.append('properties[_Customer logo ' + (k + 1) + ' (original)]', f); }); }
    fd.append('properties[_Print size]', o.printSize);
    fd.append('properties[_Print notes]', printNote(files.report, withOriginals ? files.originals.length : 0) + (!withOriginals && files.originals.length ? ', ORIGINAL LOGO FILE COULD NOT BE ATTACHED: ask the customer to email it' : ''));
    fd.append('properties[_Rights confirmed]', 'Yes, ' + new Date().toISOString());
    fd.append('properties[_Design ID]', files.designId);
    Object.keys(o.hidden || {}).forEach(function (k) { fd.append('properties[' + k + ']', o.hidden[k]); });
    fd.append('properties[_Designer]', VERSION);
    return fd;
  }
  function postCart(files, o) {
    var go = function (withOriginals) {
      return fetch('/cart/add.js', { method: 'POST', body: cartForm(files, o, withOriginals), headers: { 'Accept': 'application/json' } })
        .then(function (res) { return res.json().then(function (j) { if (!res.ok) { var e = new Error(j.description || j.message || ('HTTP ' + res.status)); e.status = res.status; throw e; } return j; }); });
    };
    // a logo file type Shopify won't take: order without it, flag it for staff
    return go(true).catch(function (e) { if (files.originals.length && e.status && e.status < 500) { return go(false); } throw e; });
  }
  function send(btn) {
    status('Building your print file… this can take a few seconds.');
    var files, rfiles = null, signIn = false, qty = Math.max(1, parseInt($('fspd-qty').value, 10) || 1);
    return buildFor('sign').then(function (f) {
      files = f;
      if (!riderOrdered()) { return null; }
      status('Building the rider’s print file…');
      return buildFor('rider').then(function (r) { rfiles = r; });
    }).then(function () {
      status('Uploading your design…');
      var hidden = {};
      if (SAVE.saved) { hidden['_Saved design'] = SAVE.saved.id + ' (' + SAVE.saved.name + ')'; }
      if (rfiles) { hidden['_Paired rider design'] = rfiles.designId; }
      return postCart(files, {
        variantId: files.variant.id, qty: qty, printSize: files.printSize, hidden: hidden,
        size: PROFILE.custom ? 'Work area ' + CUSTOM_SIZE.w + '"W x ' + CUSTOM_SIZE.h + '"H' : SIZE_OPT >= 0 && OPT_SELECTS ? optVal(files.variant, SIZE_OPT) : (parseSize(files.variant.title) ? files.variant.title : (function (z) { return z.w + '"W x ' + z.h + '"H'; })(sizeOf(files.variant))),
        back: TWO_SIDED ? (files.sides > 1 ? 'Designed' : 'Blank') : null,
        visible: modeCartProps(qty)
      });
    }).then(function () {
      signIn = true;
      if (!rfiles) { return null; }
      status('Adding the rider…');
      return postCart(rfiles, {
        variantId: rfiles.variant.id, qty: qty, size: rfiles.variant.title, printSize: rfiles.printSize,
        back: RIDER.backCustom ? 'Designed' : 'Mirror of the front (arrows flipped)',
        visible: { 'For the frame': 'Goes in the rider slot of the ' + variantLabel(files.variant) + ' framed sign' },
        hidden: { '_Paired sign design': files.designId }
      });
    }).then(function () {
      status('Added to your cart. Taking you there…');
      try { localStorage.removeItem(DRAFT_KEY); } catch (e) { }
      window.FSPD_LAST_FILES = files; window.FSPD_LAST_RIDER_FILES = rfiles;
      if (!window.FSPD_NO_REDIRECT) { window.location.href = '/cart'; }
      btn.disabled = false;
    }).catch(function (e) {
      btn.disabled = false;
      if (signIn && rfiles) { status('Your sign is in your cart, but the rider didn’t go through (' + e.message + '). Please call us and we’ll add it.', true); }
      else { status('Sorry, that didn’t go through: ' + e.message + '. Please try again or call us.', true); }
      window.FSPD_LAST_ERROR = e;
    });
  }

  /* ---------- reorder: ?design=<cdn link to an order's front SVG> ---------- */
  function loadDesignFrom(url) {
    var u; try { u = new URL(url, location.href); } catch (e) { return Promise.reject(new Error('bad link')); }
    if (!/(^|\.)shopify\.com$|^floridiansigns\.com$/.test(u.hostname)) { return Promise.reject(new Error('that link isn’t one of ours')); }
    return fetch(u.href).then(function (r) { if (!r.ok) { throw new Error('HTTP ' + r.status); } return r.text(); }).then(function (t) {
      var m = /<metadata id="fsp-design"><!\[CDATA\[([\s\S]*?)\]\]><\/metadata>/.exec(t);
      var rec = JSON.parse(m ? m[1].replace(/\]\]\]\]><!\[CDATA\[>/g, ']]>') : t);
      if (!rec.sides) { throw new Error('no design in that file'); }
      return rec;
    });
  }
  function applyRecord(rec) {
    restoreMode(rec.options);
    state.sides = [null, null];
    rec.sides.forEach(function (s) { state.sides[s.name === 'Back' ? 1 : 0] = { json: s.fabric_json, ppi: s.canvas.ppi, wpx: s.canvas.wpx, hpx: s.canvas.hpx }; });
    state.hist = [{ stack: [], idx: -1 }, { stack: [], idx: -1 }];
    var vid = rec.product && rec.product.variant_id;
    state.current = 0;
    root.querySelectorAll('.fspd-tab[data-side]').forEach(function (b) { b.classList.toggle('is-on', Number(b.dataset.side) === 0); });
    setSize(VARIANTS.some(function (v) { return String(v.id) === String(vid); }) ? vid : (state.variant || VARIANTS[0]).id, true);
    riderFromRecord(rec.rider);
  }

  /* ---------- saved designs (service behind floridiansigns.com/apps/fsp; hidden if it isn't installed) ---------- */
  function saveSession(force) {
    if (!force && SAVE.sess && (!SAVE.sess.customer || Date.now() < SAVE.sess.until)) { return Promise.resolve(SAVE.sess); }
    return fetch(SAVE.proxy + '/session', { credentials: 'same-origin', cache: 'no-store', headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok || !/json/.test(r.headers.get('content-type') || '')) { throw new Error('saving isn’t available right now'); } return r.json(); })
      .then(function (s) {
        if (!s || !s.ok || !s.api) { throw new Error('saving isn’t available right now'); }
        s.until = Date.now() + (s.hours || 4) * 3600e3 - 300e3; SAVE.sess = s; return s;
      });
  }
  function saveApi(method, path, body, raw, retried) {
    return saveSession().then(function (s) {
      if (!s.customer) { var e = new Error('please sign in'); e.signin = true; throw e; }
      var h = { 'Authorization': 'Bearer ' + s.token };
      if (body && !raw) { h['Content-Type'] = 'application/json'; }
      return fetch(s.api + path, { method: method, headers: h, body: raw ? body : (body ? JSON.stringify(body) : undefined) });
    }).then(function (r) {
      return r.json().catch(function () { return {}; }).then(function (j) {
        if (r.status === 401) {
          SAVE.sess = null;
          if (!retried) { return saveApi(method, path, body, raw, true); }
          var e = new Error('please sign in again'); e.signin = true; throw e;
        }
        if (!r.ok) { throw new Error(j.error || ('error ' + r.status)); }
        return j;
      });
    });
  }
  function strKey(str) { var h = 0; for (var i = 0; i < str.length; i++) { h = (h * 31 + str.charCodeAt(i)) >>> 0; } return str.length + ':' + h; }
  var SAVE_TYPES = /\.(png|jpe?g|webp|gif|svg|pdf|eps|ai)$/i;
  function uploadBlob(blob, name) { return saveApi('POST', '/api/files?name=' + encodeURIComponent(name), blob, true); }
  // Copy of both sides with every embedded picture replaced by its Shopify Files link (uploaded once per picture).
  function prepareSides(used, src) {
    var sides = JSON.parse(JSON.stringify(src || state.sides)), jobs = [];
    sides.forEach(function (sd) {
      if (!sd) { return; }
      (sd.json.objects || []).forEach(function walk(o) {
        if (o.type === 'image' && /^data:image\//.test(o.src || '')) { jobs.push(o); }
        (o.objects || []).forEach(walk);
      });
    });
    return jobs.reduce(function (p, o) {
      return p.then(function () {
        var k = strKey(o.src), hit = SAVE.srcMap[k];
        var go = hit ? Promise.resolve(hit) : (function () {
          var mime = (/^data:([^;,]+)/.exec(o.src) || [])[1] || 'image/png', ext = mime === 'image/jpeg' ? 'jpg' : (mime.split('/')[1] || 'png');
          return uploadBlob(new Blob([dataUrlBytes(o.src)], { type: mime }), slug(o.fspName || 'picture') + '.' + ext).then(function (f) { SAVE.srcMap[k] = f; return f; });
        })();
        return go.then(function (f) { o.src = f.url; o.crossOrigin = 'anonymous'; used.push(f.id); });
      });
    }, Promise.resolve()).then(function () { return sides; });
  }
  function prepareOriginals(used) {
    var links = {}, ids = fileIdsIn([0, 1]);
    return ids.reduce(function (p, id) {
      return p.then(function () {
        if (SAVE.links[id]) { links[id] = SAVE.links[id]; used.push(SAVE.links[id].file_id); return; }
        var f = ORIGINALS[id];
        if (!f || !SAVE_TYPES.test(f.name || '')) { return; }
        return uploadBlob(f, f.name).then(function (r) { SAVE.links[id] = links[id] = { file_id: r.id, url: r.url, name: f.name, type: f.type }; used.push(r.id); });
      });
    }, Promise.resolve()).then(function () { return links; });
  }
  function firstWords() {
    var ss = signSides(), t = ((ss[0] && ss[0].json.objects) || []).filter(function (o) { return /text/.test(o.type) && o.text; })[0];
    return t ? String(t.text).split('\n')[0].trim().slice(0, 40) : '';
  }
  function defaultName() { return SAVE.saved ? SAVE.saved.name : ((firstWords() || PRODUCT.title) + ' – ' + variantLabel(signVariant())).slice(0, 80); }
  function setSaved(saved, links) {
    SAVE.saved = saved; if (links) { SAVE.links = links; }
    var lbl = $('fspd-saved-name');
    if (lbl) { lbl.textContent = saved ? 'Saved design: “' + saved.name + '”' : ''; }
    if ($('fspd-save-new')) { $('fspd-save-new').hidden = !saved; }
    if ($('fspd-save-go')) { $('fspd-save-go').textContent = saved ? 'Save changes' : 'Save'; }
    try {
      var u = new URL(location.href);
      if (saved) { u.searchParams.set('saved', saved.id); } else { u.searchParams.delete('saved'); }
      u.searchParams.delete('fspd_save');
      history.replaceState(null, '', u.pathname + u.search + u.hash);
    } catch (e) { }
  }
  function saveMsg(m, warn) { var e = $('fspd-save-msg'); if (e) { e.textContent = m; e.style.color = warn ? '#b42318' : ''; } }
  function openSaveBox() {
    saveCurrent();
    if (!sideHasContent(signSides()[0]) && !sideHasContent(signSides()[1])) { status('Add something to your sign first, then save it.', true); return; }
    $('fspd-savebox').hidden = false; $('fspd-save-name').value = defaultName(); $('fspd-save-name').focus(); $('fspd-save-name').select();
    saveMsg(SAVE.sess && SAVE.sess.customer ? '' : 'You’ll be asked to sign in to your account (or create one) so you can open it again on any device.');
  }
  function loginUrl(back) { return SAVE.login + (SAVE.login.indexOf('?') < 0 ? '?' : '&') + 'return_url=' + encodeURIComponent(back) + '&return_to=' + encodeURIComponent(back); }
  function signIn(asNew) {
    SAVE.pending = { asNew: !!asNew };
    var w = null;
    try { w = window.open(loginUrl(SAVE.proxy + '/signed-in'), 'fspd-signin'); } catch (e) { }
    if (w) { saveMsg('Please sign in on the tab that just opened. Your design will save as soon as you’re signed in.'); return; }
    // pop-up blocked: sign in on this page and come back (the draft is kept in this browser)
    autosave();
    var here = new URL(location.href); here.searchParams.set('fspd_save', asNew ? 'new' : '1');
    setTimeout(function () { location.href = loginUrl(here.pathname + here.search); }, 400);
  }
  function signedInAgain() {
    if (!SAVE.pending) { return; }
    saveSession(true).then(function (s) {
      if (!s.customer || !SAVE.pending) { return; }
      var p = SAVE.pending; SAVE.pending = null; doSave(p.asNew);
    }, function () { });
  }
  function doSave(asNew) {
    if (SAVE.busy) { return; }
    ensureSign();
    saveCurrent();
    var name = ($('fspd-save-name').value || '').trim() || defaultName();
    // not signed in (known from the page-load check): open the sign-in tab now, inside the click, so pop-up blockers allow it
    if (SAVE.sess && !SAVE.sess.customer) { signIn(asNew); return; }
    SAVE.busy = true; $('fspd-save-go').disabled = $('fspd-save-new').disabled = true;
    saveMsg('Saving…');
    var used = [], body;
    saveSession(true).then(function (s) {
      if (!s.customer) { var e = new Error('please sign in'); e.signin = true; throw e; }
      return prepareSides(used, state.sides);
    }).then(function (sides) {
      body = {
        name: name,
        product: { handle: PRODUCT.handle, title: PRODUCT.title, variant_id: state.variant.id, size_label: variantLabel(state.variant) },
        record: {
          v: 1, designer_version: VERSION, saved_at: new Date().toISOString(),
          product: { product_id: PRODUCT.id, handle: PRODUCT.handle, variant_id: state.variant.id, size_label: variantLabel(state.variant) },
          sides: [0, 1].filter(function (i) { return sides[i] && (i === 0 || sideHasContent(sides[i])); }).map(function (i) { var sd = sides[i]; return { name: i ? 'Back' : 'Front', canvas: { wpx: sd.wpx, hpx: sd.hpx, ppi: sd.ppi }, fabric_json: sd.json }; })
        }
      };
      return riderForSave(used).then(function (r) { if (r) { body.record.rider = r; } return prepareOriginals(used); });
    }).then(function (links) {
      body.originals = links;
      return withSideCanvas(sideHasContent(state.sides[0]) ? 0 : 1, function (tmp) { return tmp.toDataURL({ format: 'jpeg', quality: 0.85, multiplier: Math.min(2, 640 / state.wpx) }); });
    }).then(function (jpg) {
      return uploadBlob(new Blob([dataUrlBytes(jpg)], { type: 'image/jpeg' }), 'preview.jpg');
    }).then(function (thumb) {
      body.thumbnail_id = thumb.id; used.push(thumb.id); body.file_ids = used;
      return SAVE.saved && !asNew ? saveApi('PUT', '/api/designs/' + SAVE.saved.id, body) : saveApi('POST', '/api/designs', body);
    }).then(function (r) {
      setSaved({ id: String(r.id), name: r.name || name }); SAVE.dirty = false;
      autosave();
      $('fspd-savebox').hidden = true;
      status('Saved to your account as “' + (r.name || name) + '”. Find it any time under My saved designs.');
    }).catch(function (e) {
      if (e.signin) { signIn(asNew); return; }
      saveMsg('Sorry, that didn’t save: ' + e.message + '.', true);
    }).then(function () { SAVE.busy = false; $('fspd-save-go').disabled = $('fspd-save-new').disabled = false; });
  }
  function openSaved(id) {
    status('Opening your saved design…');
    return saveSession().then(function (s) {
      if (!s.customer) { var e = new Error('please sign in'); e.signin = true; throw e; }
      return saveApi('GET', '/api/designs/' + encodeURIComponent(id));
    }).then(function (d) {
      if (d.product_handle && PRODUCT.handle && d.product_handle !== PRODUCT.handle) {
        location.replace('/products/' + encodeURIComponent(d.product_handle) + '?view=fsp-designer' + (d.variant_id ? '&variant=' + encodeURIComponent(d.variant_id) : '') + '&saved=' + encodeURIComponent(d.id));
        return;
      }
      if (!d.record || !d.record.sides) { throw new Error('that design is empty'); }
      ORIGINALS = {};
      applyRecord(d.record);
      setSaved({ id: String(d.id), name: d.name }, d.originals || {}); SAVE.dirty = false;
      $('fspd-draft').hidden = true;
      status('“' + d.name + '” is open. Change anything you need, then save or add it to your cart.');
    }).catch(function (e) {
      if (e.signin) {
        status('Please sign in to open your saved design.', true);
        var b = el('button', 'fspd-link', 'Sign in'); b.type = 'button';
        b.onclick = function () { location.href = loginUrl(location.pathname + location.search); };
        $('fspd-status').appendChild(document.createTextNode(' ')); $('fspd-status').appendChild(b);
        return;
      }
      status('We couldn’t open that saved design (' + e.message + '). Please try again from My saved designs, or call us.', true);
    });
  }
  function initSaving(savedId, resumeSave) {
    if (!SAVE.on || !$('fspd-savebar')) { return Promise.resolve(); }
    return saveSession().then(function () {
      $('fspd-savebar').hidden = false;
      $('fspd-save').addEventListener('click', openSaveBox);
      $('fspd-save-go').addEventListener('click', function () { doSave(false); });
      $('fspd-save-new').addEventListener('click', function () { doSave(true); });
      $('fspd-save-cancel').addEventListener('click', function () { $('fspd-savebox').hidden = true; SAVE.pending = null; });
      $('fspd-save-name').addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); doSave(false); } });
      try { var bc = new BroadcastChannel('fspd'); bc.onmessage = function (m) { if (m.data && m.data.type === 'signed-in') { signedInAgain(); } }; } catch (e) { }
      window.addEventListener('focus', signedInAgain);
      window.addEventListener('storage', function (e) { if (e.key === 'fspd:signed-in') { signedInAgain(); } });
      setSaved(SAVE.saved, SAVE.links);
      if (savedId) { return openSaved(savedId); }
      if (resumeSave && SAVE.sess.customer) { openSaveBox(); doSave(resumeSave === 'new'); }
    }, function () { /* service not installed: saving stays hidden */ });
  }

  /* ---------- wiring ---------- */
  buildOptionSelects();
  buildSwatches('fill', $('fspd-fill-sw'), function (c) { var o = canvas.getActiveObject(); if (o) { setObjColor(o, c); canvas.requestRenderAll(); commit(); } });
  buildSwatches('outline', $('fspd-outline-sw'), function (c) {
    applyToActive(function (o) {
      if (!isText(o)) { return; }
      if (c === 'none') { o.set({ stroke: null, strokeWidth: 0 }); $('fspd-outline-w').value = 0; return; }
      var w = Number($('fspd-outline-w').value) || 0; if (!w) { w = 8; $('fspd-outline-w').value = 8; }
      o.set({ stroke: c, strokeWidth: o.fontSize * w / 100, paintFirst: 'stroke', strokeLineJoin: 'round' });
    });
  }, true);
  buildSwatches('bg', $('fspd-bg-sw'), function (c) { canvas.backgroundColor = c === 'none' ? '#ffffff' : c; canvas.requestRenderAll(); commit(); });
  setSwatchValue('fill', '#000000'); setSwatchValue('bg', '#ffffff');

  if (!TWO_SIDED) { root.classList.add('is-one-sided'); }
  if (IS_BANNER) {
    root.classList.add('is-banner');
    var redKey = $('fspd-key-red'); if (redKey) { redKey.textContent = 'The edge of the banner is the red line'; }
    var bn = $('fspd-banner-note'); if (bn) { bn.hidden = false; }
    var sub = root.querySelector('.fspd-sub'); if (sub) { sub.textContent = 'Make your banner in 4 easy steps. No design experience needed.'; }
    var blank = $('fspd-blank'); if (blank) { blank.textContent = 'Start with a blank banner instead'; }
    var pe = root.querySelector('.fspd-props-empty'); if (pe) { pe.innerHTML = '&#128161; Click (or tap) any words or picture on the banner. Buttons to change its size, color and font will show up here.'; }
  }
  root.querySelectorAll('.fspd-tab[data-side]').forEach(function (b) { b.addEventListener('click', function () { switchSide(Number(b.dataset.side)); }); });
  $('fspd-copy').addEventListener('click', function () { copyFront(false); });
  $('fspd-mirror').addEventListener('click', function () { copyFront(true); });
  $('fspd-undo').addEventListener('click', function () { undoRedo(-1); });
  $('fspd-redo').addEventListener('click', function () { undoRedo(1); });
  $('fspd-startover').addEventListener('click', function () {
    var b = $('fspd-startover');
    if (!b.classList.contains('is-armed')) { b.classList.add('is-armed'); b.textContent = 'Click again to clear both sides'; setTimeout(function () { b.classList.remove('is-armed'); b.textContent = 'Start over'; }, 4000); return; }
    b.classList.remove('is-armed'); b.textContent = 'Start over'; startOver();
  });
  $('fspd-draft-clear').addEventListener('click', startOver);
  $('fspd-add-text').addEventListener('click', addText);
  $('fspd-text').addEventListener('keydown', function (e) { if (e.key === 'Enter' && (e.ctrlKey || e.metaKey)) { e.preventDefault(); addText(); } });
  root.querySelectorAll('[data-shape]').forEach(function (b) { b.addEventListener('click', function () { addShape(b.dataset.shape); }); });
  $('fspd-upload').addEventListener('change', function (e) { upload(e.target.files[0]); e.target.value = ''; });
  $('fspd-qr-add').addEventListener('click', addQr);
  $('fspd-qr').addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); addQr(); } });
  var clipOpened = false;
  $('fspd-sec-clip').addEventListener('toggle', function () { if (this.open && !clipOpened) { clipOpened = true; renderClipart(); } });
  $('fspd-clip-cat').addEventListener('change', function () { $('fspd-clip-q').value = ''; renderClipart(); });
  var clipQ; $('fspd-clip-q').addEventListener('input', function () { clearTimeout(clipQ); clipQ = setTimeout(function () { renderClipart($('fspd-clip-q').value); }, 200); });
  if (AI.url) {
    $('fspd-ai-go').addEventListener('click', aiAsk); $('fspd-ai-next').addEventListener('click', aiNext);
    var aiHealth = /\/design$/.test(AI.url) ? AI.url.replace(/\/design$/, '/healthz') : null;
    if (!aiHealth || window.FSPD_AI_FORCE) { $('fspd-sec-ai').hidden = false; }
    else { fetch(aiHealth).then(function (r) { return r.json(); }).then(function (j) { if (j && j.ai) { $('fspd-sec-ai').hidden = false; } }).catch(function () { }); }
  }

  $('fspd-font').addEventListener('change', function () {
    var f = $('fspd-font').value, o = canvas.getActiveObject();
    status('Loading ' + f + '…');
    ensureFont(f).then(function () {
      status('');
      if (isText(o) && canvas.getObjects().indexOf(o) >= 0) {
        var c = o.getCenterPoint();
        o.set('fontFamily', f);
        if (FONTS[f].weights.indexOf(700) < 0) { o.set('fontWeight', 'normal'); }
        o.initDimensions(); if (o.fspCurve) { setCurve(o, o.fspCurve); } else { o.setPositionByOrigin(c, 'center', 'center'); }
        o.setCoords(); canvas.requestRenderAll(); checkSafe(); commit();
      }
    }, function (e) { status('That font didn’t load (' + e.message + '). Please try again.', true); });
  });
  $('fspd-bold').addEventListener('click', function () {
    applyToActive(function (o) {
      if (!isText(o)) { return; }
      if (FONTS[o.fontFamily] && FONTS[o.fontFamily].weights.indexOf(700) < 0) { status(o.fontFamily + ' comes in one weight only.', true); return; }
      o.set('fontWeight', weightOf(o) === 700 ? 'normal' : '700'); o.initDimensions(); if (o.fspCurve) { setCurve(o, o.fspCurve); }
    });
  });
  root.querySelectorAll('.fspd-align').forEach(function (b) {
    b.addEventListener('click', function () { applyToActive(function (o) { if (isText(o)) { o.set('textAlign', b.dataset.align); if (o.fspCurve) { setCurve(o, o.fspCurve); } } }); syncProps(); });
  });
  var live = function (id, fn) { $(id).addEventListener('input', function () { var o = canvas.getActiveObject(); if (isText(o)) { fn(o, Number($(id).value)); o.setCoords(); canvas.requestRenderAll(); checkSafe(); } }); $(id).addEventListener('change', commit); };
  live('fspd-spacing', function (o, v) { var c = o.getCenterPoint(); o.set('charSpacing', v); o.initDimensions(); if (o.fspCurve) { setCurve(o, o.fspCurve); } else { o.setPositionByOrigin(c, 'center', 'center'); } });
  live('fspd-leading', function (o, v) { var c = o.getCenterPoint(); o.set('lineHeight', v); o.initDimensions(); o.setPositionByOrigin(c, 'center', 'center'); });
  live('fspd-curve', function (o, v) { setCurve(o, v); });
  live('fspd-outline-w', function (o, v) {
    if (!v) { o.set({ stroke: null, strokeWidth: 0 }); setSwatchValue('outline', 'none'); return; }
    var c = o.stroke || (currentColor('outline') !== 'none' ? currentColor('outline') : '#ffffff');
    o.set({ stroke: c, strokeWidth: o.fontSize * v / 100, paintFirst: 'stroke', strokeLineJoin: 'round' }); setSwatchValue('outline', toHex(c));
  });
  root.querySelectorAll('[data-alignto]').forEach(function (b) { b.addEventListener('click', function () { alignTo(b.dataset.alignto); }); });
  $('fspd-flip').addEventListener('click', function () {
    applyToActive(function (o) {
      if (isText(o)) { status('Text isn’t flipped, so it stays readable. Select the arrow or graphic to flip it.', true); return; }
      if (o.fspType === 'qr') { status('QR codes can’t be flipped or they won’t scan.', true); return; }
      o.set('flipX', !o.flipX);
    });
  });
  $('fspd-forward').addEventListener('click', function () { applyToActive(function (o) { canvas.bringForward(o); }); });
  $('fspd-backward').addEventListener('click', function () { applyToActive(function (o) { canvas.sendBackwards(o); }); });
  $('fspd-front').addEventListener('click', function () { applyToActive(function (o) { canvas.bringToFront(o); }); });
  $('fspd-back').addEventListener('click', function () { applyToActive(function (o) { canvas.sendToBack(o); }); });
  $('fspd-dup').addEventListener('click', duplicate);
  $('fspd-unwhite').addEventListener('click', function () { var o = canvas.getActiveObject(); if (o && o.type === 'image') { removeWhite(o); } });
  $('fspd-trace').addEventListener('click', function () { var o = canvas.getActiveObject(); if (o && o.type === 'image') { traceImage(o); } });
  function del() { var o = canvas.getActiveObject(); if (!o) { return; } (o.type === 'activeSelection' ? o.getObjects() : [o]).forEach(function (x) { canvas.remove(x); }); canvas.discardActiveObject(); canvas.requestRenderAll(); checkSafe(); syncProps(); }
  $('fspd-del').addEventListener('click', del);
  document.addEventListener('keydown', function (e) {
    var o = canvas.getActiveObject(), typing = /INPUT|TEXTAREA|SELECT/.test(document.activeElement.tagName) || (o && o.isEditing);
    if (typing) { return; }
    var k = e.key.toLowerCase(), mod = e.ctrlKey || e.metaKey;
    if (mod && k === 'z') { e.preventDefault(); undoRedo(e.shiftKey ? 1 : -1); return; }
    if (mod && k === 'y') { e.preventDefault(); undoRedo(1); return; }
    if (mod && k === 'd' && o) { e.preventDefault(); duplicate(); return; }
    if ((e.key === 'Delete' || e.key === 'Backspace') && o) { e.preventDefault(); del(); return; }
    if (o && /^arrow/.test(k)) {
      e.preventDefault(); var st = e.shiftKey ? 10 : 1;
      o.set({ left: o.left + (k === 'arrowleft' ? -st : k === 'arrowright' ? st : 0), top: o.top + (k === 'arrowup' ? -st : k === 'arrowdown' ? st : 0) });
      o.setCoords(); canvas.requestRenderAll(); checkSafe(); commit();
    }
  });
  $('fspd-cart').addEventListener('click', addToCart);
  [$('fspd-ok'), $('fspd-rights')].forEach(function (c) { c.addEventListener('change', function () { checksShown = ''; $('fspd-cart').textContent = 'Add to cart'; if (c.checked) { c.closest('.fspd-check').classList.remove('is-missing'); } }); });
  canvas.on('object:modified', function () { checksShown = ''; $('fspd-cart').textContent = 'Add to cart'; });
  var rz, lastW = window.innerWidth; window.addEventListener('resize', function () { clearTimeout(rz); rz = setTimeout(function () { if (state.variant && Math.abs(window.innerWidth - lastW) > 40) { lastW = window.innerWidth; if (SURF === 'rider') { saveCurrent(); layoutCanvas(); loadSideIntoEditor(state.current); } else { setSize(state.variant.id); } } }, 250); });

  // test hooks
  window.FSPD = { canvas: canvas, state: state, setSize: setSize, switchSide: switchSide, copyFront: copyFront, buildFiles: buildFiles, localPath: localPath, otFont: otFont, OT: OT, ensureFont: ensureFont, ensureOutlines: ensureOutlines, FONTS: FONTS, TEMPLATES: TEMPLATES, applyLayout: applyLayout, layoutFor: layoutFor, aspectClass: aspectClass, addShape: addShape, qrGroup: qrGroup, addQr: addQr, loadClipart: loadClipart, clipPath: clipPath, setCurve: setCurve, runChecks: runChecks, undoRedo: undoRedo, commit: commit, addToCart: addToCart, applyRecord: applyRecord, loadDesignFrom: loadDesignFrom, upload: upload, removeWhite: removeWhite, traceImage: traceImage, addObj: addObj, newText: newText, SAVE: SAVE, doSave: doSave, openSaved: openSaved, saveSession: saveSession, defaultName: function () { return defaultName(); }, variantLabel: variantLabel, ready: null };

  /* ================= v0.6: guided steps, words list, help, tour, friendlier checks ================= */
  var GUIDE = { step: 1, words: [], wordBoxes: [] };
  var SAMPLE_RE = /your name|000-000-0000|your street|yourwebsite|your text|your company|your business|call or text/i;
  var PHONE = window.FSPD_PHONE || '(561) 747-2377';
  function store(k, v) { try { if (v === undefined) { return localStorage.getItem(k); } if (v === null) { localStorage.removeItem(k); } else { localStorage.setItem(k, v); } } catch (e) { return null; } }

  /* ---- steps ---- */
  function goStep(n, quiet) {
    n = Math.max(1, Math.min(4, Number(n) || 1));
    GUIDE.step = n;
    root.querySelectorAll('.fspd-panel').forEach(function (p) { p.classList.toggle('is-on', Number(p.dataset.step) === n); });
    root.querySelectorAll('.fspd-step').forEach(function (b) {
      var k = Number(b.dataset.go);
      b.classList.toggle('is-on', k === n); b.classList.toggle('is-done', k < n);
      if (k === n) { b.setAttribute('aria-current', 'step'); } else { b.removeAttribute('aria-current'); }
    });
    root.querySelectorAll('.fspd-next').forEach(function (b) { b.classList.remove('is-pulse'); });
    $('fspd-status').classList.remove('is-show');
    if (n === 2) { renderWords(true); }
    if (n === 4) { review(); }
    if (!quiet) {
      var h = root.querySelector('.fspd-panel.is-on h2');
      if (h) {
        h.focus({ preventScroll: true });
        var r = h.getBoundingClientRect();
        if (r.top < 0 || r.top > window.innerHeight * 0.6) { h.scrollIntoView({ block: 'start', behavior: 'smooth' }); }
      }
    }
  }
  root.querySelectorAll('[data-go]').forEach(function (b) { b.addEventListener('click', function () { goStep(b.dataset.go); }); });
  function setAll(on) {
    root.classList.toggle('is-all', on); $('fspd-all').checked = on; store('fspd:all', on ? '1' : null);
    if (on) { renderWords(true); } else { goStep(GUIDE.step, true); }
  }
  $('fspd-all').addEventListener('change', function () { setAll(this.checked); });

  $('fspd-blank').addEventListener('click', function () {
    var go = function () { goStep(2); $('fspd-text').focus(); status('Your sign is blank. Type your words in the box and click “Add these words to the sign”.'); };
    if (!canvas.getObjects().length) { go(); return; }
    var b = $('fspd-blank');
    if (!b.classList.contains('is-armed')) { b.classList.add('fspd-quiet', 'is-armed'); b.textContent = 'Click again to clear this side and start blank'; setTimeout(function () { b.classList.remove('fspd-quiet', 'is-armed'); b.textContent = 'Start with a blank ' + PROFILE.noun + ' instead'; }, 5000); return; }
    b.classList.remove('fspd-quiet', 'is-armed'); b.textContent = 'Start with a blank ' + PROFILE.noun + ' instead';
    canvas.clear(); canvas.backgroundColor = MONO.on ? monoFace() : '#ffffff'; canvas.renderAll(); setSwatchValue('bg', '#ffffff'); syncProps(); commit();
    root.querySelectorAll('.fspd-tpl').forEach(function (x) { x.classList.remove('is-picked'); });
    go();
  });
  function afterTemplate() {
    var nx = root.querySelector('.fspd-panel[data-step="1"] .fspd-next'); if (nx) { nx.classList.add('is-pulse'); }
    if (window.innerWidth < 860) { var st = $('fspd-stage'), r = st.getBoundingClientRect(); if (r.bottom < 60 || r.top > window.innerHeight) { st.scrollIntoView({ block: 'center', behavior: 'smooth' }); } }
  }

  /* ---- step 2: every piece of writing gets its own box ---- */
  function sideName() { return SURF === 'rider' ? (state.current === 1 ? 'back of the rider' : 'rider') : state.current === 1 ? 'back' : 'front'; }
  function textsOnSign() { return canvas.getObjects().filter(isText); }
  // Change the words but keep them where they were: left-lined words keep their left edge, right-lined their right
  // edge, others their center. If the new words would run past the green line, shrink them to fit (never grow).
  function setTextKeepCenter(o, txt) {
    var c = o.getCenterPoint();
    if (o.fspCurve || o.angle) {
      o.set('text', txt);
      if (o.fspCurve) { setCurve(o, o.fspCurve); } else { o.initDimensions(); o.setPositionByOrigin(c, 'center', 'center'); }
      o.setCoords(); canvas.requestRenderAll(); checkSafe(); return;
    }
    var al = o.textAlign === 'left' || o.textAlign === 'right' ? o.textAlign : 'center';
    var b0 = o.getBoundingRect(true, true), ax = al === 'left' ? b0.left : al === 'right' ? b0.left + b0.width : c.x;
    o.set('text', txt); o.initDimensions();
    var m = (BLEED + SAFE) * state.ppi, lo = m, hi = state.wpx - m;
    var room = al === 'left' ? hi - ax : al === 'right' ? ax - lo : 2 * Math.min(ax - lo, hi - ax);
    var maxW = Math.max(room, (hi - lo) * 0.25), w = o.getScaledWidth();
    if (w > maxW && w > 0) { var k = maxW / w; o.set({ scaleX: o.scaleX * k, scaleY: o.scaleY * k }); }
    w = o.getScaledWidth();
    var nx = al === 'left' ? ax + w / 2 : al === 'right' ? ax - w / 2 : ax;
    o.setPositionByOrigin(new fabric.Point(nx, c.y), 'center', 'center');
    o.setCoords(); canvas.requestRenderAll(); checkSafe();
  }
  function renderWords(force) {
    var box = $('fspd-words'); if (!box) { return; }
    if (GUIDE.step !== 2 && !root.classList.contains('is-all')) { GUIDE.words = []; return; }   // rebuilt when Step 2 opens
    var list = textsOnSign();
    var same = !force && list.length === GUIDE.words.length && list.every(function (o, i) { return o === GUIDE.words[i]; });
    var sideEl = $('fspd-words-side');
    if (sideEl) {
      sideEl.textContent = SURF === 'rider'
        ? 'These are the words on the ' + sideName().toUpperCase() + '. To change the sign itself, click “Front side” above it.'
        : 'These are the words on the ' + sideName().toUpperCase() + ' of your sign. To change the other side, click “' + (state.current === 1 ? 'Front side' : 'Back side') + '” above the sign.';
    }
    if (same) {   // just bring the boxes up to date (e.g. someone typed on the sign itself)
      GUIDE.wordBoxes.forEach(function (ta, i) { if (document.activeElement !== ta && ta.value !== list[i].text) { ta.value = list[i].text; } markSample(ta, list[i]); });
      markSelected(); return;
    }
    GUIDE.words = list; GUIDE.wordBoxes = []; box.innerHTML = '';
    if (!list.length) {
      box.appendChild(el('p', 'fspd-words-empty', 'There are no words on the ' + sideName() + ' yet. Type below and click <strong>Add these words to the sign</strong>, or go back to Step 1 and pick a design.'));
      return;
    }
    list.forEach(function (o, i) {
      var wrap = el('div', 'fspd-word'), id = 'fspd-word-' + i;
      var head = el('div', 'fspd-word-head');
      head.innerHTML = '<label for="' + id + '">Words ' + (i + 1) + '<span class="fspd-word-tag" hidden>Put in your own</span></label>';
      var rm = el('button', 'fspd-link fspd-word-rm', 'Remove'); rm.type = 'button'; rm.setAttribute('aria-label', 'Remove words ' + (i + 1));
      head.appendChild(rm);
      var ta = el('textarea'); ta.id = id; ta.rows = Math.min(4, Math.max(1, (o.text || '').split('\n').length)); ta.value = o.text || ''; ta.spellcheck = true;
      wrap.appendChild(head); wrap.appendChild(ta); box.appendChild(wrap);
      GUIDE.wordBoxes.push(ta);
      markSample(ta, o);
      // sample words ("Your Name"): select them all when the box is entered, so whatever you type replaces them
      var selectOnUp = false;
      ta.addEventListener('focus', function () {
        if (SAMPLE_RE.test(ta.value)) { ta.select(); selectOnUp = true; }
        if (canvas.getObjects().indexOf(o) >= 0 && canvas.getActiveObject() !== o) { canvas.setActiveObject(o); canvas.requestRenderAll(); syncProps(); }
      });
      ta.addEventListener('mouseup', function (e) { if (selectOnUp) { selectOnUp = false; if (SAMPLE_RE.test(ta.value)) { e.preventDefault(); ta.select(); } } });
      ta.addEventListener('keydown', function () { selectOnUp = false; });
      ta.addEventListener('input', function () {
        if (canvas.getObjects().indexOf(o) < 0) { return; }
        setTextKeepCenter(o, ta.value || ' ');
        ta.rows = Math.min(4, Math.max(1, ta.value.split('\n').length));
        markSample(ta, o); commit();
      });
      rm.addEventListener('click', function () {
        if (canvas.getObjects().indexOf(o) >= 0) { canvas.remove(o); canvas.discardActiveObject(); canvas.requestRenderAll(); checkSafe(); syncProps(); }
        status('Removed. Click Undo above the sign if you want it back.');
        renderWords(true);
      });
    });
    markSelected();
  }
  function markSample(ta, o) {
    var wrap = ta.closest('.fspd-word'), on = SAMPLE_RE.test(o.text || '');
    wrap.classList.toggle('is-sample', on); wrap.querySelector('.fspd-word-tag').hidden = !on;
  }
  function markSelected() {
    var a = canvas.getActiveObject();
    GUIDE.wordBoxes.forEach(function (ta, i) { ta.closest('.fspd-word').classList.toggle('is-sel', GUIDE.words[i] === a); });
  }
  var wordsTimer;
  canvas.on('after:render', function () {
    if (state.loading || (GUIDE.step !== 2 && !root.classList.contains('is-all'))) { return; }
    clearTimeout(wordsTimer); wordsTimer = setTimeout(function () { renderWords(false); }, 150);
  });
  canvas.on('selection:created', markSelected); canvas.on('selection:updated', markSelected); canvas.on('selection:cleared', markSelected);
  // clicking words on the sign while in step 2 jumps to their box
  canvas.on('mouse:down', function (e) {
    if (GUIDE.step !== 2 || !e.target || !isText(e.target)) { return; }
    var i = GUIDE.words.indexOf(e.target);
    if (i >= 0 && GUIDE.wordBoxes[i]) { GUIDE.wordBoxes[i].closest('.fspd-word').scrollIntoView({ block: 'nearest', behavior: 'smooth' }); }
  });

  /* ---- easy size / position buttons ---- */
  function scaleActive(k) {
    applyToActive(function (o) {
      var c = o.getCenterPoint();
      o.set({ scaleX: o.scaleX * k, scaleY: o.scaleY * k });
      o.setPositionByOrigin(c, 'center', 'center');
    });
  }
  $('fspd-bigger').addEventListener('click', function () { scaleActive(1.12); });
  $('fspd-smaller').addEventListener('click', function () { scaleActive(1 / 1.12); });
  $('fspd-center').addEventListener('click', function () { alignTo('hcenter'); });

  /* ---- quantity stepper ---- */
  var qty = $('fspd-qty');
  function bumpQty(d) { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + d); }
  $('fspd-qty-minus').addEventListener('click', function () { bumpQty(-1); });
  $('fspd-qty-plus').addEventListener('click', function () { bumpQty(1); });
  qty.addEventListener('change', function () { bumpQty(0); });

  /* ---- step 4: picture of each side + plain-English checks with a fix button ---- */
  function sidePicture(i) {
    return withSideCanvas(i, function (tmp) { return tmp.toDataURL({ format: 'png', multiplier: Math.min(1, 360 / state.wpx) }); });
  }
  var reviewRun = 0;
  function review() {
    var run = ++reviewRun, pics = $('fspd-review-pics');
    var shots = [];   // [{url, cap, blank, act}]
    withCtx('sign', function () {
      var sides = TWO_SIDED ? [0, 1] : [0];
      return sides.reduce(function (p, i) {
        return p.then(function () {
          var cap = sides.length > 1 ? (i ? 'Back side' : 'Front side') : 'Your sign';
          if (!sideHasContent(state.sides[i])) { shots.push({ cap: cap, blank: true }); return; }
          return sidePicture(i).then(function (u) { shots.push({ url: u, cap: cap }); });
        });
      }, Promise.resolve());
    }).then(function () {
      if (!RIDER.on || !liveCtx('rider')) { return; }
      return withCtx('rider', function () {
        if (!sideHasContent(state.sides[0])) { shots.push({ cap: 'Rider', blank: true, wide: true }); return; }
        return prepRiderBack().then(function () { return sidePicture(0); }).then(function (u) {
          shots.push({ url: u, cap: 'Rider front', wide: true });
          return sideHasContent(state.sides[1]) ? sidePicture(1) : null;
        }).then(function (u) { if (u) { shots.push({ url: u, cap: RIDER.backCustom ? 'Rider back' : 'Rider back (mirror, made for you)', wide: true, act: true }); } });
      });
    }).then(function () {
      if (run !== reviewRun) { return; }
      pics.innerHTML = '';
      pics.style.gridTemplateColumns = shots.length > 1 ? '' : '1fr';
      shots.forEach(function (s) {
        var f = el('figure', s.wide ? 'is-rider-pic' : null);
        f.innerHTML = (s.url ? '<img alt="' + esc(s.cap) + '" src="' + s.url + '">' : '<div class="is-blank">Blank</div>') + '<figcaption>' + esc(s.cap) + '</figcaption>';
        if (s.act) { var b = el('button', 'fspd-link fspd-sm-link', RIDER.backCustom ? 'Change the rider’s back' : 'Change the rider’s back myself'); b.type = 'button'; b.addEventListener('click', customRiderBack); f.appendChild(b); }
        pics.appendChild(f);
      });
    }).catch(function () { });
    return allChecks().then(function (list) { if (run === reviewRun) { showReview(list); } return list; });
  }
  function fixFor(msg) {
    var rider = /^Rider( back)?: /.test(msg), back = /^(Back|Rider back): /.test(msg), side = back ? 1 : 0;
    if (/rider is still blank/.test(msg)) {
      return [['Design the rider', function () { toSurface('rider', 0); goStep(1); }], ['Don’t add a rider', function () { setRider(false); }]];
    }
    if (rider) {
      if (/sample words|Sample text/.test(msg)) { return [['Change the rider’s words', function () { toSurface('rider', side); goStep(2); }]]; }
      return [['Show me', function () { toSurface('rider', side); $('fspd-stage').scrollIntoView({ block: 'center', behavior: 'smooth' }); }]];
    }
    if (/back of your sign is empty/.test(msg)) {
      return [['Copy the front to the back', function () { ensureSign(); copyFront(false); }], ['Copy & flip arrows', function () { ensureSign(); copyFront(true); }], ['Leave the back blank', null]];
    }
    if (/Sample text/.test(msg)) { return [['Change the words', function () { toSurface('sign', TWO_SIDED ? side : 0); goStep(2); }]]; }
    if (/safe zone|hard to see|letters are about|repeated word|incomplete for a phone/.test(msg)) {
      return [['Show me', function () { toSurface('sign', TWO_SIDED ? side : 0); $('fspd-stage').scrollIntoView({ block: 'center', behavior: 'smooth' }); }]];
    }
    return [];
  }
  function friendly(msg) {
    return msg.replace(/^(Front|Back|Rider|Rider back): /, function (m, s) { return { Front: 'Front side: ', Back: 'Back side: ', Rider: 'Rider: ', 'Rider back': 'Back of the rider: ' }[s]; })
      .replace('Something sits past the green safe zone and may be trimmed off.', 'Something is outside the green dotted line and could get cut off. Move it in a little or make it smaller.')
      .replace(/Sample text is still on the sign: “(.*?)”\. Replace it with your own\./, 'The sample words “$1” are still on the sign. Put in your own.');
  }
  function showReview(list) {
    var box = $('fspd-checks');
    box.hidden = false; box.innerHTML = '';
    box.classList.toggle('is-good', !list.length);
    if (!list.length) { box.innerHTML = '<strong class="fspd-checks-title">&#10004; Looks good!</strong>We didn’t spot any common mistakes. Please still check the spelling, phone number and arrow direction yourself.'; return; }
    box.appendChild(el('strong', 'fspd-checks-title', '&#9888; Please take a look (' + list.length + ')'));
    var ul = el('ul'); box.appendChild(ul);
    list.forEach(function (m) {
      var li = el('li', null, esc(friendly(m))), acts = fixFor(m);
      if (acts.length) {
        var row = el('div', 'fspd-row');
        acts.forEach(function (a) {
          var b = el('button', 'fspd-btn fspd-sm', esc(a[0])); b.type = 'button';
          b.addEventListener('click', function () { if (a[1]) { a[1](); setTimeout(function () { if (GUIDE.step === 4) { review(); } }, 900); } else { li.remove(); } });
          row.appendChild(b);
        });
        li.appendChild(row);
      }
      ul.appendChild(li);
    });
  }
  // the order flow shows its notes in the same friendly box
  showChecks = function (list) { if (list.length) { showReview(list); } };
  $('fspd-recheck').addEventListener('click', function () { review(); });

  /* ---- little "?" tips ---- */
  var openTip = null;
  function closeTip() { if (openTip) { openTip.box.remove(); openTip.btn.setAttribute('aria-expanded', 'false'); openTip = null; } }
  root.querySelectorAll('.fspd-tip').forEach(function (b) {
    b.setAttribute('aria-expanded', 'false'); b.setAttribute('aria-label', 'More information');
    b.addEventListener('click', function (e) {
      e.stopPropagation();
      if (openTip && openTip.btn === b) { closeTip(); return; }
      closeTip();
      var box = el('div', 'fspd-tipbox'); box.setAttribute('role', 'note'); box.textContent = b.dataset.tip;
      document.body.appendChild(box);
      var r = b.getBoundingClientRect(), w = box.offsetWidth;
      var left = Math.max(8, Math.min(window.innerWidth - w - 8, r.left + r.width / 2 - 24));
      box.style.left = (left + window.scrollX) + 'px'; box.style.top = (r.bottom + 10 + window.scrollY) + 'px';
      box.style.setProperty('--ax', Math.max(8, r.left + r.width / 2 - left - 7) + 'px');
      b.setAttribute('aria-expanded', 'true'); openTip = { btn: b, box: box };
    });
  });
  document.addEventListener('click', function (e) { if (openTip && !openTip.box.contains(e.target)) { closeTip(); } });
  window.addEventListener('resize', closeTip);

  /* ---- Help drawer ---- */
  var helpBack = null;
  function openHelp() {
    closeTip(); helpBack = document.activeElement; $('fspd-status').classList.remove('is-show');
    $('fspd-help').hidden = false; document.documentElement.style.overflow = 'hidden';
    $('fspd-help-close').focus();
  }
  function closeHelp() {
    $('fspd-help').hidden = true; document.documentElement.style.overflow = '';
    if (helpBack && helpBack.focus) { helpBack.focus(); }
  }
  $('fspd-help-open').addEventListener('click', openHelp);
  $('fspd-help-close').addEventListener('click', closeHelp);
  $('fspd-help').addEventListener('click', function (e) { if (e.target === this) { closeHelp(); } });
  $('fspd-help-tour').addEventListener('click', function () { closeHelp(); startTour(); });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') { return; }
    if (TOUR.on) { endTour(); } else if (!$('fspd-help').hidden) { closeHelp(); } else { closeTip(); }
  });

  /* ---- chat (the store's Chatway widget, if it's there) ---- */
  function chatReady() { return window.$chatway && typeof window.$chatway.openChatwayWidget === 'function'; }
  function showChat() { if (chatReady()) { $('fspd-chat').hidden = false; } }
  $('fspd-chat').addEventListener('click', function () { try { window.$chatway.openChatwayWidget(); } catch (e) { status('Chat isn’t available right now. Please call ' + PHONE + '.', true); } });
  showChat(); setTimeout(showChat, 3000); setTimeout(showChat, 8000);

  /* ---- first-visit walkthrough ---- */
  var TOUR = { on: false, i: 0, el: null };
  var TOUR_STEPS = [
    { t: '.fspd-steps', h: 'Welcome! Here’s how it works', p: 'Making your sign takes 4 easy steps. Just follow the numbers, 1 to 4. You can go back to any step at any time.' },
    { t: '#fspd-tpl-grid', h: 'Step 1: Pick a design', p: 'Click a design you like and it goes straight onto your sign. Or start with a blank sign.', step: 1 },
    { t: '#fspd-stage', h: 'This is your sign', p: 'What you see here is what we print. Click anything on it to change its size, color or font. Keep words inside the green dotted line.' },
    { t: '.fspd-step[data-go="2"]', h: 'Step 2: Your words', p: 'Type your own words (your name, phone number and so on) into the boxes. The sign changes as you type.' },
    { t: '.fspd-step[data-go="4"]', h: 'Step 4: Check & order', p: 'Before you order, we check your sign for common mistakes, like sample words left on it or something too close to the edge.' },
    { t: '#fspd-help-open', h: 'Help is always here', p: 'Click Help for quick answers, or call us at ' + PHONE + '. We’re happy to help.' }
  ];
  function tourVisible(sel) { var e = root.querySelector(sel) || document.querySelector(sel); return e && e.offsetParent !== null ? e : null; }
  function startTour() {
    if (TOUR.on) { return; }
    closeTip();
    if (root.classList.contains('is-all')) { setAll(false); }
    TOUR.on = true; TOUR.i = 0; TOUR.back = GUIDE.step;
    var wrap = el('div', 'fspd-tour'); wrap.setAttribute('role', 'dialog'); wrap.setAttribute('aria-modal', 'true'); wrap.setAttribute('aria-labelledby', 'fspd-tour-h');
    wrap.innerHTML = '<div class="fspd-tour-hole"></div><div class="fspd-tour-box"><h3 id="fspd-tour-h"></h3><p></p><div class="fspd-tour-foot"><button type="button" class="fspd-link fspd-tour-skip">Skip the tour</button><span class="fspd-tour-count"></span><span class="fspd-tour-btns"><button type="button" class="fspd-btn fspd-sm fspd-tour-prev">&larr; Back</button><button type="button" class="fspd-btn fspd-primary-sm fspd-tour-next">Next &rarr;</button></span></div></div>';
    document.body.appendChild(wrap); TOUR.el = wrap;
    wrap.querySelector('.fspd-tour-skip').addEventListener('click', endTour);
    wrap.querySelector('.fspd-tour-prev').addEventListener('click', function () { showTourStep(TOUR.i - 1); });
    wrap.querySelector('.fspd-tour-next').addEventListener('click', function () { if (TOUR.i >= TOUR_STEPS.length - 1) { endTour(); } else { showTourStep(TOUR.i + 1); } });
    wrap.addEventListener('keydown', function (e) {   // keep keyboard focus inside the tour
      if (e.key !== 'Tab') { return; }
      var f = wrap.querySelectorAll('button:not([disabled])'), first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); } else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
    window.addEventListener('resize', placeTour); window.addEventListener('scroll', placeTour, true);
    showTourStep(0);
  }
  function showTourStep(i) {
    TOUR.i = Math.max(0, Math.min(TOUR_STEPS.length - 1, i));
    var s = TOUR_STEPS[TOUR.i];
    if (s.step && GUIDE.step !== s.step) { goStep(s.step, true); }
    var w = TOUR.el;
    w.querySelector('h3').textContent = s.h; w.querySelector('p').textContent = s.p;
    w.querySelector('.fspd-tour-count').textContent = (TOUR.i + 1) + ' of ' + TOUR_STEPS.length;
    w.querySelector('.fspd-tour-prev').disabled = TOUR.i === 0;
    w.querySelector('.fspd-tour-next').innerHTML = TOUR.i === TOUR_STEPS.length - 1 ? 'Start designing' : 'Next &rarr;';
    var t = tourVisible(s.t);
    if (t) {
      if (t.offsetHeight > window.innerHeight * 0.55) { t.scrollIntoView({ block: 'start', behavior: 'auto' }); window.scrollBy(0, -90); }
      else { t.scrollIntoView({ block: 'center', behavior: 'auto' }); }
    }
    placeTour();
    w.querySelector('.fspd-tour-next').focus();
  }
  function placeTour() {
    if (!TOUR.on) { return; }
    var s = TOUR_STEPS[TOUR.i], t = tourVisible(s.t), hole = TOUR.el.querySelector('.fspd-tour-hole'), box = TOUR.el.querySelector('.fspd-tour-box');
    var vw = window.innerWidth, vh = window.innerHeight, bw = box.offsetWidth, bh = box.offsetHeight;
    if (!t) { hole.style.cssText = 'left:50%;top:50%;width:0;height:0'; box.style.left = Math.max(12, (vw - bw) / 2) + 'px'; box.style.top = Math.max(12, (vh - bh) / 2) + 'px'; return; }
    var r = t.getBoundingClientRect(), pad = 8;
    // tall things (the design list) only get their top part highlighted, so the bubble still fits on screen
    var top = Math.max(4, r.top - pad), left = Math.max(4, r.left - pad), h = Math.min(vh * 0.55, r.bottom + pad - top), wd = Math.min(vw - 8, r.width + pad * 2);
    hole.style.cssText = 'left:' + left + 'px;top:' + top + 'px;width:' + wd + 'px;height:' + h + 'px';
    var below = top + h + 12, above = top - bh - 12, bx = Math.max(12, Math.min(vw - bw - 12, r.left + r.width / 2 - bw / 2)), by;
    if (below + bh < vh - 8) { by = below; } else if (above > 8) { by = above; } else if (r.left - bw - 16 > 8) { by = Math.max(12, Math.min(vh - bh - 12, r.top)); bx = r.left - bw - 16; } else if (r.right + bw + 16 < vw) { by = Math.max(12, Math.min(vh - bh - 12, r.top)); bx = r.right + 16; } else { by = vh - bh - 12; }
    box.style.left = bx + 'px'; box.style.top = by + 'px';
  }
  function endTour() {
    if (!TOUR.on) { return; }
    TOUR.on = false; if (TOUR.el) { TOUR.el.remove(); TOUR.el = null; }
    window.removeEventListener('resize', placeTour); window.removeEventListener('scroll', placeTour, true);
    store('fspd:tour', 'done');
    if (TOUR.back && TOUR.back !== GUIDE.step) { goStep(TOUR.back, true); }
    var h = root.querySelector('.fspd-panel.is-on h2'); if (h) { h.focus({ preventScroll: true }); }
  }
  $('fspd-tour-open').addEventListener('click', startTour);

  /* ---- keep the sign on screen while scrolling the tools (only when it fits) ---- */
  function stickyCheck() {
    var w = $('fspd-stage-wrap'); if (!w) { return; }
    w.classList.toggle('is-sticky', window.innerWidth >= 860 && w.offsetHeight < window.innerHeight - 24);
  }
  var stickyT; function stickySoon() { clearTimeout(stickyT); stickyT = setTimeout(stickyCheck, 60); }
  window.addEventListener('resize', stickySoon);
  canvas.on('selection:created', stickySoon); canvas.on('selection:updated', stickySoon); canvas.on('selection:cleared', stickySoon);
  $('fspd-props').addEventListener('toggle', stickySoon, true);

  window.FSPD.goStep = goStep; window.FSPD.renderWords = renderWords; window.FSPD.review = review; window.FSPD.startTour = startTour; window.FSPD.endTour = endTour;
  window.FSPD.onSide = function () { root.querySelectorAll('.fspd-tab').forEach(function (b) { b.setAttribute('aria-pressed', b.classList.contains('is-on') ? 'true' : 'false'); }); renderWords(true); };
  window.FSPD.afterTemplate = afterTemplate;
  window.FSPD.GUIDE = GUIDE;


  /* ================= v0.6b: a rider for the frame's rider slot =================
     Framed Max Metal signs (24"W x 18"H, 36"W x 24"H) have a slot under the sign for a 6"-tall rider the same width.
     Customers can add the matching Sign Rider (its own product, regular price) and design it on a "Rider" tab.
     The back of the rider is made automatically as a mirror of the front (arrows flipped, layout mirrored), unless
     the customer chooses to change it. The rider goes in the cart as its own line with its own print files. */
  var RIDER_URL = window.FSPD_RIDER_URL || '/products/sign-rider-max-metal.js';
  var RIDER = { product: null, on: false, backCustom: false, ready: Promise.resolve() };
  var SURF = 'sign', CTX = { sign: null, rider: null };
  var CTX_KEYS = ['variant', 'trimW', 'trimH', 'W', 'H', 'ppi', 'wpx', 'hpx', 'sides', 'hist', 'current'];
  function surface() { return SURF; }
  function takeCtx() { var c = {}; CTX_KEYS.forEach(function (k) { c[k] = state[k]; }); return c; }
  function putCtx(c) { CTX_KEYS.forEach(function (k) { state[k] = c[k]; }); }
  function liveCtx(name) { return SURF === name ? takeCtx() : CTX[name]; }
  function signSides() { return SURF === 'rider' && CTX.sign ? CTX.sign.sides : state.sides; }
  function signVariant() { return SURF === 'rider' && CTX.sign ? CTX.sign.variant : state.variant; }
  function riderSides() { var c = liveCtx('rider'); return c ? c.sides : [null, null]; }
  function newHist() { return [{ stack: [], idx: -1 }, { stack: [], idx: -1 }]; }
  // the editor's size for a rider that isn't on screen (same rule as layoutCanvas, no canvas changes)
  function calcDims(c) {
    var s = parseSize(c.variant.title);
    c.trimW = s.w; c.trimH = s.h; c.W = s.w + 2 * BLEED; c.H = s.h + 2 * BLEED;
    var maxW = stageMaxWidth(), maxH = window.innerWidth < 700 ? 360 : Math.max(300, Math.min(480, window.innerHeight - 330));
    var raw = Math.min(maxW / c.W, maxH / c.H);
    c.ppi = raw >= 4 ? Math.floor(raw / 4) * 4 : raw; c.wpx = Math.round(c.W * c.ppi); c.hpx = Math.round(c.H * c.ppi);
    return c;
  }
  function isFramed(v) { return !!v && /frame/i.test(v.title || ''); }
  function frameAlt(v) {
    if (!v || isFramed(v) || SIZE_OPT < 0) { return null; }
    return VARIANTS.filter(function (x) { return isFramed(x) && optVal(x, SIZE_OPT) === optVal(v, SIZE_OPT) && x.available; })[0] || null;
  }
  function riderVariantFor(v) {
    if (!RIDER.product || !v) { return null; }
    var s = parseSize(v.title); if (!s) { return null; }
    return RIDER.product.variants.filter(function (r) { var t = parseSize(r.title); return t && t.w === s.w && t.h === 6 && r.available !== false; })[0] || null;
  }
  function riderOrdered() { var c = liveCtx('rider'); return !!(RIDER.on && c && sideHasContent(c.sides[0]) && riderVariantFor(signVariant())); }

  // Run fn with the sign or the rider "loaded" into state, without touching what's on screen. One at a time.
  var ctxQueue = Promise.resolve();
  function withCtx(name, fn) {
    var run = ctxQueue.then(function () {
      var swap = SURF !== name;
      if (name === 'rider' && !liveCtx('rider')) { return null; }
      saveCurrent();
      if (swap) { state.loading++; CTX[SURF] = takeCtx(); putCtx(CTX[name]); }
      var P = PRODUCT, T = TWO_SIDED;
      if (name === 'rider') { PRODUCT = RIDER.product; TWO_SIDED = true; }
      var done = function () { PRODUCT = P; TWO_SIDED = T; if (swap) { CTX[name] = takeCtx(); putCtx(CTX[SURF]); state.loading--; } };
      return Promise.resolve().then(fn).then(function (r) { done(); return r; }, function (e) { done(); throw e; });
    });
    ctxQueue = run.catch(function () { });
    return run;
  }

  // Put the sign or the rider on screen (and which side of it).
  function toSurface(name, i) {
    i = i || 0;
    if (name === 'rider' && !CTX.rider && SURF !== 'rider') { return; }
    if (name === SURF) { if (i !== state.current) { switchSideCore(i); } updateSurfaceUI(); return; }
    saveCurrent(); CTX[SURF] = takeCtx(); putCtx(CTX[name]); SURF = name;
    state.current = i;
    layoutCanvas(); updateSurfaceUI();
    loadSideIntoEditor(i, function () { if (window.FSPD && FSPD.onSide) { FSPD.onSide(); } });
    renderTemplates();
    canvas.discardActiveObject(); syncProps();
  }
  // Called by setSize: swap back to the sign straight away (the caller reloads the editor). True if we saved.
  function leaveRiderNow() {
    if (SURF !== 'rider') { return false; }
    saveCurrent(); CTX.rider = takeCtx(); putCtx(CTX.sign); SURF = 'sign'; updateSurfaceUI();
    return true;
  }
  function ensureSign() { if (SURF === 'rider') { toSurface('sign', 0); } }

  // The back of the rider: a mirror of the front, arrows and shapes flipped, words kept readable.
  function mirroredSnapshot(side) {
    return new Promise(function (res) {
      var tmp = new fabric.StaticCanvas(null, { width: state.wpx, height: state.hpx });
      loadSide(tmp, side, function () {
        tmp.getObjects().forEach(function (o) {
          var c = o.getCenterPoint();
          o.setPositionByOrigin(new fabric.Point(state.wpx - c.x, c.y), 'center', 'center');
          if (shouldFlip(o)) { o.flipX = !o.flipX; }
          o.setCoords();
        });
        var snap = JSON.parse(JSON.stringify(snapshot(tmp))); tmp.dispose(); res(snap);
      });
    });
  }
  function prepRiderBack() {   // inside withCtx('rider')
    if (RIDER.backCustom || !sideHasContent(state.sides[0])) { return Promise.resolve(); }
    return mirroredSnapshot(state.sides[0]).then(function (b) { state.sides[1] = b; });
  }
  function buildFor(name) {
    return withCtx(name, function () {
      return (name === 'rider' ? prepRiderBack() : Promise.resolve()).then(buildFiles).then(function (f) {
        f.variant = state.variant;
        f.printSize = state.W + ' x ' + state.H + ' in incl. ' + BLEED + ' in bleed (trim ' + state.trimW + ' x ' + state.trimH + ')' +
          (f.pdfScale < 1 ? '. PDF is HALF SCALE (' + (state.W * f.pdfScale) + ' x ' + (state.H * f.pdfScale) + ' in): print at 200%' : '');
        return f;
      });
    });
  }
  function allChecks() {
    return withCtx('sign', function () { return runChecks(); }).then(function (list) {
      if (!RIDER.on) { return list; }
      return withCtx('rider', function () {
        if (!sideHasContent(state.sides[0])) { return ['Rider: The rider is still blank. Design it, or untick “Add a rider sign”.']; }
        return runChecks({ prefix: 'Rider', autoBack: !RIDER.backCustom });
      }).then(function (r) { return list.concat(r || []); });
    });
  }

  /* ---- the offer (Step 1, under the size and add-on) and the order line ---- */
  function riderLine() {
    var line = $('fspd-rider-line'), rv = riderVariantFor(signVariant());
    if (!line) { return; }
    line.hidden = !(RIDER.on && rv);
    if (RIDER.on && rv) { line.innerHTML = '+ <strong>Rider ' + esc(rv.title) + '</strong> for the frame: ' + money(rv.price) + ' each (one with each sign)'; }
  }
  function riderSync() {
    if (SURF !== 'sign') { riderLine(); updateSurfaceUI(); return; }
    var sv = state.variant, rv = riderVariantFor(sv), framed = isFramed(sv), alt = frameAlt(sv);
    var offer = $('fspd-rider-offer'), tip = $('fspd-frame-tip');
    offer.hidden = !(framed && rv);
    if (framed && rv) {
      $('fspd-rider-price').textContent = '+' + money(rv.price) + ' each';
      $('fspd-rider-size').textContent = rv.title;
    }
    var altRider = alt && riderVariantFor(alt);
    tip.hidden = !(alt && altRider);
    if (alt && altRider) {
      tip.innerHTML = '';
      tip.appendChild(el('span', null, '&#128161; Want a frame? The ' + esc(alt.title.split(' / ').filter(function (x) { return /frame/i.test(x); })[0] || 'frame') + ' (' + (alt.price > sv.price ? '+' + money(alt.price - sv.price) : 'same price') + ') holds your sign plus a ' + esc(altRider.title) + ' rider. '));
      var b = el('button', 'fspd-link', 'Add the frame'); b.type = 'button';
      b.addEventListener('click', function () { setSize(alt.id); status('Frame added. You can add a matching rider below the size.'); });
      tip.appendChild(b);
    }
    if (RIDER.on && !(framed && rv)) { RIDER.on = false; $('fspd-rider-on').checked = false; status('The rider was taken off, since this size or option has no rider slot.'); }
    if (RIDER.on && rv && CTX.rider && CTX.rider.variant.id !== rv.id) { CTX.rider.variant = rv; calcDims(CTX.rider); }
    $('fspd-rider-on').checked = RIDER.on;
    riderLine();
    updateSurfaceUI();
  }
  function setRider(on) {
    var rv = riderVariantFor(signVariant());
    if (on && !rv) { return; }
    RIDER.on = !!on;
    if (on) {
      if (!CTX.rider) { CTX.rider = calcDims({ variant: rv, sides: [null, null], hist: newHist(), current: 0 }); }
      else if (CTX.rider.variant.id !== rv.id) { CTX.rider.variant = rv; calcDims(CTX.rider); }
      toSurface('rider', 0);
      if (window.innerWidth < 860) { var sn = $('fspd-surface-note'); if (sn) { setTimeout(function () { sn.scrollIntoView({ block: 'start', behavior: 'smooth' }); }, 50); } }
      status('Rider added. Pick a rider design, then put in your words. Click “Front side” above the sign to go back to the sign.');
    } else {
      if (SURF === 'rider') { toSurface('sign', 0); }
      status('No rider. You can add one again any time.');
    }
    riderSync(); autosave();
  }
  $('fspd-rider-on').addEventListener('change', function () { setRider(this.checked); });
  $('fspd-tab-rider').addEventListener('click', function () { toSurface('rider', 0); });

  function updateSurfaceUI() {
    var r = SURF === 'rider';
    root.classList.toggle('is-rider', r);
    root.querySelectorAll('.fspd-tab[data-side]').forEach(function (b) { var on = !r && Number(b.dataset.side) === state.current; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); });
    var rt = $('fspd-tab-rider'); rt.hidden = !RIDER.on; rt.classList.toggle('is-on', r); rt.setAttribute('aria-pressed', r ? 'true' : 'false');
    var note = $('fspd-surface-note'); note.hidden = !r; if (!r) { return; }
    var rv = state.variant, back = state.current === 1;
    note.innerHTML = '';
    note.appendChild(el('span', null, back
      ? 'You’re changing the <strong>back of the rider</strong> (' + esc(rv.title) + ').'
      : 'You’re designing the <strong>rider</strong> (' + esc(rv.title) + ') that goes in the frame’s slot under your sign. ' +
        (RIDER.backCustom ? 'The back of the rider is your own design.' : 'Its back is made for you as a mirror image, so arrows point the right way. You’ll see it in Step 4.')));
    var row = el('span', 'fspd-surface-acts');
    var add = function (label, fn) { var b = el('button', 'fspd-btn fspd-sm', label); b.type = 'button'; b.addEventListener('click', fn); row.appendChild(b); };
    if (back) { add('Rider front', function () { toSurface('rider', 0); }); }
    else if (RIDER.backCustom) { add('Change the rider’s back', function () { toSurface('rider', 1); }); }
    if (RIDER.backCustom) { add('Make the back automatic again', function () { RIDER.backCustom = false; if (state.current === 1) { toSurface('rider', 0); } else { updateSurfaceUI(); } autosave(); status('The back of the rider will be a mirror of the front again.'); }); }
    add('← Back to the sign', function () { toSurface('sign', 0); });
    note.appendChild(row);
  }
  function customRiderBack() {
    withCtx('rider', function () {
      if (sideHasContent(state.sides[1]) && RIDER.backCustom) { return; }
      return prepRiderBack();
    }).then(function () { RIDER.backCustom = true; toSurface('rider', 1); goStep(2); status('Now change the back of the rider. The front stays as it is.'); autosave(); });
  }

  /* ---- drafts and saved designs carry the rider too ---- */
  function riderDraft() {
    var c = liveCtx('rider');
    if (!c) { return null; }
    return { on: RIDER.on, variant: c.variant && c.variant.id, sides: c.sides, backCustom: RIDER.backCustom };
  }
  function riderRestore(d) {
    if (!d || !RIDER.product) { return; }
    var rv = RIDER.product.variants.filter(function (x) { return String(x.id) === String(d.variant); })[0] || riderVariantFor(signVariant());
    if (!rv) { return; }
    if (SURF === 'rider') { toSurface('sign', 0); }
    CTX.rider = calcDims({ variant: rv, sides: [d.sides && d.sides[0] || null, d.sides && d.sides[1] || null], hist: newHist(), current: 0 });
    RIDER.backCustom = !!d.backCustom;
    RIDER.on = !!d.on;
    riderSync();
  }
  function riderForSave(used) {
    if (!RIDER.on) { return Promise.resolve(null); }
    var c = liveCtx('rider'); if (!c || !sideHasContent(c.sides[0])) { return Promise.resolve(null); }
    return prepareSides(used, c.sides).then(function (sides) {
      return {
        product_id: RIDER.product.id, handle: RIDER.product.handle, variant_id: c.variant.id, size_label: c.variant.title, back_custom: RIDER.backCustom,
        sides: [0, 1].filter(function (i) { return sides[i] && (i === 0 || (RIDER.backCustom && sideHasContent(sides[i]))); }).map(function (i) { var sd = sides[i]; return { name: i ? 'Back' : 'Front', canvas: { wpx: sd.wpx, hpx: sd.hpx, ppi: sd.ppi }, fabric_json: sd.json }; })
      };
    });
  }
  function riderFromRecord(r) {
    return RIDER.ready.then(function () {
      if (!r || !r.sides) { if (RIDER.on || CTX.rider) { RIDER.on = false; CTX.rider = null; RIDER.backCustom = false; riderSync(); } return; }
      var sides = [null, null];
      r.sides.forEach(function (s) { sides[s.name === 'Back' ? 1 : 0] = { json: s.fabric_json, ppi: s.canvas.ppi, wpx: s.canvas.wpx, hpx: s.canvas.hpx }; });
      riderRestore({ on: true, variant: r.variant_id, sides: sides, backCustom: !!r.back_custom });
    });
  }
  function riderInit(draft) {
    if (!VARIANTS.some(isFramed)) { return; }   // only signs that come with a frame option
    RIDER.ready = fetch(RIDER_URL, { headers: { 'Accept': 'application/json' } }).then(function (r) { if (!r.ok) { throw new Error('HTTP ' + r.status); } return r.json(); })
      .then(function (p) { RIDER.product = p.product || p; if (draft && draft.rider) { riderRestore(draft.rider); } riderSync(); })
      .catch(function () { /* no rider product: the offer just doesn't show */ });
  }

  window.FSPD.surface = surface; window.FSPD.toSurface = toSurface; window.FSPD.leaveRiderNow = leaveRiderNow; window.FSPD.riderSync = riderSync;
  window.FSPD.RIDER = RIDER; window.FSPD.CTX = CTX; window.FSPD.setRider = setRider; window.FSPD.allChecks = allChecks; window.FSPD.buildFor = buildFor;
  window.FSPD.withCtx = withCtx; window.FSPD.customRiderBack = customRiderBack; window.FSPD.riderReady = function () { return RIDER.ready; };
  window.FSPD.onSide = function () { updateSurfaceUI(); renderWords(true); };

  /* ---------- product modes: A-frame panels, engraving, cast plaques, CNC letters & shapes ---------- */
  function clampIn(v, lo, hi) { v = Math.round(parseFloat(v) * 4) / 4; return isFinite(v) ? Math.max(lo, Math.min(hi, v)) : lo; }
  function modeState() { return { kind: KIND, size: PROFILE.custom ? { w: CUSTOM_SIZE.w, h: CUSTOM_SIZE.h } : null, scheme: MONO.on && KIND !== 'cnc' ? MONO.scheme.label : null, material: KIND === 'cnc' ? MONO.material[0] : null }; }
  function restoreMode(m) {
    if (!m || m.kind !== KIND) { return; }
    if (m.size && PROFILE.custom) { CUSTOM_SIZE.w = clampIn(m.size.w, 1, 96); CUSTOM_SIZE.h = clampIn(m.size.h, 1, 48); }
    if (m.scheme) { var sc = SCHEMES.filter(function (x) { return x.label === m.scheme; })[0]; if (sc) { MONO.scheme = sc; } }
    if (m.material) { var mt = MATERIALS.filter(function (x) { return x[0] === m.material; })[0]; if (mt) { MONO.material = mt; } }
    syncModeUI();
  }
  // every item in the letter color, the background in the material color
  function applyMono(noCommit) {
    if (!MONO.on) { return; }
    canvas.backgroundColor = monoFace();
    canvas.getObjects().forEach(function (o) { setObjColor(o, monoInk()); if (isText(o) && o.stroke && o.strokeWidth) { o.set('stroke', monoInk()); } });
    canvas.requestRenderAll();
    if (!noCommit) { commit(); }
  }
  canvas.on('object:added', function (e) { if (MONO.on && e.target) { setObjColor(e.target, monoInk()); } });
  // CNC work area and material, engraving colors: shown under the size in Step 1
  function buildCustomSize(box) {
    var row = el('div', 'fspd-custom-size');
    var mk = function (lab, id, val, max) {
      var l = el('label', 'fspd-field fspd-field-num'); l.appendChild(document.createTextNode(lab + ' '));
      var i = el('input'); i.type = 'number'; i.id = id; i.min = 1; i.max = max; i.step = 0.25; i.value = val; i.inputMode = 'decimal';
      l.appendChild(i); row.appendChild(l); return i;
    };
    var w = mk('Width (inches)', 'fspd-cw', CUSTOM_SIZE.w, 96), h = mk('Height (inches)', 'fspd-ch', CUSTOM_SIZE.h, 48);
    box.appendChild(row);
    var hint = el('p', 'fspd-hint', 'Set the area your letters or shapes fit in. The biggest we can cut in one piece is 96" x 48".'); box.appendChild(hint);
    var go = function () {
      var nw = clampIn(w.value, 1, 96), nh = clampIn(h.value, 1, 48);
      w.value = nw; h.value = nh;
      if (nw === CUSTOM_SIZE.w && nh === CUSTOM_SIZE.h) { return; }
      CUSTOM_SIZE.w = nw; CUSTOM_SIZE.h = nh; setSize(VARIANTS[0].id); autosave();
    };
    w.addEventListener('change', go); h.addEventListener('change', go);
    var ml = el('label', 'fspd-field'); ml.appendChild(document.createTextNode('Material '));
    var ms = el('select'); ms.id = 'fspd-material';
    MATERIALS.forEach(function (m) { var o = el('option'); o.value = m[0]; o.textContent = m[0]; ms.appendChild(o); });
    ms.value = MONO.material[0];
    ms.addEventListener('change', function () { MONO.material = MATERIALS.filter(function (x) { return x[0] === ms.value; })[0] || MONO.material; applyMono(); renderTemplates(); autosave(); });
    ml.appendChild(ms); box.appendChild(ml);
  }
  function buildSchemeSelect() {
    if (!MONO.on || KIND === 'cnc') { return; }
    var box = $('fspd-options');
    var l = el('label', 'fspd-field'); l.appendChild(document.createTextNode('Colors '));
    if (SCHEMES.length > 1 && KIND !== 'plaque') {
      var s = el('select'); s.id = 'fspd-scheme';
      SCHEMES.forEach(function (x) { var o = el('option'); o.value = x.label; o.textContent = x.label; s.appendChild(o); });
      s.value = MONO.scheme.label;
      s.addEventListener('change', function () { MONO.scheme = SCHEMES.filter(function (x) { return x.label === s.value; })[0] || MONO.scheme; applyMono(); renderTemplates(); autosave(); });
      l.appendChild(s);
    } else {
      var t = el('strong'); t.id = 'fspd-scheme-text'; t.textContent = MONO.scheme.label; l.appendChild(t);
    }
    box.appendChild(l);
  }
  function syncModeUI() {
    if ($('fspd-cw')) { $('fspd-cw').value = CUSTOM_SIZE.w; $('fspd-ch').value = CUSTOM_SIZE.h; }
    if ($('fspd-material')) { $('fspd-material').value = MONO.material[0]; }
    if ($('fspd-scheme')) { $('fspd-scheme').value = MONO.scheme.label; }
    if ($('fspd-scheme-text')) { $('fspd-scheme-text').textContent = MONO.scheme.label; }
  }
  // Quantity-tier products ("1-9 pcs", "10-24 pcs"...): the quantity box and the tier always agree.
  var QTY_OPT = OPTION_NAMES.reduce(function (a, n, i) { return a < 0 && /quantity|qty/i.test(n) ? i : a; }, -1);
  function tierRange(t) { var m = /(\d+)\s*-\s*(\d+)/.exec(t || '') || /(\d+)\s*\+/.exec(t || ''); return m ? { lo: +m[1], hi: m[2] ? +m[2] : 1e6 } : null; }
  function qtyTierSync(v) {
    if (QTY_OPT < 0 || !v) { return; }
    var r = tierRange(optVal(v, QTY_OPT)), q = $('fspd-qty'); if (!r || !q) { return; }
    var n = parseInt(q.value, 10) || 1;
    if (n < r.lo || n > r.hi) { q.value = r.lo; }
    q.min = r.lo; q.max = r.hi;
  }
  function tierForQty() {
    if (QTY_OPT < 0 || !OPT_SELECTS) { return; }
    var n = parseInt($('fspd-qty').value, 10) || 1, v = state.variant;
    var r = tierRange(optVal(v, QTY_OPT)); if (r && n >= r.lo && n <= r.hi) { return; }
    var want = VARIANTS.filter(function (x) {
      var t = tierRange(optVal(x, QTY_OPT));
      return t && n >= t.lo && n <= t.hi && OPTION_NAMES.every(function (nm, i) { return i === QTY_OPT || optVal(x, i) === optVal(v, i); });
    })[0];
    if (want) { setSize(want.id); $('fspd-qty').value = n; status('Price updated for ' + n + ' pieces.'); }
  }
  // extra order details for this kind of product
  function overallDims() {
    var objs = canvas.getObjects(); if (!objs.length) { return ''; }
    var b = objs.reduce(function (a, o) { var r = o.getBoundingRect(true, true); return { l: Math.min(a.l, r.left), t: Math.min(a.t, r.top), r: Math.max(a.r, r.left + r.width), b: Math.max(a.b, r.top + r.height) }; }, { l: 1e9, t: 1e9, r: -1e9, b: -1e9 });
    var r1 = function (x) { return Math.round(x / state.ppi * 10) / 10; };
    return r1(b.r - b.l) + '"W x ' + r1(b.b - b.t) + '"H';
  }
  function modeCartProps(qty) {
    if (KIND === 'cnc') {
      var p = {
        'What are we making': 'CNC cut letters / shapes (designed online)',
        'Size or dimensions': 'Overall ' + overallDims() + ' (work area ' + CUSTOM_SIZE.w + '"W x ' + CUSTOM_SIZE.h + '"H)',
        'Quantity': qty + (qty > 1 ? ' sets' : ' set'),
        'Material': MONO.material[0]
      };
      [['Phone', 'fspd-q-phone'], ['Needed by', 'fspd-q-date'], ['Install or ship', 'fspd-q-ship'], ['Notes', 'fspd-q-notes']].forEach(function (f) { var e = $(f[1]); if (e && e.value.trim()) { p[f[0]] = e.value.trim().slice(0, 1000); } });
      return p;
    }
    if (MONO.on) { return { 'Colors': MONO.scheme.label }; }
    return {};
  }
  function initMode() {
    root.classList.add('kind-' + KIND);
    if (MONO.on) { root.classList.add('is-mono'); }
    if (PROFILE.noQr) { root.classList.add('no-qr'); }
    if (PROFILE.noPhotos) { var un = $('fspd-upload-note'); if (un) { un.hidden = false; un.textContent = KIND === 'cnc' ? 'For cutting, a logo file (SVG, PDF, AI or EPS) works best. Photos can’t be cut as they are.' : 'For ' + (KIND === 'plaque' ? 'cast plaques' : 'engraving') + ', a logo file (SVG, PDF, AI or EPS) works best. Photos can’t be ' + (KIND === 'plaque' ? 'cast' : 'engraved') + '.'; } }
    if (PROFILE.quote) {
      var qf = $('fspd-quote'); if (qf) { qf.hidden = false; }
      $('fspd-cart').textContent = 'Send for a free quote';
      var ql = root.querySelector('.fspd-qty-label'); if (ql) { ql.textContent = 'How many sets?'; }
    }
    if (KIND === 'cnc') {
      var mat = new URLSearchParams(location.search).get('material');
      var pre = MATERIALS.filter(function (x) { return x[2] && x[2] === mat; })[0]; if (pre) { MONO.material = pre; syncModeUI(); }
    }
    var lead = root.querySelector('[data-step="1"] .fspd-lead');
    if (lead && KIND !== 'sign') { lead.textContent = KIND === 'cnc' ? 'Click a design to start, or start blank and add your own letters and shapes. Each letter or shape is cut out as its own piece.' : 'Click a design to put it on your ' + PROFILE.noun + '. You can change the words next.'; }
    var sub = root.querySelector('.fspd-sub');
    if (sub && KIND !== 'sign' && KIND !== 'banner') { sub.textContent = KIND === 'cnc' ? 'Design custom CNC-cut letters and shapes. We review it and send you a free quote.' : 'Make your ' + PROFILE.noun + ' in 4 easy steps. No design experience needed.'; }
    var blank = $('fspd-blank'); if (blank && KIND !== 'sign') { blank.textContent = KIND === 'cnc' ? 'Start blank instead' : 'Start with a blank ' + PROFILE.noun + ' instead'; }
    var pe2 = root.querySelector('.fspd-props-empty'); if (pe2 && KIND !== 'sign' && KIND !== 'banner') { pe2.innerHTML = '&#128161; Click (or tap) any words or shape on your ' + PROFILE.noun + '. Buttons to change its size' + (MONO.on ? '' : ', color') + ' and font will show up here.'; }
    var redKey = $('fspd-key-red'); if (redKey && KIND === 'cnc') { redKey.textContent = 'The edge of your work area'; }
    if (redKey && (KIND === 'engrave' || KIND === 'plate' || KIND === 'plaque')) { redKey.textContent = 'The edge of the ' + PROFILE.noun + ' is the red line'; }
    if (KIND === 'aframe') { var tb = root.querySelectorAll('.fspd-tab[data-side]'); if (tb[0]) { tb[0].textContent = 'Panel 1 (front)'; } if (tb[1]) { tb[1].textContent = 'Panel 2 (back)'; } }
  }
  $('fspd-qty').addEventListener('change', tierForQty);
  $('fspd-qty-minus').addEventListener('click', tierForQty);
  $('fspd-qty-plus').addEventListener('click', tierForQty);
  initMode();
  buildSchemeSelect();
  window.FSPD.KIND = KIND; window.FSPD.MONO = MONO; window.FSPD.CUSTOM_SIZE = CUSTOM_SIZE; window.FSPD.applyMono = applyMono; window.FSPD.modeCartProps = modeCartProps; window.FSPD.overallDims = overallDims; window.FSPD.PROFILE = PROFILE;
  var _onSide = window.FSPD.onSide;
  window.FSPD.onSide = function () { if (MONO.on) { applyMono(true); } _onSide(); };

  // start: a reorder link wins, then a saved draft, then a blank sign
  var params = new URLSearchParams(location.search), wanted = params.get('variant'), designUrl = params.get('design');
  var savedId = /^\d{1,20}$/.test(params.get('saved') || '') ? params.get('saved') : null, resumeSave = params.get('fspd_save');
  var first = VARIANTS.filter(function (v) { return String(v.id) === wanted; })[0] || VARIANTS.filter(function (v) { return v.available; })[0] || VARIANTS[0];
  var draft = readDraft();
  // ?saved=<id> opens the copy in the account, unless this browser holds newer unsaved changes to that same design
  var draftIsSaved = draft && draft.saved && savedId && String(draft.saved.id) === savedId && draft.dirty;
  if (draft && !designUrl && (!savedId || draftIsSaved)) {
    if (draftIsSaved) { savedId = null; }
    state.sides = draft.sides || [null, null];
    if (draft.saved) { SAVE.saved = draft.saved; SAVE.links = draft.links || {}; SAVE.dirty = !!draft.dirty; }
    restoreMode(draft.mode);
    if (draft.variant && VARIANTS.some(function (v) { return String(v.id) === String(draft.variant); }) && !wanted) { first = VARIANTS.filter(function (v) { return String(v.id) === String(draft.variant); })[0]; }
    if (sideHasContent(state.sides[0]) || sideHasContent(state.sides[1])) { $('fspd-draft').hidden = false; }
  }
  setSize(first.id);
  riderInit(draft);
  if (!sideHasContent(state.sides[0])) { $('fspd-sec-tpl').open = true; }
  // where to start: a sign already in progress opens at Step 2 (Your words); a new one at Step 1
  var hasWork = sideHasContent(state.sides[0]) || sideHasContent(state.sides[1]) || savedId || designUrl;
  if (store('fspd:all') === '1') { setAll(true); }
  goStep(hasWork ? 2 : 1, true);
  setTimeout(stickyCheck, 300);
  status('Loading fonts…');
  $('fspd-add-text').disabled = true;
  window.FSPD.ready = ensureFont(DEFAULT_FONT).then(function () {
    $('fspd-add-text').disabled = false;
    status('');
    canvas.getObjects().forEach(function (o) { if (isText(o)) { o.initDimensions(); } });
    canvas.requestRenderAll();
    var saving = initSaving(designUrl ? null : savedId, resumeSave);
    stickyCheck();
    // first visit: a short walkthrough (skippable; replay any time from Help or "Show me how")
    if (!hasWork && !resumeSave && !window.FSPD_NO_TOUR && store('fspd:tour') !== 'done') { setTimeout(function () { if (!TOUR.on && $('fspd-help').hidden) { startTour(); } }, 900); }
    if (designUrl) {
      status('Opening your saved design…');
      return loadDesignFrom(designUrl).then(function (rec) { applyRecord(rec); status('Your design is open. Change anything you need, then add it to your cart.'); },
        function (e) { status('We couldn’t open that saved design (' + e.message + '). Please call us and we’ll help.', true); });
    }
    return saving;
  }, function (e) {
    status('Fonts didn’t load (' + e.message + '). Please refresh the page.', true);
    throw e;
  });
})();
